export const Analytics = () => {
  return (
    <>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='52'
        height='52'
        viewBox='0 0 52 52'
        fill='none'>
        <rect
          opacity='0.3'
          x='27.5'
          y='14'
          width='4.5'
          height='24'
          rx='2'
          fill='#8D99A5'
        />
        <rect x='20' y='21.5' width='4.5' height='16.5' rx='2' fill='#8D99A5' />
        <rect x='35' y='24.5' width='4.5' height='13.5' rx='2' fill='#8D99A5' />
        <rect
          x='12.5'
          y='27.5'
          width='4.5'
          height='10.5'
          rx='2'
          fill='#8D99A5'
        />
      </svg>
    </>
  );
};

export const AssetManagement = () => {
  return (
    <>
      {" "}
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='52'
        height='52'
        viewBox='0 0 52 52'
        fill='none'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M12.582 35.6253C12.582 36.4538 13.2536 37.1253 14.082 37.1253H36.9154C37.7438 37.1253 38.4154 36.4538 38.4154 35.6253V20.542C38.4154 19.7136 37.7438 19.042 36.9154 19.042H22.9154L19.4797 15.6063C19.1984 15.325 18.8169 15.167 18.419 15.167H14.082C13.2536 15.167 12.582 15.8386 12.582 16.667V35.6253Z'
          fill='#D4D9DD'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M15.168 34.5413L22.918 24.208L30.668 34.5413H15.168Z'
          fill='#A2A7AC'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M24.207 34.5413L29.3737 28.083L34.5404 34.5413H24.207Z'
          fill='#F3F6F9'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M33.25 25.5C34.3201 25.5 35.1875 24.6326 35.1875 23.5625C35.1875 22.4924 34.3201 21.625 33.25 21.625C32.1799 21.625 31.3125 22.4924 31.3125 23.5625C31.3125 24.6326 32.1799 25.5 33.25 25.5Z'
          fill='#A2A7AC'
        />
      </svg>{" "}
    </>
  );
};

export const ToolsAndPortal = () => {
  return (
    <>
      {" "}
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='52'
        height='52'
        viewBox='0 0 52 52'
        fill='none'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M16.168 13.875C15.6157 13.875 15.168 14.3227 15.168 14.875V36.125C15.168 36.6773 15.6157 37.125 16.168 37.125H18.043C18.5953 37.125 19.043 36.6773 19.043 36.125V14.875C19.043 14.3227 18.5953 13.875 18.043 13.875H16.168ZM22.6263 13.875C22.074 13.875 21.6263 14.3227 21.6263 14.875V36.125C21.6263 36.6773 22.074 37.125 22.6263 37.125H24.5013C25.0536 37.125 25.5013 36.6773 25.5013 36.125V14.875C25.5013 14.3227 25.0536 13.875 24.5013 13.875H22.6263Z'
          fill='#8D99A5'
        />
        <rect
          opacity='0.3'
          x='27.4062'
          y='15.0684'
          width='3.875'
          height='23.25'
          rx='1'
          transform='rotate(-19 27.4062 15.0684)'
          fill='#8D99A5'
        />
      </svg>
    </>
  );
};

export const Contacts = () => {
  return (
    <>
      {" "}
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='52'
        height='52'
        viewBox='0 0 52 52'
        fill='none'>
        <path
          opacity='0.3'
          fillRule='evenodd'
          clipRule='evenodd'
          d='M16.457 19.0417C16.457 21.8951 18.7702 24.2083 21.6237 24.2083C24.4772 24.2083 26.7904 21.8951 26.7904 19.0417C26.7904 16.1882 24.4772 13.875 21.6237 13.875C18.7702 13.875 16.457 16.1882 16.457 19.0417ZM29.3737 24.2083C29.3737 26.3484 31.1086 28.0833 33.2487 28.0833C35.3888 28.0833 37.1237 26.3484 37.1237 24.2083C37.1237 22.0682 35.3888 20.3333 33.2487 20.3333C31.1086 20.3333 29.3737 22.0682 29.3737 24.2083Z'
          fill='#70808F'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M21.6035 26.792C15.505 26.792 10.5015 29.9262 10.0008 36.091C9.97357 36.4268 10.6158 37.1253 10.9397 37.1253H32.277C33.2473 37.1253 33.2624 36.3445 33.2473 36.092C32.8688 29.754 27.7878 26.792 21.6035 26.792ZM40.2973 37.1253L35.3166 37.1253C35.3166 34.2179 34.356 31.5348 32.7349 29.3761C37.1349 29.4242 40.7277 31.6488 40.9981 36.3503C41.009 36.5397 40.9981 37.1253 40.2973 37.1253Z'
          fill='#70808F'
        />
      </svg>
    </>
  );
};

export const PRPlanning = () => {
  return (
    <>
      {" "}
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='52'
        height='52'
        viewBox='0 0 52 52'
        fill='none'>
        <path
          d='M16.3574 17.3262H10.9082C10.4062 17.3262 10 16.92 10 16.418C10 15.916 10.4062 15.5098 10.9082 15.5098H16.3574C16.8585 15.5098 17.2656 15.1026 17.2656 14.6016C17.2656 14.1005 16.8585 13.6934 16.3574 13.6934C15.8554 13.6934 15.4492 13.2872 15.4492 12.7852C15.4492 12.2832 15.8554 11.877 16.3574 11.877C17.8598 11.877 19.082 13.0992 19.082 14.6016C19.082 16.104 17.8598 17.3262 16.3574 17.3262Z'
          fill='#E2E5E9'
        />
        <path
          d='M38.2754 41H32.8262C32.3242 41 31.918 40.5938 31.918 40.0918C31.918 39.5898 32.3242 39.1836 32.8262 39.1836H38.2754C38.7765 39.1836 39.1836 38.7765 39.1836 38.2754C39.1836 37.7743 38.7765 37.3672 38.2754 37.3672C37.7734 37.3672 37.3672 36.961 37.3672 36.459C37.3672 35.957 37.7734 35.5508 38.2754 35.5508C39.7778 35.5508 41 36.773 41 38.2754C41 39.7778 39.7778 41 38.2754 41Z'
          fill='#E2E5E9'
        />
        <path
          d='M14.541 20.959H10.9082C10.4062 20.959 10 20.5528 10 20.0508C10 19.5488 10.4062 19.1426 10.9082 19.1426H14.541C15.043 19.1426 15.4492 19.5488 15.4492 20.0508C15.4492 20.5528 15.043 20.959 14.541 20.959Z'
          fill='#E2E5E9'
        />
        <path
          d='M16.3574 24.5918H12.7246C12.2226 24.5918 11.8164 24.1856 11.8164 23.6836C11.8164 23.1816 12.2226 22.7754 12.7246 22.7754H16.3574C16.8594 22.7754 17.2656 23.1816 17.2656 23.6836C17.2656 24.1856 16.8594 24.5918 16.3574 24.5918Z'
          fill='#E2E5E9'
        />
        <path
          d='M34.6426 37.3672H31.0098C30.5078 37.3672 30.1016 36.961 30.1016 36.459C30.1016 35.957 30.5078 35.5508 31.0098 35.5508H34.6426C35.1446 35.5508 35.5508 35.957 35.5508 36.459C35.5508 36.961 35.1446 37.3672 34.6426 37.3672Z'
          fill='#E2E5E9'
        />
        <path
          d='M29.5504 34.3886L33.3261 31.996L33.2404 30.0023L31.3771 31.2086L27.6016 33.6012L27.7789 35.632L29.5504 34.3886Z'
          fill='#70808F'
        />
        <path
          d='M23.0764 31.7738L22.0233 27.4302L21.7096 25.3444L20.0742 26.6427L21.1271 30.9862L21.4251 33.0657L23.0764 31.7738Z'
          fill='#E2E5E9'
        />
        <path
          d='M27.3802 27.635L26.5382 27.2948L23.8164 34.0314L24.6584 34.3716L25.5005 34.7118L28.2223 27.9752L27.3802 27.635Z'
          fill='#E2E5E9'
        />
        <path
          d='M24.6602 34.3823L27.3848 27.6471L28.2267 27.9877L25.5021 34.7229L24.6602 34.3823Z'
          fill='#70808F'
        />
        <path
          d='M19.9983 16.816C18.406 20.7636 19.8416 23.6666 20.077 26.643L22.026 27.4304L24.3756 28.3797L34.1858 10.7937C28.6143 8.54271 22.2511 11.2444 19.9983 16.816Z'
          fill='#70808F'
        />
        <path
          d='M34.1828 10.7938L29.0234 30.259L31.3742 31.2087L33.3231 31.9961C35.575 30.0055 38.6094 28.9275 40.2049 24.9818C42.4558 19.4093 39.7535 13.0448 34.1828 10.7938Z'
          fill='#A9B2BC'
        />
        <path
          d='M34.1838 10.7936C31.8585 9.85408 28.1456 13.6166 25.8908 19.1974C24.47 22.7141 23.9693 26.111 24.3735 28.3796L26.699 29.3192L29.0245 30.2587C30.8912 28.9076 32.8907 26.1163 34.3116 22.5996C36.5663 17.0188 36.5092 11.7331 34.1838 10.7936Z'
          fill='#70808F'
        />
        <path
          d='M34.3118 22.5998C36.5665 17.019 36.5094 11.7333 34.184 10.7938L26.6992 29.3194L29.0247 30.259C30.8914 28.9078 32.8909 26.1165 34.3118 22.5998Z'
          fill='#70808F'
        />
        <path
          d='M25.338 32.6875L21.1276 30.9865L18.746 36.8809C18.5582 37.3459 18.7829 37.8754 19.2479 38.0632L22.6162 39.4241L25.9845 40.785C26.4495 40.9728 26.9789 40.7481 27.1668 40.2831L29.5483 34.3886L25.338 32.6875Z'
          fill='#55696E'
        />
        <path
          d='M27.1678 40.2831L29.5493 34.3887L25.339 32.6876L22.6172 39.4242L25.9855 40.785C26.4505 40.9728 26.9799 40.7481 27.1678 40.2831Z'
          fill='#3F4A4A'
        />
      </svg>
    </>
  );
};

export const Dashboard = () => {
  return (
    <>
      {" "}
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='52'
        height='52'
        viewBox='0 0 52 52'
        fill='none'>
        <rect
          x='15.9414'
          y='15.1666'
          width='8.39583'
          height='9.04167'
          rx='1.5'
          fill='#70808F'
        />
        <path
          opacity='0.3'
          fillRule='evenodd'
          clipRule='evenodd'
          d='M26.736 16.6666C26.736 15.8382 27.4076 15.1666 28.236 15.1666H33.6319C34.4603 15.1666 35.1319 15.8382 35.1319 16.6666V22.7083C35.1319 23.5367 34.4603 24.2083 33.6319 24.2083H28.236C27.4076 24.2083 26.736 23.5367 26.736 22.7083V16.6666ZM15.9414 28.2916C15.9414 27.4632 16.613 26.7916 17.4414 26.7916H22.8372C23.6657 26.7916 24.3372 27.4632 24.3372 28.2916V34.3333C24.3372 35.1617 23.6657 35.8333 22.8372 35.8333H17.4414C16.613 35.8333 15.9414 35.1617 15.9414 34.3333V28.2916ZM28.236 26.7916C27.4076 26.7916 26.736 27.4632 26.736 28.2916V34.3333C26.736 35.1617 27.4076 35.8333 28.236 35.8333H33.6319C34.4603 35.8333 35.1319 35.1617 35.1319 34.3333V28.2916C35.1319 27.4632 34.4603 26.7916 33.6319 26.7916H28.236Z'
          fill='#70808F'
        />
      </svg>
    </>
  );
};

export const ThumbsUp = () => {
  return (
    <>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='20'
        height='18'
        viewBox='0 0 20 18'
        fill='none'>
        <path
          d='M11.11 3.72L10.54 6.61C10.42 7.2 10.58 7.81 10.96 8.27C11.34 8.73 11.9 9 12.5 9H18V10.08L15.43 16H7.34C7.16 16 7 15.84 7 15.66V7.82L11.11 3.72ZM12 0L5.59 6.41C5.21 6.79 5 7.3 5 7.83V15.66C5 16.95 6.05 18 7.34 18H15.44C16.15 18 16.8 17.63 17.16 17.03L19.83 10.88C19.94 10.63 20 10.36 20 10.08V9C20 7.9 19.1 7 18 7H12.5L13.42 2.35C13.47 2.13 13.44 1.89 13.34 1.69C13.11 1.24 12.82 0.83 12.46 0.47L12 0ZM2 7H0V18H2C2.55 18 3 17.55 3 17V8C3 7.45 2.55 7 2 7Z'
          fill='#3699FF'
        />
      </svg>
    </>
  );
};

export const ViewEye = () => {
  return (
    <>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='16'
        viewBox='0 0 24 16'
        fill='none'>
        <path
          d='M11.7333 0C6.4 0 1.84533 3.31733 0 8C1.84533 12.6827 6.4 16 11.7333 16C17.0667 16 21.6213 12.6827 23.4667 8C21.6213 3.31733 17.0667 0 11.7333 0ZM11.7333 13.3333C8.78933 13.3333 6.4 10.944 6.4 8C6.4 5.056 8.78933 2.66667 11.7333 2.66667C14.6773 2.66667 17.0667 5.056 17.0667 8C17.0667 10.944 14.6773 13.3333 11.7333 13.3333Z'
          fill='#BADAFB'
        />
        <path
          d='M11.7333 0C6.4 0 1.84533 3.31733 0 8C1.84533 12.6827 6.4 16 11.7333 16C17.0667 16 21.6213 12.6827 23.4667 8C21.6213 3.31733 17.0667 0 11.7333 0ZM11.7333 13.3333C8.78933 13.3333 6.4 10.944 6.4 8C6.4 5.056 8.78933 2.66667 11.7333 2.66667C14.6773 2.66667 17.0667 5.056 17.0667 8C17.0667 10.944 14.6773 13.3333 11.7333 13.3333Z'
          fill='#BADAFB'
        />
        <path
          d='M11.7352 4.80078C9.96449 4.80078 8.53515 6.23012 8.53515 8.00078C8.53515 9.77145 9.96449 11.2008 11.7352 11.2008C13.5058 11.2008 14.9352 9.77145 14.9352 8.00078C14.9352 6.23012 13.5058 4.80078 11.7352 4.80078Z'
          fill='#4EA5FE'
        />
      </svg>
    </>
  );
};

export const EditIcon = () => {
  return (
    <>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='40'
        height='40'
        viewBox='0 0 40 40'
        fill='none'>
        <path
          d='M27.9321 13.9924C28.5096 14.5698 28.519 15.503 27.9534 16.092L20.8203 23.5203C20.545 23.807 20.1672 23.9727 19.7698 23.9811L16.7705 24.044L16.8338 21.0295C16.8419 20.6411 17.0004 20.2711 17.2758 19.9972L24.5696 12.7451C25.1559 12.1622 26.1033 12.1635 26.6879 12.7481L27.9321 13.9924Z'
          fill='#3699FF'
        />
        <path
          opacity='0.3'
          d='M20.7513 11.667C21.2115 11.667 21.5846 12.0401 21.5846 12.5003C21.5846 12.9606 21.2115 13.3337 20.7513 13.3337H15.0013C14.0808 13.3337 13.3346 14.0799 13.3346 15.0003V25.0003C13.3346 25.9208 14.0808 26.667 15.0013 26.667H25.0013C25.9218 26.667 26.668 25.9208 26.668 25.0003V20.8337C26.668 20.3734 27.0411 20.0003 27.5013 20.0003C27.9615 20.0003 28.3346 20.3734 28.3346 20.8337V25.0003C28.3346 26.8413 26.8423 28.3337 25.0013 28.3337H15.0013C13.1604 28.3337 11.668 26.8413 11.668 25.0003V15.0003C11.668 13.1594 13.1604 11.667 15.0013 11.667H20.7513Z'
          fill='#3699FF'
        />
      </svg>
    </>
  );
};

export const EditIconSmall = () => {
  return (
    <>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'>
        <path
          d='M14.6844 2.44506C15.2516 3.03242 15.2609 3.98172 14.7053 4.58088L8.3404 11.444C8.06994 11.7356 7.69876 11.9042 7.30836 11.9127L4.63297 11.9708L4.68942 9.18512C4.69742 8.79008 4.85311 8.41367 5.12371 8.13508L11.6312 1.43552C12.2072 0.842544 13.138 0.843925 13.7123 1.43861L14.6844 2.44506Z'
          fill='#3699FF'
        />
        <path
          d='M8.24322 0.339844C8.66089 0.339844 8.99948 0.690426 8.99948 1.12289C8.99948 1.55536 8.66089 1.90594 8.24322 1.90594H3.02504C2.18969 1.90594 1.51252 2.60711 1.51252 3.47204V12.8686C1.51252 13.7336 2.18969 14.4347 3.02504 14.4347H12.1001C12.9355 14.4347 13.6127 13.7336 13.6127 12.8686V8.95338C13.6127 8.52091 13.9512 8.17033 14.3689 8.17033C14.7866 8.17033 15.1252 8.52091 15.1252 8.95338V12.8686C15.1252 14.5985 13.7708 16.0008 12.1001 16.0008H3.02504C1.35435 16.0008 0 14.5985 0 12.8686V3.47204C0 1.74217 1.35435 0.339844 3.02504 0.339844H8.24322Z'
          fill='#3699FF'
        />
      </svg>
    </>
  );
};

export const Trash = () => {
  return (
    <>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'>
        <path
          d='M4.5 6V15C4.5 15.8284 5.17157 16.5 6 16.5H12C12.8284 16.5 13.5 15.8284 13.5 15V6H4.5Z'
          fill='#3699FF'
        />
        <path
          opacity='0.3'
          fillRule='evenodd'
          clipRule='evenodd'
          d='M10.5 3.375V3.25C10.5 2.69772 10.0523 2.25 9.5 2.25H8.5C7.94772 2.25 7.5 2.69772 7.5 3.25V3.375H4.25C3.97386 3.375 3.75 3.59886 3.75 3.875V4C3.75 4.27614 3.97386 4.5 4.25 4.5H13.75C14.0261 4.5 14.25 4.27614 14.25 4V3.875C14.25 3.59886 14.0261 3.375 13.75 3.375H10.5Z'
          fill='#3699FF'
        />
      </svg>
    </>
  );
};

export const ProductInventory = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='52'
      height='51'
      viewBox='0 0 52 51'
      fill='none'>
      <path
        opacity='0.3'
        d='M26 14.4656L19.6524 21.8891C19.122 22.5094 18.1762 22.5932 17.5398 22.0763C16.9033 21.5594 16.8174 20.6376 17.3477 20.0174L24.8477 11.2462C25.4474 10.5449 26.5527 10.5449 27.1524 11.2462L34.6524 20.0174C35.1827 20.6376 35.0967 21.5594 34.4603 22.0763C33.8239 22.5932 32.8781 22.5094 32.3477 21.8891L26 14.4656Z'
        fill='#8D99A5'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M14.7784 20.9536C14.0573 20.9536 13.5732 21.6938 13.8623 22.3544L19.2143 34.5869C19.692 35.6788 20.7708 36.3844 21.9627 36.3844H30.0385C31.2305 36.3844 32.3094 35.6787 32.7871 34.5867L38.1378 22.3544C38.4268 21.6937 37.9428 20.9536 37.2217 20.9536H14.7784ZM29.0007 29.7248C29.0007 31.3396 27.6576 32.6486 26.0007 32.6486C24.3439 32.6486 23.0007 31.3396 23.0007 29.7248C23.0007 28.1101 24.3439 26.8011 26.0007 26.8011C27.6576 26.8011 29.0007 28.1101 29.0007 29.7248Z'
        fill='#8D99A5'
      />
    </svg>
  );
};

export const Help = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='33'
      height='32'
      viewBox='0 0 33 32'
      fill='none'>
      <path
        opacity='0.4'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M20.7775 24.2436C24.803 22.2983 27.5549 18.3687 27.5549 13.8379C27.5549 7.37364 21.9532 2.1333 15.0431 2.1333C8.13299 2.1333 2.53125 7.37364 2.53125 13.8379C2.53125 20.3022 8.13299 25.5426 15.0431 25.5426C15.1782 25.5426 15.3127 25.5406 15.4468 25.5366V27.6354C15.4468 28.4488 16.3608 28.9132 16.969 28.3732C17.4849 27.9152 18.1322 27.2968 19.0793 26.3498C19.9385 25.4905 20.4319 24.8508 20.7775 24.2436Z'
        fill='#70808F'
      />
      <path
        d='M14.7824 15.1318C14.7824 14.4824 14.863 13.9648 15.0241 13.5791C15.1853 13.1934 15.5026 12.771 15.9763 12.312C16.4548 11.8481 16.7575 11.5186 16.8845 11.3232C17.0798 11.0254 17.1774 10.7031 17.1774 10.3564C17.1774 9.89746 17.0627 9.54834 16.8332 9.30908C16.6086 9.06494 16.2766 8.94287 15.8371 8.94287C15.4172 8.94287 15.0778 9.0625 14.819 9.30176C14.5651 9.53613 14.4382 9.85596 14.4382 10.2612H12.6584C12.6682 9.39697 12.9611 8.71338 13.5373 8.21045C14.1184 7.70752 14.885 7.45605 15.8371 7.45605C16.8186 7.45605 17.5827 7.70508 18.1296 8.20312C18.6813 8.70117 18.9572 9.39697 18.9572 10.2905C18.9572 11.0864 18.5861 11.8701 17.8439 12.6416L16.9431 13.5278C16.6208 13.894 16.4548 14.4287 16.445 15.1318H14.7824ZM14.6579 17.4097C14.6579 17.1216 14.7482 16.8896 14.9289 16.7139C15.1096 16.5332 15.3537 16.4429 15.6613 16.4429C15.9738 16.4429 16.2204 16.5356 16.4011 16.7212C16.5817 16.9019 16.6721 17.1313 16.6721 17.4097C16.6721 17.6782 16.5842 17.9028 16.4084 18.0835C16.2326 18.2642 15.9836 18.3545 15.6613 18.3545C15.3391 18.3545 15.09 18.2642 14.9143 18.0835C14.7434 17.9028 14.6579 17.6782 14.6579 17.4097Z'
        fill='#70808F'
      />
    </svg>
  );
};

export const Notification = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='34'
      height='32'
      viewBox='0 0 34 32'
      fill='none'>
      <path
        d='M16.5086 29.2793C18.0072 29.2793 19.2334 28.0793 19.2334 26.6126H13.7838C13.7838 28.0793 14.9963 29.2793 16.5086 29.2793ZM24.6829 21.2793V14.6126C24.6829 10.5193 22.4486 7.09263 18.5522 6.18596V5.2793C18.5522 4.17263 17.6393 3.2793 16.5086 3.2793C15.3778 3.2793 14.465 4.17263 14.465 5.2793V6.18596C10.5549 7.09263 8.33417 10.506 8.33417 14.6126V21.2793L5.60938 23.946V25.2793H27.4077V23.946L24.6829 21.2793Z'
        fill='#A9B3BC'
      />
    </svg>
  );
};

export const OFishNavIcon = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M12 2C6.4898 2 2 6.4898 2 12C2 17.5102 6.4898 22 12 22C16.9854 22 21.1254 18.3557 21.8834 13.5743C21.9708 13.0496 22 12.5248 22 12C22 6.4898 17.5394 2 12 2ZM15.1195 18.1808C12.7289 18.1808 10.7755 16.2274 10.7755 13.8367C10.7755 13.3411 10.863 12.8746 11.0087 12.4373C11.5918 10.7172 13.2245 9.49271 15.1195 9.49271C17.5102 9.49271 19.4636 11.4461 19.4636 13.8367C19.4636 13.9242 19.4636 13.9825 19.4636 14.07C19.3469 16.3732 17.4519 18.1808 15.1195 18.1808Z'
        fill='#3699FF'
      />
    </svg>
  );
};

export const PaymentProcessorIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'>
      <path
        d='M21 8V6H7V8H21ZM21 16V11H7V16H21ZM21 4C21.5304 4 22.0391 4.21071 22.4142 4.58579C22.7893 4.96086 23 5.46957 23 6V16C23 16.5304 22.7893 17.0391 22.4142 17.4142C22.0391 17.7893 21.5304 18 21 18H7C5.89 18 5 17.1 5 16V6C5 4.89 5.89 4 7 4H21ZM3 20H18V22H3C2.46957 22 1.96086 21.7893 1.58579 21.4142C1.21071 21.0391 1 20.5304 1 20V9H3V20Z'
        fill='#70808F'
      />
    </svg>
  );
};

export const DynamicIntegrationIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'>
      <path
        d='M19.0002 3C18.5353 3.00271 18.0774 3.11343 17.6626 3.32342C17.2479 3.53341 16.8876 3.83692 16.6102 4.21C15.6693 4.02094 14.7085 3.9504 13.7502 4L13.8802 6C14.5895 5.9637 15.3006 6.00731 16.0002 6.13C16.0256 6.71714 16.223 7.28386 16.5677 7.75981C16.9125 8.23577 17.3894 8.59998 17.9394 8.80724C18.4893 9.0145 19.088 9.05568 19.6611 8.92565C20.2342 8.79563 20.7565 8.50014 21.1632 8.07586C21.5698 7.65159 21.8429 7.11722 21.9485 6.5391C22.0541 5.96098 21.9876 5.36457 21.7572 4.82392C21.5268 4.28328 21.1427 3.82221 20.6526 3.49796C20.1625 3.1737 19.5879 3.00055 19.0002 3ZM19.0002 7C18.8024 7 18.6091 6.94135 18.4446 6.83147C18.2802 6.72159 18.152 6.56541 18.0763 6.38268C18.0006 6.19996 17.9808 5.99889 18.0194 5.80491C18.058 5.61093 18.1532 5.43275 18.2931 5.29289C18.4329 5.15304 18.6111 5.0578 18.8051 5.01921C18.9991 4.98063 19.2001 5.00043 19.3829 5.07612C19.5656 5.15181 19.7218 5.27998 19.8316 5.44443C19.9415 5.60888 20.0002 5.80222 20.0002 6C20.0002 6.26522 19.8948 6.51957 19.7073 6.70711C19.5198 6.89464 19.2654 7 19.0002 7ZM8.86018 7.86L7.67018 6.25C8.84843 5.37866 10.1824 4.74054 11.6002 4.37L12.1002 6.31C10.9314 6.61595 9.8318 7.14202 8.86018 7.86ZM21.0002 18C21.004 18.4825 20.8915 18.9588 20.672 19.3885C20.4525 19.8182 20.1327 20.1887 19.7395 20.4684C19.3464 20.7481 18.8916 20.9289 18.4137 20.9954C17.9358 21.0619 17.4489 21.0121 16.9943 20.8503C16.5397 20.6885 16.1309 20.4195 15.8025 20.066C15.474 19.7125 15.2357 19.285 15.1077 18.8198C14.9798 18.3546 14.9659 17.8653 15.0673 17.3936C15.1687 16.9219 15.3823 16.4815 15.6902 16.11C14.753 15.2032 13.6386 14.4998 12.4168 14.0438C11.1951 13.5878 9.89232 13.3891 8.59018 13.46C8.37018 13.47 8.16018 13.5 7.94018 13.54C7.84207 14.0757 7.6 14.5746 7.23991 14.9832C6.87982 15.3917 6.4153 15.6946 5.89618 15.8592C5.37706 16.0238 4.82291 16.0441 4.29317 15.9177C3.76343 15.7913 3.27807 15.5232 2.88916 15.1419C2.50026 14.7607 2.22246 14.2808 2.08557 13.7536C1.94868 13.2265 1.95787 12.6721 2.11213 12.1498C2.2664 11.6275 2.55994 11.157 2.96126 10.7889C3.36258 10.4207 3.85654 10.1688 4.39018 10.06C4.83949 9.20753 5.3938 8.41469 6.04018 7.7L7.50018 9.06C7.12697 9.47905 6.79228 9.93087 6.50018 10.41C6.96981 10.6861 7.35663 11.0832 7.62018 11.56C7.91018 11.5 8.19018 11.5 8.50018 11.46C10.1648 11.3713 11.8288 11.6466 13.3762 12.2666C14.9236 12.8866 16.3173 13.8364 17.4602 15.05C17.6383 15.0168 17.819 15.0001 18.0002 15C18.7958 15 19.5589 15.3161 20.1215 15.8787C20.6841 16.4413 21.0002 17.2044 21.0002 18Z'
        fill='#70808F'
      />
    </svg>
  );
};

export const ShippingProvidersIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'>
      <path
        d='M20 8H17V4H3C1.9 4 1 4.9 1 6V17H3C3 18.7 4.3 20 6 20C7.7 20 9 18.7 9 17H15C15 18.7 16.3 20 18 20C19.7 20 21 18.7 21 17H23V12L20 8ZM6 18.5C5.2 18.5 4.5 17.8 4.5 17C4.5 16.2 5.2 15.5 6 15.5C6.8 15.5 7.5 16.2 7.5 17C7.5 17.8 6.8 18.5 6 18.5ZM15 15H8.2C7.7 14.4 6.9 14 6 14C5.1 14 4.3 14.4 3.8 15H3V6H15V15ZM18 18.5C17.2 18.5 16.5 17.8 16.5 17C16.5 16.2 17.2 15.5 18 15.5C18.8 15.5 19.5 16.2 19.5 17C19.5 17.8 18.8 18.5 18 18.5ZM17 12V9.5H19.5L21.5 12H17ZM6 11V9H12V11H6Z'
        fill='#70808F'
      />
    </svg>
  );
};

export const Calendar = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='33'
      height='32'
      viewBox='0 0 33 32'
      fill='none'>
      <path
        d='M25.5 5.33325H24.1667V3.99992C24.1667 3.26392 23.5697 2.66659 22.8333 2.66659C22.0973 2.66659 21.5 3.26392 21.5 3.99992V5.33325H11.5V3.99992C11.5 3.26392 10.9027 2.66659 10.1667 2.66659C9.43067 2.66659 8.83334 3.26392 8.83334 3.99992V5.33325H7.50001C6.03601 5.33325 4.83334 6.53592 4.83334 7.99992V25.3333C4.83334 26.7973 6.03601 27.9999 7.50001 27.9999H25.5C26.964 27.9999 28.1667 26.7973 28.1667 25.3333V7.99992C28.1667 6.53592 26.964 5.33325 25.5 5.33325ZM25.5 25.3333H7.50001V11.9999H25.5V25.3333Z'
        fill='#8D99A5'
      />
    </svg>
  );
};

export const Settings = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='33'
      height='32'
      viewBox='0 0 33 32'
      fill='none'>
      <path
        d='M26.0758 17.2482C26.1248 16.8482 26.1575 16.4322 26.1575 16.0002C26.1575 15.5682 26.1248 15.1522 26.0594 14.7522L28.8223 12.6402C29.0676 12.4482 29.133 12.0962 28.9858 11.8242L26.37 7.3922C26.2065 7.1042 25.8632 7.0082 25.5689 7.1042L22.3155 8.3842C21.6289 7.8722 20.9095 7.4562 20.1084 7.1362L19.618 3.7442C19.5689 3.4242 19.291 3.2002 18.964 3.2002H13.7324C13.4054 3.2002 13.1439 3.4242 13.0948 3.7442L12.6044 7.1362C11.8033 7.4562 11.0676 7.8882 10.3973 8.3842L7.14387 7.1042C6.84959 6.9922 6.50627 7.1042 6.34278 7.3922L3.72697 11.8242C3.56349 12.1122 3.62888 12.4482 3.89046 12.6402L6.65341 14.7522C6.58801 15.1522 6.53896 15.5842 6.53896 16.0002C6.53896 16.4162 6.57166 16.8482 6.63706 17.2482L3.87411 19.3602C3.62888 19.5522 3.56349 19.9042 3.71063 20.1762L6.32643 24.6082C6.48992 24.8962 6.83324 24.9922 7.12752 24.8962L10.3809 23.6162C11.0676 24.1282 11.7869 24.5442 12.588 24.8642L13.0785 28.2562C13.1439 28.5762 13.4054 28.8002 13.7324 28.8002H18.964C19.291 28.8002 19.5689 28.5762 19.6016 28.2562L20.0921 24.8642C20.8932 24.5442 21.6289 24.1122 22.2992 23.6162L25.5526 24.8962C25.8469 25.0082 26.1902 24.8962 26.3537 24.6082L28.9695 20.1762C29.133 19.8882 29.0676 19.5522 28.806 19.3602L26.0758 17.2482V17.2482ZM16.3482 20.8002C13.6507 20.8002 11.4436 18.6402 11.4436 16.0002C11.4436 13.3602 13.6507 11.2002 16.3482 11.2002C19.0458 11.2002 21.2529 13.3602 21.2529 16.0002C21.2529 18.6402 19.0458 20.8002 16.3482 20.8002Z'
        fill='#8D99A5'
      />
    </svg>
  );
};

export const Support = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='52'
      height='53'
      viewBox='0 0 52 53'
      fill='none'>
      <path
        d='M26 12.6777C18.2681 12.6777 12 18.9459 12 26.6777C12 34.4096 18.2681 40.6777 26 40.6777C33.7319 40.6777 40 34.4096 40 26.6777C40 18.9459 33.7319 12.6777 26 12.6777ZM22 26.6777C22 25.8866 22.2346 25.1133 22.6741 24.4555C23.1136 23.7977 23.7384 23.285 24.4693 22.9822C25.2002 22.6795 26.0044 22.6003 26.7804 22.7546C27.5563 22.9089 28.269 23.2899 28.8284 23.8493C29.3878 24.4087 29.7688 25.1214 29.9231 25.8974C30.0775 26.6733 29.9983 27.4776 29.6955 28.2085C29.3928 28.9394 28.8801 29.5641 28.2223 30.0036C27.5645 30.4431 26.7911 30.6777 26 30.6777C24.9391 30.6777 23.9217 30.2563 23.1716 29.5062C22.4214 28.756 22 27.7386 22 26.6777ZM36.8275 22.7846L31.4319 23.1152C30.9428 22.373 30.3078 21.7381 29.5656 21.249L29.8931 15.8534C31.4874 16.4304 32.9353 17.3509 34.1342 18.5498C35.3331 19.7487 36.2536 21.1966 36.8306 22.7909L36.8275 22.7846ZM17.8681 18.5459C19.0644 17.345 20.5121 16.4244 22.1069 15.8502L22.4375 21.2459C21.6939 21.7355 21.0578 22.3716 20.5681 23.1152L15.1725 22.7877C15.7462 21.1918 16.6669 19.743 17.8681 18.5459ZM15.1725 30.5709L20.5681 30.2434C21.0581 30.9859 21.6942 31.6209 22.4375 32.1096L22.11 37.5052C20.516 36.9286 19.0683 36.0085 17.8695 34.8102C16.6706 33.6118 15.7499 32.1646 15.1725 30.5709ZM34.1319 34.8096C32.9356 36.0104 31.4879 36.9311 29.8931 37.5052L29.5656 32.1096C30.3078 31.6205 30.9428 30.9856 31.4319 30.2434L36.8275 30.5709C36.2533 32.1657 35.3327 33.6133 34.1319 34.8096Z'
        fill='#8D99A5'
      />
    </svg>
  );
};

export const Messages = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='52'
      height='53'
      viewBox='0 0 52 53'
      fill='none'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M40.679 36.3199C40.9946 36.6355 41.5341 36.4108 41.5325 35.9645L41.5053 28.3356V16.9672C41.5053 14.8743 39.8087 13.1777 37.7159 13.1777H20.0317C17.9388 13.1777 16.2422 14.8743 16.2422 16.9672V22.1777H28.0003C29.6571 22.1777 31.0003 23.5209 31.0003 25.1777V32.1251H36.4842L40.679 36.3199Z'
        fill='#8D99A5'
      />
      <path
        opacity='0.3'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.97656 35.6777V28.1777C9.97656 26.5209 11.3197 25.1777 12.9766 25.1777H24.9766C26.6334 25.1777 27.9766 26.5209 27.9766 28.1777V35.6777C27.9766 37.3346 26.6334 38.6777 24.9766 38.6777H13.1502L10.8615 40.8683C10.5435 41.1726 10.0158 40.9472 10.0158 40.5071V36.1641C9.98998 36.0058 9.97656 35.8433 9.97656 35.6777ZM15.9996 30.1777C15.9996 29.9016 16.2234 29.6777 16.4996 29.6777H24.4996C24.7757 29.6777 24.9996 29.9016 24.9996 30.1777V30.6777C24.9996 30.9539 24.7757 31.1777 24.4996 31.1777H16.4996C16.2234 31.1777 15.9996 30.9539 15.9996 30.6777V30.1777ZM20.9996 32.6777C20.7234 32.6777 20.4996 32.9016 20.4996 33.1777V33.6777C20.4996 33.9539 20.7234 34.1777 20.9996 34.1777H24.4996C24.7757 34.1777 24.9996 33.9539 24.9996 33.6777V33.1777C24.9996 32.9016 24.7757 32.6777 24.4996 32.6777H20.9996Z'
        fill='#8D99A5'
      />
    </svg>
  );
};

export const LeadMessages = props => {
  return (
    <svg
      {...props}
      xmlns='http://www.w3.org/2000/svg'
      width='30'
      height='31'
      viewBox='0 0 52 53'
      fill='none'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M40.679 36.3199C40.9946 36.6355 41.5341 36.4108 41.5325 35.9645L41.5053 28.3356V16.9672C41.5053 14.8743 39.8087 13.1777 37.7159 13.1777H20.0317C17.9388 13.1777 16.2422 14.8743 16.2422 16.9672V22.1777H28.0003C29.6571 22.1777 31.0003 23.5209 31.0003 25.1777V32.1251H36.4842L40.679 36.3199Z'
        fill={props?.style.fill}
      />
      <path
        opacity='0.3'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.97656 35.6777V28.1777C9.97656 26.5209 11.3197 25.1777 12.9766 25.1777H24.9766C26.6334 25.1777 27.9766 26.5209 27.9766 28.1777V35.6777C27.9766 37.3346 26.6334 38.6777 24.9766 38.6777H13.1502L10.8615 40.8683C10.5435 41.1726 10.0158 40.9472 10.0158 40.5071V36.1641C9.98998 36.0058 9.97656 35.8433 9.97656 35.6777ZM15.9996 30.1777C15.9996 29.9016 16.2234 29.6777 16.4996 29.6777H24.4996C24.7757 29.6777 24.9996 29.9016 24.9996 30.1777V30.6777C24.9996 30.9539 24.7757 31.1777 24.4996 31.1777H16.4996C16.2234 31.1777 15.9996 30.9539 15.9996 30.6777V30.1777ZM20.9996 32.6777C20.7234 32.6777 20.4996 32.9016 20.4996 33.1777V33.6777C20.4996 33.9539 20.7234 34.1777 20.9996 34.1777H24.4996C24.7757 34.1777 24.9996 33.9539 24.9996 33.6777V33.1777C24.9996 32.9016 24.7757 32.6777 24.4996 32.6777H20.9996Z'
        fill={props?.style.fill}
      />
    </svg>
  );
};

export const ConvertToCustomerIcon = props => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z'
        fill={props?.style?.fill || "#BADAFB"}
      />
      <path
        d='M16 12C18.21 12 20 10.21 20 8C20 5.79 18.21 4 16 4C13.79 4 12 5.79 12 8C12 10.21 13.79 12 16 12Z'
        fill={props?.style?.fill || "#BADAFB"}
      />
      <path
        d='M22 14C22 15.11 21.1 16 20 16C18.9 16 18 15.11 18 14C18 12.89 18.9 12 20 12C21.1 12 22 12.89 22 14Z'
        fill={props?.style?.fill2 || "#4EA5FE"}
      />
    </svg>
  );
};

export const IntegrationHighlited = () => {
  return (
    <svg
      width='52'
      height='52'
      viewBox='0 0 52 52'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <rect width='52' height='52' rx='6' fill='#E5F2FF' />
      <g clip-path='url(#clip0_305_142)'>
        <path
          d='M26 14V9.5L20 15.5L26 21.5V17C30.965 17 35 21.035 35 26C35 27.515 34.625 28.955 33.95 30.2L36.14 32.39C37.31 30.545 38 28.355 38 26C38 19.37 32.63 14 26 14ZM26 35C21.035 35 17 30.965 17 26C17 24.485 17.375 23.045 18.05 21.8L15.86 19.61C14.69 21.455 14 23.645 14 26C14 32.63 19.37 38 26 38V42.5L32 36.5L26 30.5V35Z'
          fill='#3699FF'
        />
      </g>
      <defs>
        <clipPath id='clip0_305_142'>
          <rect
            width='36'
            height='36'
            fill='white'
            transform='translate(8 8)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Integration = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='52'
      height='53'
      viewBox='0 0 52 53'
      fill='none'>
      <path
        d='M26 14.6777V10.1777L20 16.1777L26 22.1777V17.6777C30.965 17.6777 35 21.7127 35 26.6777C35 28.1927 34.625 29.6327 33.95 30.8777L36.14 33.0677C37.31 31.2227 38 29.0327 38 26.6777C38 20.0477 32.63 14.6777 26 14.6777ZM26 35.6777C21.035 35.6777 17 31.6427 17 26.6777C17 25.1627 17.375 23.7227 18.05 22.4777L15.86 20.2877C14.69 22.1327 14 24.3227 14 26.6777C14 33.3077 19.37 38.6777 26 38.6777V43.1777L32 37.1777L26 31.1777V35.6777Z'
        fill='#8D99A5'
      />
    </svg>
  );
};

export const Clip = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'>
      <path
        d='M8.60842 5.30962L9.55123 6.25242L7.90132 7.90234C7.51079 8.29286 7.51079 8.92603 7.90132 9.31655C8.29184 9.70708 8.92501 9.70708 9.31553 9.31655L11.6726 6.95953C12.5838 6.04831 12.5838 4.57092 11.6726 3.6597C10.7613 2.74848 9.28394 2.74848 8.37272 3.6597L3.65868 8.37374C2.74745 9.28497 2.74745 10.7623 3.65868 11.6736L3.89438 11.9093C4.67543 12.6903 5.94176 12.6903 6.72281 11.9093L7.66562 12.8521C6.36387 14.1538 4.25332 14.1538 2.95157 12.8521L2.71587 12.6164C1.28395 11.1845 1.28395 8.86286 2.71587 7.43093L7.42991 2.71689C8.86183 1.28497 11.1834 1.28497 12.6154 2.71689C14.0473 4.14881 14.0473 6.47042 12.6154 7.90234L10.2583 10.2594C9.34712 11.1706 7.86973 11.1706 6.95851 10.2594C6.04728 9.34814 6.04728 7.87075 6.95851 6.95953L8.60842 5.30962Z'
        fill='#FFA800'
      />
    </svg>
  );
};

export const BusinessCustomer = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='16'
      viewBox='0 0 18 16'
      fill='none'>
      <path
        d='M9 14H3V10H9V14ZM18 10V8L17 3H1L0 8V10H1V16H11V10H15V16H17V10H18ZM17 0H1V2H17V0Z'
        fill='#70808F'
      />
    </svg>
  );
};

export const ContactSettings = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='21'
      height='18'
      viewBox='0 0 21 18'
      fill='none'>
      <path
        d='M8 0C6.93913 0 5.92172 0.421427 5.17157 1.17157C4.42143 1.92172 4 2.93913 4 4C4 5.06087 4.42143 6.07828 5.17157 6.82843C5.92172 7.57857 6.93913 8 8 8C9.06087 8 10.0783 7.57857 10.8284 6.82843C11.5786 6.07828 12 5.06087 12 4C12 2.93913 11.5786 1.92172 10.8284 1.17157C10.0783 0.421427 9.06087 0 8 0ZM15 8C14.87 8 14.76 8.09 14.74 8.21L14.55 9.53C14.25 9.66 13.96 9.82 13.7 10L12.46 9.5C12.35 9.5 12.22 9.5 12.15 9.63L11.15 11.36C11.09 11.47 11.11 11.6 11.21 11.68L12.27 12.5C12.25 12.67 12.24 12.83 12.24 13C12.24 13.17 12.25 13.33 12.27 13.5L11.21 14.32C11.12 14.4 11.09 14.53 11.15 14.64L12.15 16.37C12.21 16.5 12.34 16.5 12.46 16.5L13.7 16C13.96 16.18 14.24 16.35 14.55 16.47L14.74 17.79C14.76 17.91 14.86 18 15 18H17C17.11 18 17.22 17.91 17.24 17.79L17.43 16.47C17.73 16.34 18 16.18 18.27 16L19.5 16.5C19.63 16.5 19.76 16.5 19.83 16.37L20.83 14.64C20.89 14.53 20.86 14.4 20.77 14.32L19.7 13.5C19.72 13.33 19.74 13.17 19.74 13C19.74 12.83 19.73 12.67 19.7 12.5L20.76 11.68C20.85 11.6 20.88 11.47 20.82 11.36L19.82 9.63C19.76 9.5 19.63 9.5 19.5 9.5L18.27 10C18 9.82 17.73 9.65 17.42 9.53L17.23 8.21C17.22 8.09 17.11 8 17 8H15ZM8 10C3.58 10 0 11.79 0 14V16H9.68C9.2337 15.0628 9.00142 14.038 9 13C9.00203 11.9953 9.22031 11.0028 9.64 10.09C9.11 10.03 8.56 10 8 10ZM16 11.5C16.83 11.5 17.5 12.17 17.5 13C17.5 13.83 16.83 14.5 16 14.5C15.16 14.5 14.5 13.83 14.5 13C14.5 12.17 15.17 11.5 16 11.5Z'
        fill='#70808F'
      />
    </svg>
  );
};

export const EndUsers = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='14'
      viewBox='0 0 24 14'
      fill='none'>
      <path
        d='M12 0C11.0717 0 10.1815 0.368749 9.52513 1.02513C8.86875 1.6815 8.5 2.57174 8.5 3.5C8.5 4.42826 8.86875 5.3185 9.52513 5.97487C10.1815 6.63125 11.0717 7 12 7C12.9283 7 13.8185 6.63125 14.4749 5.97487C15.1313 5.3185 15.5 4.42826 15.5 3.5C15.5 2.57174 15.1313 1.6815 14.4749 1.02513C13.8185 0.368749 12.9283 0 12 0ZM12 2C12.3978 2 12.7794 2.15804 13.0607 2.43934C13.342 2.72064 13.5 3.10218 13.5 3.5C13.5 3.89782 13.342 4.27936 13.0607 4.56066C12.7794 4.84196 12.3978 5 12 5C11.6022 5 11.2206 4.84196 10.9393 4.56066C10.658 4.27936 10.5 3.89782 10.5 3.5C10.5 3.10218 10.658 2.72064 10.9393 2.43934C11.2206 2.15804 11.6022 2 12 2ZM5.5 3C4.83696 3 4.20107 3.26339 3.73223 3.73223C3.26339 4.20107 3 4.83696 3 5.5C3 6.44 3.53 7.25 4.29 7.68C4.65 7.88 5.06 8 5.5 8C5.94 8 6.35 7.88 6.71 7.68C7.08 7.47 7.39 7.17 7.62 6.81C6.89 5.86 6.5 4.7 6.5 3.5C6.5 3.41 6.5 3.31 6.5 3.22C6.2 3.08 5.86 3 5.5 3ZM18.5 3C18.14 3 17.8 3.08 17.5 3.22C17.5 3.31 17.5 3.41 17.5 3.5C17.5 4.7 17.11 5.86 16.38 6.81C16.5 7 16.63 7.15 16.78 7.3C16.94 7.45 17.1 7.58 17.29 7.68C17.65 7.88 18.06 8 18.5 8C18.94 8 19.35 7.88 19.71 7.68C20.47 7.25 21 6.44 21 5.5C21 4.83696 20.7366 4.20107 20.2678 3.73223C19.7989 3.26339 19.163 3 18.5 3ZM12 9C9.66 9 5 10.17 5 12.5V14H19V12.5C19 10.17 14.34 9 12 9ZM4.71 9.55C2.78 9.78 0 10.76 0 12.5V14H3V12.07C3 11.06 3.69 10.22 4.71 9.55ZM19.29 9.55C20.31 10.22 21 11.06 21 12.07V14H24V12.5C24 10.76 21.22 9.78 19.29 9.55ZM12 11C13.53 11 15.24 11.5 16.23 12H7.77C8.76 11.5 10.47 11 12 11Z'
        fill='#70808F'
      />
    </svg>
  );
};

export const LeadVititor = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='21'
      height='20'
      viewBox='0 0 21 20'
      fill='none'>
      <path
        d='M13.5 8C16 8 18 10 18 12.5C18 13.38 17.75 14.21 17.31 14.9L20.39 18L19 19.39L15.88 16.32C15.19 16.75 14.37 17 13.5 17C11 17 9 15 9 12.5C9 10 11 8 13.5 8ZM13.5 10C12.837 10 12.2011 10.2634 11.7322 10.7322C11.2634 11.2011 11 11.837 11 12.5C11 13.163 11.2634 13.7989 11.7322 14.2678C12.2011 14.7366 12.837 15 13.5 15C14.163 15 14.7989 14.7366 15.2678 14.2678C15.7366 13.7989 16 13.163 16 12.5C16 11.837 15.7366 11.2011 15.2678 10.7322C14.7989 10.2634 14.163 10 13.5 10ZM8 0C9.06087 0 10.0783 0.421427 10.8284 1.17157C11.5786 1.92172 12 2.93913 12 4C12 4.91 11.69 5.75 11.18 6.43C10.32 6.75 9.55 7.26 8.91 7.9L8 8C6.93913 8 5.92172 7.57857 5.17157 6.82843C4.42143 6.07828 4 5.06087 4 4C4 2.93913 4.42143 1.92172 5.17157 1.17157C5.92172 0.421427 6.93913 0 8 0ZM0 16V14C0 11.88 3.31 10.14 7.5 10C7.18 10.78 7 11.62 7 12.5C7 13.79 7.38 15 8 16H0Z'
        fill='#70808F'
      />
    </svg>
  );
};

export const MediaContact = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='21'
      height='18'
      viewBox='0 0 21 18'
      fill='none'>
      <path
        d='M2 4V16H17V18H2C0 18 0 16 0 16V4H2ZM19.3 0H5.7C4.76 0 4 0.7 4 1.55V12.45C4 13.31 4.76 14 5.7 14H19.3C20.24 14 21 13.31 21 12.45V1.55C21 0.7 20.24 0 19.3 0ZM6 2H11V8H6V2ZM19 12H6V10H19V12ZM19 8H13V6H19V8ZM19 4H13V2H19V4Z'
        fill='#70808F'
      />
    </svg>
  );
};

export const VenderContact = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='19'
      viewBox='0 0 20 19'
      fill='none'>
      <path
        d='M18 4H14V2C14 1.46957 13.7893 0.960859 13.4142 0.585786C13.0391 0.210714 12.5304 0 12 0H8C6.89 0 6 0.89 6 2V4H2C0.89 4 0 4.89 0 6V17C0 17.5304 0.210714 18.0391 0.585786 18.4142C0.960859 18.7893 1.46957 19 2 19H18C18.5304 19 19.0391 18.7893 19.4142 18.4142C19.7893 18.0391 20 17.5304 20 17V6C20 5.46957 19.7893 4.96086 19.4142 4.58579C19.0391 4.21071 18.5304 4 18 4ZM8 2H12V4H8V2ZM10 7C10.663 7 11.2989 7.26339 11.7678 7.73223C12.2366 8.20107 12.5 8.83696 12.5 9.5C12.5 10.163 12.2366 10.7989 11.7678 11.2678C11.2989 11.7366 10.663 12 10 12C9.33696 12 8.70107 11.7366 8.23223 11.2678C7.76339 10.7989 7.5 10.163 7.5 9.5C7.5 8.83696 7.76339 8.20107 8.23223 7.73223C8.70107 7.26339 9.33696 7 10 7ZM15 17H5V15.75C5 14.37 7.24 13.25 10 13.25C12.76 13.25 15 14.37 15 15.75V17Z'
        fill='#70808F'
      />
    </svg>
  );
};

export const GridSelected = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='34'
      height='34'
      viewBox='0 0 34 34'
      fill='none'>
      <rect opacity='0.6' width='34' height='34' rx='6' fill='#ECF0F3' />
      <path
        opacity='0.25'
        d='M18.2326 19.6703C18.3353 18.9203 18.9203 18.3353 19.6703 18.2326C20.1004 18.1736 20.5676 18.125 20.9375 18.125C21.3074 18.125 21.7746 18.1736 22.2047 18.2326C22.9547 18.3353 23.5397 18.9203 23.6424 19.6703C23.7014 20.1004 23.75 20.5676 23.75 20.9375C23.75 21.3074 23.7014 21.7746 23.6424 22.2047C23.5397 22.9547 22.9547 23.5397 22.2047 23.6424C21.7746 23.7014 21.3074 23.75 20.9375 23.75C20.5676 23.75 20.1004 23.7014 19.6703 23.6424C18.9203 23.5397 18.3353 22.9547 18.2326 22.2047C18.1736 21.7746 18.125 21.3074 18.125 20.9375C18.125 20.5676 18.1736 20.1004 18.2326 19.6703Z'
        fill='#00A3FF'
      />
      <path
        opacity='0.25'
        d='M11.3576 19.6703C11.4603 18.9203 12.0453 18.3353 12.7953 18.2326C13.2254 18.1736 13.6926 18.125 14.0625 18.125C14.4324 18.125 14.8996 18.1736 15.3297 18.2326C16.0797 18.3353 16.6647 18.9203 16.7674 19.6703C16.8264 20.1004 16.875 20.5676 16.875 20.9375C16.875 21.3074 16.8264 21.7746 16.7674 22.2047C16.6647 22.9547 16.0797 23.5397 15.3297 23.6424C14.8996 23.7014 14.4324 23.75 14.0625 23.75C13.6926 23.75 13.2254 23.7014 12.7953 23.6424C12.0453 23.5397 11.4603 22.9547 11.3576 22.2047C11.2986 21.7746 11.25 21.3074 11.25 20.9375C11.25 20.5676 11.2986 20.1004 11.3576 19.6703Z'
        fill='#00A3FF'
      />
      <path
        opacity='0.25'
        d='M18.2326 12.7953C18.3353 12.0453 18.9203 11.4603 19.6703 11.3576C20.1004 11.2986 20.5676 11.25 20.9375 11.25C21.3074 11.25 21.7746 11.2986 22.2047 11.3576C22.9547 11.4603 23.5397 12.0453 23.6424 12.7953C23.7014 13.2254 23.75 13.6926 23.75 14.0625C23.75 14.4324 23.7014 14.8996 23.6424 15.3297C23.5397 16.0797 22.9547 16.6647 22.2047 16.7674C21.7746 16.8264 21.3074 16.875 20.9375 16.875C20.5676 16.875 20.1004 16.8264 19.6703 16.7674C18.9203 16.6647 18.3353 16.0797 18.2326 15.3297C18.1736 14.8996 18.125 14.4324 18.125 14.0625C18.125 13.6926 18.1736 13.2254 18.2326 12.7953Z'
        fill='#00A3FF'
      />
      <path
        d='M11.3576 12.7953C11.4603 12.0453 12.0453 11.4603 12.7953 11.3576C13.2254 11.2986 13.6926 11.25 14.0625 11.25C14.4324 11.25 14.8996 11.2986 15.3297 11.3576C16.0797 11.4603 16.6647 12.0453 16.7674 12.7953C16.8264 13.2254 16.875 13.6926 16.875 14.0625C16.875 14.4324 16.8264 14.8996 16.7674 15.3297C16.6647 16.0797 16.0797 16.6647 15.3297 16.7674C14.8996 16.8264 14.4324 16.875 14.0625 16.875C13.6926 16.875 13.2254 16.8264 12.7953 16.7674C12.0453 16.6647 11.4603 16.0797 11.3576 15.3297C11.2986 14.8996 11.25 14.4324 11.25 14.0625C11.25 13.6926 11.2986 13.2254 11.3576 12.7953Z'
        fill='#00A3FF'
      />
    </svg>
  );
};

export const GridUnSelected = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='34'
      height='34'
      viewBox='0 0 34 34'
      fill='none'>
      <rect opacity='0.6' width='34' height='34' rx='6' fill='#ECF0F3' />
      <path
        opacity='0.25'
        d='M18.2326 19.6703C18.3353 18.9203 18.9203 18.3353 19.6703 18.2326C20.1004 18.1736 20.5676 18.125 20.9375 18.125C21.3074 18.125 21.7746 18.1736 22.2047 18.2326C22.9547 18.3353 23.5397 18.9203 23.6424 19.6703C23.7014 20.1004 23.75 20.5676 23.75 20.9375C23.75 21.3074 23.7014 21.7746 23.6424 22.2047C23.5397 22.9547 22.9547 23.5397 22.2047 23.6424C21.7746 23.7014 21.3074 23.75 20.9375 23.75C20.5676 23.75 20.1004 23.7014 19.6703 23.6424C18.9203 23.5397 18.3353 22.9547 18.2326 22.2047C18.1736 21.7746 18.125 21.3074 18.125 20.9375C18.125 20.5676 18.1736 20.1004 18.2326 19.6703Z'
        fill='#A1A5B7'
      />
      <path
        opacity='0.25'
        d='M11.3576 19.6703C11.4603 18.9203 12.0453 18.3353 12.7953 18.2326C13.2254 18.1736 13.6926 18.125 14.0625 18.125C14.4324 18.125 14.8996 18.1736 15.3297 18.2326C16.0797 18.3353 16.6647 18.9203 16.7674 19.6703C16.8264 20.1004 16.875 20.5676 16.875 20.9375C16.875 21.3074 16.8264 21.7746 16.7674 22.2047C16.6647 22.9547 16.0797 23.5397 15.3297 23.6424C14.8996 23.7014 14.4324 23.75 14.0625 23.75C13.6926 23.75 13.2254 23.7014 12.7953 23.6424C12.0453 23.5397 11.4603 22.9547 11.3576 22.2047C11.2986 21.7746 11.25 21.3074 11.25 20.9375C11.25 20.5676 11.2986 20.1004 11.3576 19.6703Z'
        fill='#A1A5B7'
      />
      <path
        opacity='0.25'
        d='M18.2326 12.7953C18.3353 12.0453 18.9203 11.4603 19.6703 11.3576C20.1004 11.2986 20.5676 11.25 20.9375 11.25C21.3074 11.25 21.7746 11.2986 22.2047 11.3576C22.9547 11.4603 23.5397 12.0453 23.6424 12.7953C23.7014 13.2254 23.75 13.6926 23.75 14.0625C23.75 14.4324 23.7014 14.8996 23.6424 15.3297C23.5397 16.0797 22.9547 16.6647 22.2047 16.7674C21.7746 16.8264 21.3074 16.875 20.9375 16.875C20.5676 16.875 20.1004 16.8264 19.6703 16.7674C18.9203 16.6647 18.3353 16.0797 18.2326 15.3297C18.1736 14.8996 18.125 14.4324 18.125 14.0625C18.125 13.6926 18.1736 13.2254 18.2326 12.7953Z'
        fill='#A1A5B7'
      />
      <path
        d='M11.3576 12.7953C11.4603 12.0453 12.0453 11.4603 12.7953 11.3576C13.2254 11.2986 13.6926 11.25 14.0625 11.25C14.4324 11.25 14.8996 11.2986 15.3297 11.3576C16.0797 11.4603 16.6647 12.0453 16.7674 12.7953C16.8264 13.2254 16.875 13.6926 16.875 14.0625C16.875 14.4324 16.8264 14.8996 16.7674 15.3297C16.6647 16.0797 16.0797 16.6647 15.3297 16.7674C14.8996 16.8264 14.4324 16.875 14.0625 16.875C13.6926 16.875 13.2254 16.8264 12.7953 16.7674C12.0453 16.6647 11.4603 16.0797 11.3576 15.3297C11.2986 14.8996 11.25 14.4324 11.25 14.0625C11.25 13.6926 11.2986 13.2254 11.3576 12.7953Z'
        fill='#A1A5B7'
      />
    </svg>
  );
};

export const ListSelected = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='34'
      height='34'
      viewBox='0 0 34 34'
      fill='none'>
      <rect opacity='0.6' width='34' height='34' rx='6' fill='#ECF0F3' />
      <path
        d='M22.1984 11.4138C22.9525 11.479 23.5397 12.0453 23.6424 12.7953C23.7014 13.2254 23.75 13.6926 23.75 14.0625C23.75 14.4324 23.7014 14.8996 23.6424 15.3297C23.5397 16.0797 22.9525 16.646 22.1984 16.7112C21.2669 16.7918 19.758 16.875 17.5 16.875C15.242 16.875 13.7331 16.7918 12.8016 16.7112C12.0475 16.646 11.4603 16.0797 11.3576 15.3297C11.2986 14.8996 11.25 14.4324 11.25 14.0625C11.25 13.6926 11.2986 13.2254 11.3576 12.7953C11.4603 12.0453 12.0475 11.479 12.8016 11.4138C13.7331 11.3332 15.242 11.25 17.5 11.25C19.758 11.25 21.2669 11.3332 22.1984 11.4138Z'
        fill='#3699FF'
      />
      <path
        opacity='0.25'
        d='M22.1984 18.2888C22.9525 18.354 23.5397 18.9203 23.6424 19.6703C23.7014 20.1004 23.75 20.5676 23.75 20.9375C23.75 21.3074 23.7014 21.7746 23.6424 22.2047C23.5397 22.9547 22.9525 23.521 22.1984 23.5862C21.2669 23.6668 19.758 23.75 17.5 23.75C15.242 23.75 13.7331 23.6668 12.8016 23.5862C12.0475 23.521 11.4603 22.9547 11.3576 22.2047C11.2986 21.7746 11.25 21.3074 11.25 20.9375C11.25 20.5676 11.2986 20.1004 11.3576 19.6703C11.4603 18.9203 12.0475 18.354 12.8016 18.2888C13.7331 18.2082 15.242 18.125 17.5 18.125C19.758 18.125 21.2669 18.2082 22.1984 18.2888Z'
        fill='#3699FF'
      />
    </svg>
  );
};

export const ListUnSelected = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='34'
      height='34'
      viewBox='0 0 34 34'
      fill='none'>
      <rect opacity='0.6' width='34' height='34' rx='6' fill='#ECF0F3' />
      <path
        d='M22.1984 11.4138C22.9525 11.479 23.5397 12.0453 23.6424 12.7953C23.7014 13.2254 23.75 13.6926 23.75 14.0625C23.75 14.4324 23.7014 14.8996 23.6424 15.3297C23.5397 16.0797 22.9525 16.646 22.1984 16.7112C21.2669 16.7918 19.758 16.875 17.5 16.875C15.242 16.875 13.7331 16.7918 12.8016 16.7112C12.0475 16.646 11.4603 16.0797 11.3576 15.3297C11.2986 14.8996 11.25 14.4324 11.25 14.0625C11.25 13.6926 11.2986 13.2254 11.3576 12.7953C11.4603 12.0453 12.0475 11.479 12.8016 11.4138C13.7331 11.3332 15.242 11.25 17.5 11.25C19.758 11.25 21.2669 11.3332 22.1984 11.4138Z'
        fill='#A1A5B7'
      />
      <path
        opacity='0.25'
        d='M22.1984 18.2888C22.9525 18.354 23.5397 18.9203 23.6424 19.6703C23.7014 20.1004 23.75 20.5676 23.75 20.9375C23.75 21.3074 23.7014 21.7746 23.6424 22.2047C23.5397 22.9547 22.9525 23.521 22.1984 23.5862C21.2669 23.6668 19.758 23.75 17.5 23.75C15.242 23.75 13.7331 23.6668 12.8016 23.5862C12.0475 23.521 11.4603 22.9547 11.3576 22.2047C11.2986 21.7746 11.25 21.3074 11.25 20.9375C11.25 20.5676 11.2986 20.1004 11.3576 19.6703C11.4603 18.9203 12.0475 18.354 12.8016 18.2888C13.7331 18.2082 15.242 18.125 17.5 18.125C19.758 18.125 21.2669 18.2082 22.1984 18.2888Z'
        fill='#A1A5B7'
      />
    </svg>
  );
};
export const TickMark = props => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={props?.style?.width || "26"}
      height={props?.style?.width || "25"}
      viewBox='0 0 26 25'
      fill='none'>
      <rect
        x='0.0859375'
        width='25.1645'
        height='25'
        rx='4.97368'
        fill='#219653'
        fillOpacity='0.25'
      />
      <path
        d='M20.3926 7.34961L10.0918 17.6504L4.94141 12.5'
        stroke='#219653'
        strokeWidth='3.67885'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export const RedCross = props => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={props?.style?.width || "26"}
      height={props?.style?.width || "25"}
      viewBox='0 0 26 25'
      fill='none'>
      <rect
        width='25.1645'
        height='25'
        rx='4.97368'
        fill='#EB5757'
        fillOpacity='0.25'
      />
      <path
        d='M19.0618 6.0199L6.10156 18.9801'
        stroke='#EB5757'
        strokeWidth='3.60006'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M19.0618 18.9801L6.10156 6.0199'
        stroke='#EB5757'
        strokeWidth='3.60006'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export const Filter = () => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g clip-path='url(#clip0_6446_69745)'>
        <path
          d='M3.20856 4.67504C4.8919 6.83337 8.00023 10.8334 8.00023 10.8334V15.8334C8.00023 16.2917 8.37523 16.6667 8.83356 16.6667H10.5002C10.9586 16.6667 11.3336 16.2917 11.3336 15.8334V10.8334C11.3336 10.8334 14.4336 6.83337 16.1169 4.67504C16.5419 4.12504 16.1502 3.33337 15.4586 3.33337H3.8669C3.17523 3.33337 2.78356 4.12504 3.20856 4.67504Z'
          fill='white'
        />
      </g>
      <defs>
        <clipPath id='clip0_6446_69745'>
          <rect
            width='20'
            height='20'
            fill='white'
            transform='translate(-0.333008)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const LastestVersion = () => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16ZM11.707 6.707L7.704 10.707C7.61113 10.8 7.50084 10.8737 7.37944 10.9241C7.25804 10.9744 7.12792 11.0003 6.9965 11.0003C6.86508 11.0003 6.73496 10.9744 6.61356 10.9241C6.49216 10.8737 6.38187 10.8 6.289 10.707L4.292 8.707C4.10449 8.51923 3.99926 8.26466 3.99944 7.99929C3.99963 7.73393 4.10523 7.47951 4.293 7.292C4.48077 7.10449 4.73534 6.99926 5.00071 6.99944C5.26607 6.99963 5.52049 7.10523 5.708 7.293L6.998 8.586L10.293 5.293C10.4816 5.11084 10.7342 5.01005 10.9964 5.01233C11.2586 5.0146 11.5094 5.11977 11.6948 5.30518C11.8802 5.49059 11.9854 5.7414 11.9877 6.0036C11.99 6.2658 11.8892 6.5184 11.707 6.707Z'
        fill='#18BC6D'
      />
    </svg>
  );
};

export const InTesting = () => {
  return (
    <svg
      width='13'
      height='13'
      viewBox='0 0 13 13'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M5.33366 2.00008C6.25366 2.00008 7.08699 2.37341 7.69366 2.97341L6.00033 4.66675H10.0003V0.666748L8.63366 2.03341C7.78699 1.18675 6.62033 0.666748 5.33366 0.666748C2.98033 0.666748 1.04699 2.40675 0.720325 4.66675H2.06699C2.37366 3.14675 3.72033 2.00008 5.33366 2.00008ZM9.09366 8.09342C9.53366 7.49342 9.84033 6.78008 9.94699 6.00008H8.60033C8.29366 7.52008 6.94699 8.66675 5.33366 8.66675C4.41366 8.66675 3.58033 8.29342 2.97366 7.69341L4.66699 6.00008H0.666992V10.0001L2.03366 8.63341C2.88033 9.48008 4.04699 10.0001 5.33366 10.0001C6.36699 10.0001 7.32033 9.66008 8.09366 9.09341L11.3337 12.3267L12.327 11.3334L9.09366 8.09342Z'
        fill='#9B51E0'
      />
    </svg>
  );
};

export const RetiredVersion = () => {
  return (
    <svg
      width='15'
      height='16'
      viewBox='0 0 15 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M7.76541 0.888916C6.35897 0.888916 4.98411 1.30598 3.81469 2.08735C2.64527 2.86873 1.73382 3.97934 1.1956 5.27872C0.657378 6.57811 0.516554 8.00792 0.790938 9.38734C1.06532 10.7668 1.74259 12.0338 2.7371 13.0283C3.7316 14.0228 4.99868 14.7001 6.3781 14.9745C7.75752 15.2489 9.18733 15.1081 10.4867 14.5698C11.7861 14.0316 12.8967 13.1202 13.6781 11.9507C14.4595 10.7813 14.8765 9.40647 14.8765 8.00003C14.8765 6.11404 14.1273 4.3053 12.7937 2.97171C11.4601 1.63812 9.6514 0.888916 7.76541 0.888916ZM11.321 10.7111C11.4388 10.829 11.5051 10.9889 11.5051 11.1556C11.5051 11.3223 11.4388 11.4822 11.321 11.6C11.2031 11.7179 11.0432 11.7841 10.8765 11.7841C10.7098 11.7841 10.55 11.7179 10.4321 11.6L7.76541 8.93336L5.09874 11.6089C5.04038 11.6673 4.97109 11.7136 4.89483 11.7452C4.81857 11.7768 4.73684 11.793 4.6543 11.793C4.57176 11.793 4.49003 11.7768 4.41377 11.7452C4.33751 11.7136 4.26822 11.6673 4.20986 11.6089C4.15149 11.5506 4.10519 11.4813 4.07361 11.405C4.04202 11.3287 4.02576 11.247 4.02576 11.1645C4.02576 11.0819 4.04202 11.0002 4.07361 10.9239C4.10519 10.8477 4.15149 10.7784 4.20986 10.72L6.87652 8.03558L4.1343 5.27114C4.01643 5.15326 3.95021 4.99339 3.95021 4.82669C3.95021 4.65999 4.01643 4.50012 4.1343 4.38225C4.25217 4.26437 4.41205 4.19815 4.57874 4.19815C4.74544 4.19815 4.90531 4.26437 5.02319 4.38225L7.76541 7.15558L10.5076 4.41336C10.566 4.355 10.6353 4.3087 10.7115 4.27711C10.7878 4.24552 10.8695 4.22927 10.9521 4.22927C11.0346 4.22927 11.1164 4.24552 11.1926 4.27711C11.2689 4.3087 11.3382 4.355 11.3965 4.41336C11.4549 4.47173 11.5012 4.54101 11.5328 4.61727C11.5644 4.69353 11.5806 4.77526 11.5806 4.8578C11.5806 4.94035 11.5644 5.02208 11.5328 5.09834C11.5012 5.17459 11.4549 5.24388 11.3965 5.30225L8.6543 8.03558L11.321 10.7111Z'
        fill='#FF3535'
      />
    </svg>
  );
};

export const ExpandRightIcon = () => {
  return (
    <svg
      width='26'
      height='25'
      viewBox='0 0 26 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <ellipse
        cx='12.878'
        cy='12.5'
        rx='12.5'
        ry='12.878'
        transform='rotate(-90 12.878 12.5)'
        fill='#E2E6E9'
      />
      <path
        d='M9.73315 7.70711C9.33082 7.31658 9.33082 6.68342 9.73315 6.29289C10.1355 5.90237 10.7878 5.90237 11.1901 6.29289L17.3716 12.2929C17.7616 12.6715 17.7753 13.2811 17.4025 13.6757L11.7362 19.6757C11.3517 20.0828 10.7 20.1103 10.2806 19.7371C9.86118 19.364 9.83284 18.7314 10.2173 18.3243L15.2171 13.0301L9.73315 7.70711Z'
        fill='black'
      />
    </svg>
  );
};

export const ExpandDownIcon = () => {
  return (
    <svg
      width='26'
      height='25'
      viewBox='0 0 26 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <ellipse
        cx='12.878'
        cy='12.5'
        rx='12.5'
        ry='12.878'
        transform='rotate(-90 12.878 12.5)'
        fill='#E2E6E9'
      />
      <path
        d='M9.73315 7.70711C9.33082 7.31658 9.33082 6.68342 9.73315 6.29289C10.1355 5.90237 10.7878 5.90237 11.1901 6.29289L17.3716 12.2929C17.7616 12.6715 17.7753 13.2811 17.4025 13.6757L11.7362 19.6757C11.3517 20.0828 10.7 20.1103 10.2806 19.7371C9.86118 19.364 9.83284 18.7314 10.2173 18.3243L15.2171 13.0301L9.73315 7.70711Z'
        fill='black'
      />
    </svg>
  );
};

export const WifiIcon = () => {
  return (
    <svg
      width='22'
      height='16'
      viewBox='0 0 22 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M0 4.99977L2 6.99977C6.97 2.02977 15.03 2.02977 20 6.99977L22 4.99977C15.93 -1.07023 6.08 -1.07023 0 4.99977ZM8 12.9998L11 15.9998L14 12.9998C12.35 11.3398 9.66 11.3398 8 12.9998ZM4 8.99977L6 10.9998C8.76 8.23977 13.24 8.23977 16 10.9998L18 8.99977C14.14 5.13977 7.87 5.13977 4 8.99977Z'
        fill='#323232'
      />
    </svg>
  );
};

export const BluetoothIcon = () => {
  return (
    <svg
      width='13'
      height='20'
      viewBox='0 0 13 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M12.71 5.71L7 0H6V7.59L1.41 3L0 4.41L5.59 10L0 15.59L1.41 17L6 12.41V20H7L12.71 14.29L8.41 10L12.71 5.71ZM8 3.83L9.88 5.71L8 7.59V3.83ZM9.88 14.29L8 16.17V12.41L9.88 14.29Z'
        fill='#3699FF'
      />
    </svg>
  );
};

export const SoftwareTickMark = () => {
  return (
    <svg
      width='41'
      height='41'
      viewBox='0 0 41 41'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <rect width='41' height='41' rx='6' fill='#C5EEDB' />
      <rect
        x='8.67285'
        y='22.9126'
        width='4.7331'
        height='10.1736'
        rx='1'
        transform='rotate(-45 8.67285 22.9126)'
        fill='#18BC6D'
      />
      <rect
        x='30.0527'
        y='10.25'
        width='4.01089'
        height='24.0653'
        rx='1'
        transform='rotate(45 30.0527 10.25)'
        fill='#18BC6D'
      />
    </svg>
  );
};
export const GridIcon = () => {
  return (
    <svg
      width='15'
      height='15'
      viewBox='0 0 15 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        opacity='0.25'
        d='M8.23256 9.67027C8.33526 8.92033 8.92033 8.33526 9.67027 8.23256C10.1004 8.17365 10.5676 8.125 10.9375 8.125C11.3074 8.125 11.7746 8.17365 12.2047 8.23256C12.9547 8.33526 13.5397 8.92033 13.6424 9.67027C13.7014 10.1004 13.75 10.5676 13.75 10.9375C13.75 11.3074 13.7014 11.7746 13.6424 12.2047C13.5397 12.9547 12.9547 13.5397 12.2047 13.6424C11.7746 13.7014 11.3074 13.75 10.9375 13.75C10.5676 13.75 10.1004 13.7014 9.67027 13.6424C8.92033 13.5397 8.33526 12.9547 8.23256 12.2047C8.17365 11.7746 8.125 11.3074 8.125 10.9375C8.125 10.5676 8.17365 10.1004 8.23256 9.67027Z'
        fill='#A1A5B7'
      />
      <path
        opacity='0.25'
        d='M1.35756 9.67027C1.46026 8.92033 2.04533 8.33526 2.79527 8.23256C3.2254 8.17365 3.6926 8.125 4.0625 8.125C4.4324 8.125 4.8996 8.17365 5.32973 8.23256C6.07967 8.33526 6.66474 8.92033 6.76744 9.67027C6.82635 10.1004 6.875 10.5676 6.875 10.9375C6.875 11.3074 6.82635 11.7746 6.76744 12.2047C6.66474 12.9547 6.07967 13.5397 5.32973 13.6424C4.8996 13.7014 4.4324 13.75 4.0625 13.75C3.6926 13.75 3.2254 13.7014 2.79527 13.6424C2.04533 13.5397 1.46026 12.9547 1.35756 12.2047C1.29865 11.7746 1.25 11.3074 1.25 10.9375C1.25 10.5676 1.29865 10.1004 1.35756 9.67027Z'
        fill='#A1A5B7'
      />
      <path
        opacity='0.25'
        d='M8.23256 2.79527C8.33526 2.04533 8.92033 1.46026 9.67027 1.35756C10.1004 1.29865 10.5676 1.25 10.9375 1.25C11.3074 1.25 11.7746 1.29865 12.2047 1.35756C12.9547 1.46026 13.5397 2.04533 13.6424 2.79527C13.7014 3.2254 13.75 3.6926 13.75 4.0625C13.75 4.4324 13.7014 4.8996 13.6424 5.32973C13.5397 6.07967 12.9547 6.66474 12.2047 6.76744C11.7746 6.82635 11.3074 6.875 10.9375 6.875C10.5676 6.875 10.1004 6.82635 9.67027 6.76744C8.92033 6.66474 8.33526 6.07967 8.23256 5.32973C8.17365 4.8996 8.125 4.4324 8.125 4.0625C8.125 3.6926 8.17365 3.2254 8.23256 2.79527Z'
        fill='#A1A5B7'
      />
      <path
        d='M1.35756 2.79527C1.46026 2.04533 2.04533 1.46026 2.79527 1.35756C3.2254 1.29865 3.6926 1.25 4.0625 1.25C4.4324 1.25 4.8996 1.29865 5.32973 1.35756C6.07967 1.46026 6.66474 2.04533 6.76744 2.79527C6.82635 3.2254 6.875 3.6926 6.875 4.0625C6.875 4.4324 6.82635 4.8996 6.76744 5.32973C6.66474 6.07967 6.07967 6.66474 5.32973 6.76744C4.8996 6.82635 4.4324 6.875 4.0625 6.875C3.6926 6.875 3.2254 6.82635 2.79527 6.76744C2.04533 6.66474 1.46026 6.07967 1.35756 5.32973C1.29865 4.8996 1.25 4.4324 1.25 4.0625C1.25 3.6926 1.29865 3.2254 1.35756 2.79527Z'
        fill='#A1A5B7'
      />
    </svg>
  );
};

export const ListShow = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='15'
      height='15'
      viewBox='0 0 15 15'
      fill='none'>
      <path
        d='M12.1984 1.4138C12.9525 1.47902 13.5397 2.04533 13.6424 2.79527C13.7014 3.2254 13.75 3.6926 13.75 4.0625C13.75 4.4324 13.7014 4.8996 13.6424 5.32973C13.5397 6.07967 12.9525 6.64598 12.1984 6.7112C11.2669 6.79176 9.75803 6.875 7.5 6.875C5.24197 6.875 3.73313 6.79176 2.80164 6.7112C2.04752 6.64597 1.46026 6.07967 1.35756 5.32973C1.29865 4.8996 1.25 4.4324 1.25 4.0625C1.25 3.6926 1.29865 3.2254 1.35756 2.79527C1.46027 2.04533 2.04752 1.47902 2.80164 1.4138C3.73314 1.33324 5.24197 1.25 7.5 1.25C9.75803 1.25 11.2669 1.33324 12.1984 1.4138Z'
        fill='#3699FF'
      />
      <path
        opacity='0.25'
        d='M12.1984 8.2888C12.9525 8.35402 13.5397 8.92033 13.6424 9.67027C13.7014 10.1004 13.75 10.5676 13.75 10.9375C13.75 11.3074 13.7014 11.7746 13.6424 12.2047C13.5397 12.9547 12.9525 13.521 12.1984 13.5862C11.2669 13.6668 9.75803 13.75 7.5 13.75C5.24197 13.75 3.73313 13.6668 2.80164 13.5862C2.04752 13.521 1.46026 12.9547 1.35756 12.2047C1.29865 11.7746 1.25 11.3074 1.25 10.9375C1.25 10.5676 1.29865 10.1004 1.35756 9.67027C1.46027 8.92033 2.04752 8.35402 2.80164 8.2888C3.73314 8.20824 5.24197 8.125 7.5 8.125C9.75803 8.125 11.2669 8.20824 12.1984 8.2888Z'
        fill='#3699FF'
      />
    </svg>
  );
};

export const GridHide = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='15'
      height='15'
      viewBox='0 0 15 15'
      fill='none'>
      <path
        opacity='0.25'
        d='M8.23256 9.67027C8.33526 8.92033 8.92033 8.33526 9.67027 8.23256C10.1004 8.17365 10.5676 8.125 10.9375 8.125C11.3074 8.125 11.7746 8.17365 12.2047 8.23256C12.9547 8.33526 13.5397 8.92033 13.6424 9.67027C13.7014 10.1004 13.75 10.5676 13.75 10.9375C13.75 11.3074 13.7014 11.7746 13.6424 12.2047C13.5397 12.9547 12.9547 13.5397 12.2047 13.6424C11.7746 13.7014 11.3074 13.75 10.9375 13.75C10.5676 13.75 10.1004 13.7014 9.67027 13.6424C8.92033 13.5397 8.33526 12.9547 8.23256 12.2047C8.17365 11.7746 8.125 11.3074 8.125 10.9375C8.125 10.5676 8.17365 10.1004 8.23256 9.67027Z'
        fill='#A1A5B7'
      />
      <path
        opacity='0.25'
        d='M1.35756 9.67027C1.46026 8.92033 2.04533 8.33526 2.79527 8.23256C3.2254 8.17365 3.6926 8.125 4.0625 8.125C4.4324 8.125 4.8996 8.17365 5.32973 8.23256C6.07967 8.33526 6.66474 8.92033 6.76744 9.67027C6.82635 10.1004 6.875 10.5676 6.875 10.9375C6.875 11.3074 6.82635 11.7746 6.76744 12.2047C6.66474 12.9547 6.07967 13.5397 5.32973 13.6424C4.8996 13.7014 4.4324 13.75 4.0625 13.75C3.6926 13.75 3.2254 13.7014 2.79527 13.6424C2.04533 13.5397 1.46026 12.9547 1.35756 12.2047C1.29865 11.7746 1.25 11.3074 1.25 10.9375C1.25 10.5676 1.29865 10.1004 1.35756 9.67027Z'
        fill='#A1A5B7'
      />
      <path
        opacity='0.25'
        d='M8.23256 2.79527C8.33526 2.04533 8.92033 1.46026 9.67027 1.35756C10.1004 1.29865 10.5676 1.25 10.9375 1.25C11.3074 1.25 11.7746 1.29865 12.2047 1.35756C12.9547 1.46026 13.5397 2.04533 13.6424 2.79527C13.7014 3.2254 13.75 3.6926 13.75 4.0625C13.75 4.4324 13.7014 4.8996 13.6424 5.32973C13.5397 6.07967 12.9547 6.66474 12.2047 6.76744C11.7746 6.82635 11.3074 6.875 10.9375 6.875C10.5676 6.875 10.1004 6.82635 9.67027 6.76744C8.92033 6.66474 8.33526 6.07967 8.23256 5.32973C8.17365 4.8996 8.125 4.4324 8.125 4.0625C8.125 3.6926 8.17365 3.2254 8.23256 2.79527Z'
        fill='#A1A5B7'
      />
      <path
        d='M1.35756 2.79527C1.46026 2.04533 2.04533 1.46026 2.79527 1.35756C3.2254 1.29865 3.6926 1.25 4.0625 1.25C4.4324 1.25 4.8996 1.29865 5.32973 1.35756C6.07967 1.46026 6.66474 2.04533 6.76744 2.79527C6.82635 3.2254 6.875 3.6926 6.875 4.0625C6.875 4.4324 6.82635 4.8996 6.76744 5.32973C6.66474 6.07967 6.07967 6.66474 5.32973 6.76744C4.8996 6.82635 4.4324 6.875 4.0625 6.875C3.6926 6.875 3.2254 6.82635 2.79527 6.76744C2.04533 6.66474 1.46026 6.07967 1.35756 5.32973C1.29865 4.8996 1.25 4.4324 1.25 4.0625C1.25 3.6926 1.29865 3.2254 1.35756 2.79527Z'
        fill='#A1A5B7'
      />
    </svg>
  );
};

export const FilterIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='14'
      viewBox='0 0 16 14'
      fill='none'>
      <path
        d='M0.246372 1.67492C2.26266 3.83325 5.98581 7.83325 5.98581 7.83325V12.8333C5.98581 13.2916 6.43499 13.6666 6.98398 13.6666H8.98031C9.5293 13.6666 9.97847 13.2916 9.97847 12.8333V7.83325C9.97847 7.83325 13.6916 3.83325 15.7079 1.67492C16.217 1.12492 15.7479 0.333252 14.9194 0.333252H1.03492C0.206445 0.333252 -0.262692 1.12492 0.246372 1.67492Z'
        fill='white'
      />
    </svg>
  );
};

export const StarOutline = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'>
      <path
        d='M7.52447 1.46352C7.67415 1.00287 8.32585 1.00287 8.47553 1.46353L9.68386 5.18237C9.75079 5.38838 9.94277 5.52786 10.1594 5.52786H14.0696C14.554 5.52786 14.7554 6.14767 14.3635 6.43237L11.2001 8.73075C11.0248 8.85807 10.9515 9.08375 11.0184 9.28976L12.2268 13.0086C12.3764 13.4693 11.8492 13.8523 11.4573 13.5676L8.29389 11.2693C8.11865 11.1419 7.88135 11.1419 7.70611 11.2693L4.54267 13.5676C4.15081 13.8523 3.62357 13.4693 3.77325 13.0086L4.98157 9.28976C5.04851 9.08375 4.97518 8.85807 4.79994 8.73075L1.6365 6.43237C1.24464 6.14767 1.44603 5.52786 1.93039 5.52786H5.84062C6.05723 5.52786 6.24921 5.38838 6.31614 5.18237L7.52447 1.46352Z'
        fill='#E0E0E0'
      />
    </svg>
  );
};

export const StarFill = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'>
      <path
        d='M7.52447 1.46352C7.67415 1.00287 8.32585 1.00287 8.47553 1.46353L9.68386 5.18237C9.75079 5.38838 9.94277 5.52786 10.1594 5.52786H14.0696C14.554 5.52786 14.7554 6.14767 14.3635 6.43237L11.2001 8.73075C11.0248 8.85807 10.9515 9.08375 11.0184 9.28976L12.2268 13.0086C12.3764 13.4693 11.8492 13.8523 11.4573 13.5676L8.29389 11.2693C8.11865 11.1419 7.88135 11.1419 7.70611 11.2693L4.54267 13.5676C4.15081 13.8523 3.62357 13.4693 3.77325 13.0086L4.98157 9.28976C5.04851 9.08375 4.97518 8.85807 4.79994 8.73075L1.6365 6.43237C1.24464 6.14767 1.44603 5.52786 1.93039 5.52786H5.84062C6.05723 5.52786 6.24921 5.38838 6.31614 5.18237L7.52447 1.46352Z'
        fill='#F6C000'
      />
    </svg>
  );
};

export const SmallStarFill = () => {
  return (
    <>
      <svg
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M6.52447 0.463524C6.67415 0.00286841 7.32585 0.00286996 7.47553 0.463525L8.68386 4.18237C8.75079 4.38838 8.94277 4.52786 9.15938 4.52786H13.0696C13.554 4.52786 13.7554 5.14767 13.3635 5.43237L10.2001 7.73075C10.0248 7.85807 9.95149 8.08375 10.0184 8.28976L11.2268 12.0086C11.3764 12.4693 10.8492 12.8523 10.4573 12.5676L7.29389 10.2693C7.11865 10.1419 6.88135 10.1419 6.70611 10.2693L3.54267 12.5676C3.15081 12.8523 2.62357 12.4693 2.77325 12.0086L3.98157 8.28976C4.04851 8.08375 3.97518 7.85807 3.79994 7.73075L0.636495 5.43237C0.244639 5.14767 0.446028 4.52786 0.93039 4.52786H4.84062C5.05723 4.52786 5.24921 4.38838 5.31614 4.18237L6.52447 0.463524Z'
          fill='#F7C000'
        />
      </svg>
    </>
  );
};

export const SmallOutFill = () => {
  return (
    <>
      <svg
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M6.52447 0.463524C6.67415 0.00286841 7.32585 0.00286996 7.47553 0.463525L8.68386 4.18237C8.75079 4.38838 8.94277 4.52786 9.15938 4.52786H13.0696C13.554 4.52786 13.7554 5.14767 13.3635 5.43237L10.2001 7.73075C10.0248 7.85807 9.95149 8.08375 10.0184 8.28976L11.2268 12.0086C11.3764 12.4693 10.8492 12.8523 10.4573 12.5676L7.29389 10.2693C7.11865 10.1419 6.88135 10.1419 6.70611 10.2693L3.54267 12.5676C3.15081 12.8523 2.62357 12.4693 2.77325 12.0086L3.98157 8.28976C4.04851 8.08375 3.97518 7.85807 3.79994 7.73075L0.636495 5.43237C0.244639 5.14767 0.446028 4.52786 0.93039 4.52786H4.84062C5.05723 4.52786 5.24921 4.38838 5.31614 4.18237L6.52447 0.463524Z'
          fill='#E0E0E0'
        />
      </svg>
    </>
  );
};

export const FilterPricingIcon = () => {
  return (
    <svg
      width='25'
      height='20'
      viewBox='0 0 25 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g clip-path='url(#clip0_6766_63650)'>
        <path
          d='M4.51329 4.6776C6.57921 6.83594 10.394 10.8359 10.394 10.8359V15.8359C10.394 16.2943 10.8542 16.6693 11.4167 16.6693H13.4622C14.0247 16.6693 14.4849 16.2943 14.4849 15.8359V10.8359C14.4849 10.8359 18.2895 6.83594 20.3554 4.6776C20.877 4.1276 20.3964 3.33594 19.5475 3.33594H5.32125C4.47238 3.33594 3.9917 4.1276 4.51329 4.6776Z'
          fill='white'
        />
      </g>
      <defs>
        <clipPath id='clip0_6766_63650'>
          <rect
            width='24.5456'
            height='20'
            fill='white'
            transform='translate(0.166016)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const GridListIcon = () => {
  return (
    <svg
      width='16'
      height='15'
      viewBox='0 0 16 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M13.1554 1.4138C13.9209 1.47902 14.517 2.04533 14.6213 2.79527C14.6811 3.2254 14.7305 3.6926 14.7305 4.0625C14.7305 4.4324 14.6811 4.8996 14.6213 5.32973C14.517 6.07967 13.9209 6.64598 13.1554 6.7112C12.2099 6.79176 10.6783 6.875 8.38625 6.875C6.09417 6.875 4.56259 6.79176 3.61706 6.7112C2.85157 6.64597 2.25546 6.07967 2.1512 5.32973C2.09141 4.8996 2.04203 4.4324 2.04203 4.0625C2.04203 3.6926 2.09141 3.2254 2.1512 2.79527C2.25546 2.04533 2.85157 1.47902 3.61706 1.4138C4.5626 1.33324 6.09418 1.25 8.38625 1.25C10.6783 1.25 12.2099 1.33324 13.1554 1.4138Z'
        fill='#3699FF'
      />
      <path
        opacity='0.25'
        d='M13.1554 8.2888C13.9209 8.35402 14.517 8.92033 14.6213 9.67027C14.6811 10.1004 14.7305 10.5676 14.7305 10.9375C14.7305 11.3074 14.6811 11.7746 14.6213 12.2047C14.517 12.9547 13.9209 13.521 13.1554 13.5862C12.2099 13.6668 10.6783 13.75 8.38625 13.75C6.09417 13.75 4.56259 13.6668 3.61706 13.5862C2.85157 13.521 2.25546 12.9547 2.1512 12.2047C2.09141 11.7746 2.04203 11.3074 2.04203 10.9375C2.04203 10.5676 2.09141 10.1004 2.1512 9.67027C2.25546 8.92033 2.85157 8.35402 3.61706 8.2888C4.5626 8.20824 6.09418 8.125 8.38625 8.125C10.6783 8.125 12.2099 8.20824 13.1554 8.2888Z'
        fill='#3699FF'
      />
    </svg>
  );
};

export const GridReleaseIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='15'
      viewBox='0 0 16 15'
      fill='none'>
      <path
        opacity='0.25'
        d='M8.58281 9.67027C8.68707 8.92033 9.28096 8.33526 10.0422 8.23256C10.4788 8.17365 10.9531 8.125 11.3285 8.125C11.704 8.125 12.1782 8.17365 12.6149 8.23256C13.3761 8.33526 13.97 8.92033 14.0743 9.67027C14.134 10.1004 14.1834 10.5676 14.1834 10.9375C14.1834 11.3074 14.134 11.7746 14.0743 12.2047C13.97 12.9547 13.3761 13.5397 12.6149 13.6424C12.1782 13.7014 11.704 13.75 11.3285 13.75C10.9531 13.75 10.4788 13.7014 10.0422 13.6424C9.28096 13.5397 8.68707 12.9547 8.58281 12.2047C8.52302 11.7746 8.47363 11.3074 8.47363 10.9375C8.47363 10.5676 8.52302 10.1004 8.58281 9.67027Z'
        fill='#3699FF'
      />
      <path
        opacity='0.25'
        d='M1.6043 9.67027C1.70855 8.92033 2.30244 8.33526 3.06369 8.23256C3.5003 8.17365 3.97454 8.125 4.35002 8.125C4.72549 8.125 5.19973 8.17365 5.63635 8.23256C6.39759 8.33526 6.99148 8.92033 7.09574 9.67027C7.15553 10.1004 7.20492 10.5676 7.20492 10.9375C7.20492 11.3074 7.15553 11.7746 7.09574 12.2047C6.99148 12.9547 6.39759 13.5397 5.63635 13.6424C5.19973 13.7014 4.72549 13.75 4.35002 13.75C3.97454 13.75 3.5003 13.7014 3.06369 13.6424C2.30244 13.5397 1.70855 12.9547 1.6043 12.2047C1.5445 11.7746 1.49512 11.3074 1.49512 10.9375C1.49512 10.5676 1.5445 10.1004 1.6043 9.67027Z'
        fill='#3699FF'
      />
      <path
        opacity='0.25'
        d='M8.58281 2.79527C8.68707 2.04533 9.28096 1.46026 10.0422 1.35756C10.4788 1.29865 10.9531 1.25 11.3285 1.25C11.704 1.25 12.1782 1.29865 12.6149 1.35756C13.3761 1.46026 13.97 2.04533 14.0743 2.79527C14.134 3.2254 14.1834 3.6926 14.1834 4.0625C14.1834 4.4324 14.134 4.8996 14.0743 5.32973C13.97 6.07967 13.3761 6.66474 12.6149 6.76744C12.1782 6.82635 11.704 6.875 11.3285 6.875C10.9531 6.875 10.4788 6.82635 10.0422 6.76744C9.28096 6.66474 8.68707 6.07967 8.58281 5.32973C8.52302 4.8996 8.47363 4.4324 8.47363 4.0625C8.47363 3.6926 8.52302 3.2254 8.58281 2.79527Z'
        fill='#3699FF'
      />
      <path
        d='M1.6043 2.79527C1.70855 2.04533 2.30244 1.46026 3.06369 1.35756C3.5003 1.29865 3.97454 1.25 4.35002 1.25C4.72549 1.25 5.19973 1.29865 5.63635 1.35756C6.39759 1.46026 6.99148 2.04533 7.09574 2.79527C7.15553 3.2254 7.20492 3.6926 7.20492 4.0625C7.20492 4.4324 7.15553 4.8996 7.09574 5.32973C6.99148 6.07967 6.39759 6.66474 5.63635 6.76744C5.19973 6.82635 4.72549 6.875 4.35002 6.875C3.97454 6.875 3.5003 6.82635 3.06369 6.76744C2.30244 6.66474 1.70855 6.07967 1.6043 5.32973C1.5445 4.8996 1.49512 4.4324 1.49512 4.0625C1.49512 3.6926 1.5445 3.2254 1.6043 2.79527Z'
        fill='#3699FF'
      />
    </svg>
  );
};

export const TableGrid = () => {
  return (
    <svg
      width='16'
      height='15'
      viewBox='0 0 16 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        opacity='0.25'
        d='M8.61308 9.67027C8.71734 8.92033 9.31123 8.33526 10.0725 8.23256C10.5091 8.17365 10.9833 8.125 11.3588 8.125C11.7343 8.125 12.2085 8.17365 12.6451 8.23256C13.4064 8.33526 14.0003 8.92033 14.1045 9.67027C14.1643 10.1004 14.2137 10.5676 14.2137 10.9375C14.2137 11.3074 14.1643 11.7746 14.1045 12.2047C14.0003 12.9547 13.4064 13.5397 12.6451 13.6424C12.2085 13.7014 11.7343 13.75 11.3588 13.75C10.9833 13.75 10.5091 13.7014 10.0725 13.6424C9.31123 13.5397 8.71734 12.9547 8.61308 12.2047C8.55329 11.7746 8.50391 11.3074 8.50391 10.9375C8.50391 10.5676 8.55329 10.1004 8.61308 9.67027Z'
        fill='#A1A5B7'
      />
      <path
        opacity='0.25'
        d='M1.63652 9.67027C1.74078 8.92033 2.33467 8.33526 3.09591 8.23256C3.53253 8.17365 4.00677 8.125 4.38224 8.125C4.75772 8.125 5.23196 8.17365 5.66857 8.23256C6.42982 8.33526 7.02371 8.92033 7.12796 9.67027C7.18776 10.1004 7.23714 10.5676 7.23714 10.9375C7.23714 11.3074 7.18776 11.7746 7.12796 12.2047C7.02371 12.9547 6.42982 13.5397 5.66857 13.6424C5.23196 13.7014 4.75772 13.75 4.38224 13.75C4.00677 13.75 3.53253 13.7014 3.09591 13.6424C2.33467 13.5397 1.74078 12.9547 1.63652 12.2047C1.57673 11.7746 1.52734 11.3074 1.52734 10.9375C1.52734 10.5676 1.57673 10.1004 1.63652 9.67027Z'
        fill='#A1A5B7'
      />
      <path
        opacity='0.25'
        d='M8.61308 2.79527C8.71734 2.04533 9.31123 1.46026 10.0725 1.35756C10.5091 1.29865 10.9833 1.25 11.3588 1.25C11.7343 1.25 12.2085 1.29865 12.6451 1.35756C13.4064 1.46026 14.0003 2.04533 14.1045 2.79527C14.1643 3.2254 14.2137 3.6926 14.2137 4.0625C14.2137 4.4324 14.1643 4.8996 14.1045 5.32973C14.0003 6.07967 13.4064 6.66474 12.6451 6.76744C12.2085 6.82635 11.7343 6.875 11.3588 6.875C10.9833 6.875 10.5091 6.82635 10.0725 6.76744C9.31123 6.66474 8.71734 6.07967 8.61308 5.32973C8.55329 4.8996 8.50391 4.4324 8.50391 4.0625C8.50391 3.6926 8.55329 3.2254 8.61308 2.79527Z'
        fill='#A1A5B7'
      />
      <path
        d='M1.63652 2.79527C1.74078 2.04533 2.33467 1.46026 3.09591 1.35756C3.53253 1.29865 4.00677 1.25 4.38224 1.25C4.75772 1.25 5.23196 1.29865 5.66857 1.35756C6.42982 1.46026 7.02371 2.04533 7.12796 2.79527C7.18776 3.2254 7.23714 3.6926 7.23714 4.0625C7.23714 4.4324 7.18776 4.8996 7.12796 5.32973C7.02371 6.07967 6.42982 6.66474 5.66857 6.76744C5.23196 6.82635 4.75772 6.875 4.38224 6.875C4.00677 6.875 3.53253 6.82635 3.09591 6.76744C2.33467 6.66474 1.74078 6.07967 1.63652 5.32973C1.57673 4.8996 1.52734 4.4324 1.52734 4.0625C1.52734 3.6926 1.57673 3.2254 1.63652 2.79527Z'
        fill='#A1A5B7'
      />
    </svg>
  );
};

export const CancleIcon = () => {
  return (
    <svg
      width='26'
      height='25'
      viewBox='0 0 26 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <rect
        width='25.1645'
        height='25'
        rx='4.97368'
        fill='#EB5757'
        fill-opacity='0.25'
      />
      <path
        d='M19.0618 6.02344L6.10156 18.9837'
        stroke='#EB5757'
        stroke-width='3.60006'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M19.0618 18.9837L6.10156 6.02344'
        stroke='#EB5757'
        stroke-width='3.60006'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
};

export const TickIcon = () => {
  return (
    <svg
      width='26'
      height='25'
      viewBox='0 0 26 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <rect
        x='0.0849609'
        width='25.1645'
        height='25'
        rx='4.97368'
        fill='#219653'
        fill-opacity='0.25'
      />
      <path
        d='M20.3926 7.35156L10.0918 17.6523L4.94141 12.502'
        stroke='#219653'
        stroke-width='3.67885'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
};

export const Close = props => {
  return (
    <svg
      {...props}
      width='36'
      height='36'
      viewBox='0 0 36 36'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        opacity='0.8'
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M3.55349 9.81276C3.98869 6.51756 6.51757 3.98869 9.81276 3.55349C12.0781 3.2543 14.9119 3 18 3C21.0881 3 23.9219 3.2543 26.1872 3.55349C29.4824 3.98869 32.0113 6.51757 32.4465 9.81276C32.7457 12.0781 33 14.9119 33 18C33 21.0881 32.7457 23.9219 32.4465 26.1872C32.0113 29.4824 29.4824 32.0113 26.1872 32.4465C23.9219 32.7457 21.0881 33 18 33C14.9119 33 12.0781 32.7457 9.81276 32.4465C6.51756 32.0113 3.98869 29.4824 3.55349 26.1872C3.2543 23.9219 3 21.0881 3 18C3 14.9119 3.2543 12.0781 3.55349 9.81276Z'
        fill='white'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M12.4393 12.4393C13.0251 11.8536 13.9749 11.8536 14.5607 12.4393L18 15.8787L21.4393 12.4393C22.0251 11.8536 22.9749 11.8536 23.5607 12.4393C24.1464 13.0251 24.1464 13.9749 23.5607 14.5607L20.1213 18L23.5607 21.4393C24.1464 22.0251 24.1464 22.9749 23.5607 23.5607C22.9749 24.1464 22.0251 24.1464 21.4393 23.5607L18 20.1213L14.5607 23.5607C13.9749 24.1464 13.0251 24.1464 12.4393 23.5607C11.8536 22.9749 11.8536 22.0251 12.4393 21.4393L15.8787 18L12.4393 14.5607C11.8536 13.9749 11.8536 13.0251 12.4393 12.4393Z'
        fill='#3699FF'
      />
    </svg>
  );
};

export const AssetPopupClose = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        opacity='0.25'
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M2.36899 6.54184C2.65912 4.34504 4.34504 2.65912 6.54184 2.36899C8.05208 2.16953 9.94127 2 12 2C14.0587 2 15.9479 2.16953 17.4582 2.36899C19.655 2.65912 21.3409 4.34504 21.631 6.54184C21.8305 8.05208 22 9.94128 22 12C22 14.0587 21.8305 15.9479 21.631 17.4582C21.3409 19.655 19.655 21.3409 17.4582 21.631C15.9479 21.8305 14.0587 22 12 22C9.94127 22 8.05208 21.8305 6.54184 21.631C4.34504 21.3409 2.65912 19.655 2.36899 17.4582C2.16953 15.9479 2 14.0587 2 12C2 9.94128 2.16953 8.05208 2.36899 6.54184Z'
        fill='white'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M8.29289 8.29338C8.68342 7.90286 9.31658 7.90286 9.70711 8.29338L12 10.5863L14.2929 8.29338C14.6834 7.90286 15.3166 7.90286 15.7071 8.29338C16.0976 8.68391 16.0976 9.31707 15.7071 9.7076L13.4142 12.0005L15.7071 14.2934C16.0976 14.6839 16.0976 15.3171 15.7071 15.7076C15.3166 16.0981 14.6834 16.0981 14.2929 15.7076L12 13.4147L9.70711 15.7076C9.31658 16.0981 8.68342 16.0981 8.29289 15.7076C7.90237 15.3171 7.90237 14.6839 8.29289 14.2934L10.5858 12.0005L8.29289 9.7076C7.90237 9.31707 7.90237 8.68391 8.29289 8.29338Z'
        fill='#3699FF'
      />
    </svg>
  );
};

export const SearchFilter = () => {
  return (
    <svg
      width='38'
      height='24'
      viewBox='0 0 38 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <rect width='38' height='24' rx='6' fill='#3699FF' />
      <g clip-path='url(#clip0_6766_70736)'>
        <path
          d='M11.7594 6.52495C13.5462 8.61366 16.8454 12.4846 16.8454 12.4846V17.3233C16.8454 17.7669 17.2435 18.1298 17.7299 18.1298H19.499C19.9855 18.1298 20.3835 17.7669 20.3835 17.3233V12.4846C20.3835 12.4846 23.6739 8.61366 25.4606 6.52495C25.9117 5.99269 25.496 5.22656 24.7619 5.22656H12.4582C11.7241 5.22656 11.3083 5.99269 11.7594 6.52495Z'
          fill='white'
        />
      </g>
      <defs>
        <clipPath id='clip0_6766_70736'>
          <rect
            width='21.2285'
            height='19.3548'
            fill='white'
            transform='translate(8 2)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ArrowsIcon = props => {
  return (
    // <svg
    //   width="20"
    //   height="24"
    //   viewBox="0 0 20 14"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    //   {...props}
    // >
    //   <path
    //     d="M7.01 9H0V11H7.01V14L11 10L7.01 6V9ZM12.99 8V5H20V3H12.99V0L9 4L12.99 8Z"
    //     fill={props.style?.color}
    //   />
    // </svg>
    <svg
      {...props}
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g clip-path='url(#clip0_6766_60958)'>
        <path
          d='M9.01 14H2V16H9.01V19L13 15L9.01 11V14ZM14.99 13V10H22V8H14.99V5L11 9L14.99 13Z'
          fill={props.style?.color}
        />
      </g>
      <defs>
        <clipPath id='clip0_6766_60958'>
          <rect width='24' height='24' fill={props.style?.color} />
        </clipPath>
      </defs>
    </svg>
  );
};

export const DropdowArrow = () => {
  return (
    <svg
      width='14'
      height='12'
      viewBox='0 0 14 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M6.52056 9.7845C6.57407 9.85112 6.64568 9.90559 6.72921 9.94322C6.81274 9.98086 6.90569 10.0005 7.00005 10.0005C7.09442 10.0005 7.18737 9.98086 7.2709 9.94322C7.35443 9.90559 7.42604 9.85112 7.47955 9.7845L12.7296 3.2845C12.7903 3.20953 12.826 3.12172 12.8326 3.0306C12.8392 2.93949 12.8166 2.84856 12.7672 2.7677C12.7177 2.68683 12.6434 2.61912 12.5522 2.57193C12.4611 2.52473 12.3566 2.49986 12.2501 2.5H1.75005C1.6438 2.50038 1.53967 2.52557 1.44887 2.57288C1.35807 2.62019 1.28403 2.68782 1.23472 2.7685C1.18541 2.84917 1.16269 2.93985 1.169 3.03077C1.17532 3.12168 1.21043 3.20941 1.27055 3.2845L6.52056 9.7845Z'
        fill='white'
      />
    </svg>
  );
};

export const Copy = () => {
  return (
    <svg
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g clip-path='url(#clip0_6766_67406)'>
        <path
          d='M12 0.75H3C2.175 0.75 1.5 1.425 1.5 2.25V12.75H3V2.25H12V0.75ZM11.25 3.75L15.75 8.25V15.75C15.75 16.575 15.075 17.25 14.25 17.25H5.9925C5.1675 17.25 4.5 16.575 4.5 15.75L4.5075 5.25C4.5075 4.425 5.175 3.75 6 3.75H11.25ZM10.5 9H14.625L10.5 4.875V9Z'
          fill='#3699FF'
        />
      </g>
      <defs>
        <clipPath id='clip0_6766_67406'>
          <rect width='18' height='18' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const PasswordConfirm = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='172'
      height='124'
      viewBox='0 0 172 124'
      fill='none'>
      <circle
        opacity='0.25'
        cx='74.1301'
        cy='61.1057'
        r='48.6955'
        fill='#3699FF'
      />
      <path
        d='M47.145 58.9001L72.7733 84.0538L139.692 9.30469'
        stroke='#3699FF'
        stroke-width='6.88571'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M122.664 48.6125C125.846 60.4887 124.571 73.1189 119.079 84.1193C113.587 95.1196 104.258 103.729 92.8537 108.323C81.4489 112.916 68.7571 113.176 57.1738 109.053C45.5906 104.93 35.9172 96.7098 29.9796 85.9435C24.042 75.1771 22.2509 62.6096 24.9443 50.6132C27.6378 38.6167 34.6295 28.0211 44.5997 20.8264C54.57 13.6317 66.829 10.3355 79.063 11.5601C91.297 12.7846 102.66 18.4452 111.006 27.4733'
        stroke='#3699FF'
        stroke-width='8'
        stroke-linecap='round'
      />
      <circle cx='165.007' cy='37.8478' r='6.20325' fill='#3699FF' />
      <circle cx='155.703' cy='23.5743' r='3.10162' fill='#3699FF' />
      <circle
        cx='6.20325'
        cy='62.0392'
        r='4.70325'
        stroke='#3699FF'
        stroke-width='3'
      />
    </svg>
  );
};

export const FilterArrow = ({ color = "#7E8299" }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='16'
      viewBox='0 0 18 16'
      fill='none'>
      <path
        d='M0.668031 3.75834C0.668024 3.67665 0.684246 3.59578 0.715756 3.52041C0.747267 3.44505 0.793437 3.37669 0.851585 3.31932C0.909733 3.26195 0.978701 3.2167 1.05448 3.1862C1.13027 3.15571 1.21135 3.14057 1.29303 3.14167H4.2347C4.39006 2.34465 4.8367 1.63407 5.48753 1.14847C6.13835 0.662877 6.94671 0.437087 7.75497 0.515129C8.56323 0.593171 9.31346 0.96945 9.85935 1.57059C10.4052 2.17174 10.7077 2.95465 10.7077 3.76667C10.7077 4.5787 10.4052 5.36161 9.85935 5.96275C9.31346 6.5639 8.56323 6.94018 7.75497 7.01822C6.94671 7.09626 6.13835 6.87047 5.48753 6.38488C4.8367 5.89928 4.39006 5.18869 4.2347 4.39167H1.31803C1.23317 4.39508 1.1485 4.38115 1.0692 4.35075C0.989904 4.32034 0.917633 4.27409 0.856803 4.21482C0.795974 4.15555 0.747862 4.08451 0.715406 4.00602C0.68295 3.92754 0.666831 3.84326 0.668031 3.75834ZM12.0014 4.39167H16.6514C16.7389 4.3999 16.8272 4.38955 16.9105 4.36131C16.9938 4.33307 17.0702 4.28758 17.1346 4.22781C17.1991 4.16803 17.2503 4.09532 17.2848 4.01442C17.3192 3.93352 17.3363 3.84626 17.3347 3.75834C17.3347 3.67665 17.3185 3.59578 17.287 3.52041C17.2555 3.44505 17.2093 3.37669 17.1511 3.31932C17.093 3.26195 17.024 3.2167 16.9482 3.1862C16.8725 3.15571 16.7914 3.14057 16.7097 3.14167H12.0264C11.9443 3.14276 11.8632 3.16001 11.7878 3.19242C11.7124 3.22484 11.6441 3.2718 11.5868 3.33061C11.5296 3.38942 11.4845 3.45894 11.4541 3.53519C11.4237 3.61144 11.4086 3.69293 11.4097 3.77501C11.4097 3.8567 11.4259 3.93757 11.4574 4.01294C11.4889 4.0883 11.5351 4.15666 11.5933 4.21403C11.6514 4.2714 11.7204 4.31665 11.7962 4.34715C11.8719 4.37764 11.953 4.39278 12.0347 4.39167H12.0014ZM16.643 11.6H13.768C13.6127 10.803 13.166 10.0924 12.5152 9.60681C11.8644 9.12121 11.056 8.89542 10.2478 8.97346C9.4395 9.05151 8.68927 9.42778 8.14338 10.0289C7.59748 10.6301 7.29504 11.413 7.29504 12.225C7.29504 13.037 7.59748 13.8199 8.14338 14.4211C8.68927 15.0222 9.4395 15.3985 10.2478 15.4766C11.056 15.5546 11.8644 15.3288 12.5152 14.8432C13.166 14.3576 13.6127 13.647 13.768 12.85H16.6847C16.7668 12.8489 16.8478 12.8317 16.9232 12.7993C16.9987 12.7668 17.0669 12.7199 17.1242 12.6611C17.1815 12.6023 17.2266 12.5327 17.257 12.4565C17.2874 12.3802 17.3025 12.2988 17.3014 12.2167C17.3014 12.135 17.2851 12.0541 17.2536 11.9787C17.2221 11.9034 17.176 11.835 17.1178 11.7777C17.0597 11.7203 16.9907 11.675 16.9149 11.6445C16.8391 11.614 16.758 11.5989 16.6764 11.6H16.643ZM5.94303 11.6H1.32636C1.24468 11.5989 1.1636 11.614 1.08782 11.6445C1.01203 11.675 0.943067 11.7203 0.884918 11.7777C0.82677 11.835 0.7806 11.9034 0.74909 11.9787C0.71758 12.0541 0.701357 12.135 0.701365 12.2167C0.700263 12.2988 0.71534 12.3802 0.745736 12.4565C0.776131 12.5327 0.821249 12.6023 0.878514 12.6611C0.935778 12.7199 1.00407 12.7668 1.07948 12.7993C1.15489 12.8317 1.23595 12.8489 1.31803 12.85H5.96803C6.13379 12.85 6.29276 12.7842 6.40997 12.667C6.52718 12.5497 6.59303 12.3908 6.59303 12.225C6.59415 12.1437 6.57897 12.063 6.54838 11.9877C6.51778 11.9124 6.4724 11.8439 6.41491 11.7865C6.35742 11.729 6.289 11.6836 6.21367 11.653C6.13835 11.6224 6.05766 11.6072 5.97636 11.6083L5.94303 11.6Z'
        fill={color}
      />
    </svg>
  );
};
export const ProductOwnedFilterIcon = () => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M1.66803 5.75834C1.66802 5.67665 1.68425 5.59578 1.71576 5.52041C1.74727 5.44505 1.79344 5.37669 1.85158 5.31932C1.90973 5.26195 1.9787 5.2167 2.05448 5.1862C2.13027 5.15571 2.21135 5.14057 2.29303 5.14167H5.2347C5.39006 4.34465 5.8367 3.63407 6.48753 3.14847C7.13835 2.66288 7.94671 2.43709 8.75497 2.51513C9.56323 2.59317 10.3135 2.96945 10.8594 3.57059C11.4052 4.17174 11.7077 4.95465 11.7077 5.76667C11.7077 6.5787 11.4052 7.36161 10.8594 7.96275C10.3135 8.5639 9.56323 8.94018 8.75497 9.01822C7.94671 9.09626 7.13835 8.87047 6.48753 8.38488C5.8367 7.89928 5.39006 7.18869 5.2347 6.39167H2.31803C2.23317 6.39508 2.1485 6.38115 2.0692 6.35075C1.9899 6.32034 1.91763 6.27409 1.8568 6.21482C1.79597 6.15555 1.74786 6.08451 1.71541 6.00602C1.68295 5.92754 1.66683 5.84326 1.66803 5.75834ZM13.0014 6.39167H17.6514C17.7389 6.3999 17.8272 6.38955 17.9105 6.36131C17.9938 6.33307 18.0702 6.28758 18.1346 6.22781C18.1991 6.16803 18.2503 6.09532 18.2848 6.01442C18.3192 5.93352 18.3363 5.84626 18.3347 5.75834C18.3347 5.67665 18.3185 5.59578 18.287 5.52041C18.2555 5.44505 18.2093 5.37669 18.1511 5.31932C18.093 5.26195 18.024 5.2167 17.9482 5.1862C17.8725 5.15571 17.7914 5.14057 17.7097 5.14167H13.0264C12.9443 5.14276 12.8632 5.16001 12.7878 5.19242C12.7124 5.22484 12.6441 5.2718 12.5868 5.33061C12.5296 5.38942 12.4845 5.45894 12.4541 5.53519C12.4237 5.61144 12.4086 5.69293 12.4097 5.77501C12.4097 5.8567 12.4259 5.93757 12.4574 6.01294C12.4889 6.0883 12.5351 6.15666 12.5933 6.21403C12.6514 6.2714 12.7204 6.31665 12.7962 6.34715C12.8719 6.37764 12.953 6.39278 13.0347 6.39167H13.0014ZM17.643 13.6H14.768C14.6127 12.803 14.166 12.0924 13.5152 11.6068C12.8644 11.1212 12.056 10.8954 11.2478 10.9735C10.4395 11.0515 9.68927 11.4278 9.14338 12.0289C8.59748 12.6301 8.29504 13.413 8.29504 14.225C8.29504 15.037 8.59748 15.8199 9.14338 16.4211C9.68927 17.0222 10.4395 17.3985 11.2478 17.4766C12.056 17.5546 12.8644 17.3288 13.5152 16.8432C14.166 16.3576 14.6127 15.647 14.768 14.85H17.6847C17.7668 14.8489 17.8478 14.8317 17.9232 14.7993C17.9987 14.7668 18.067 14.7199 18.1242 14.6611C18.1815 14.6023 18.2266 14.5327 18.257 14.4565C18.2874 14.3802 18.3025 14.2988 18.3014 14.2167C18.3014 14.135 18.2851 14.0541 18.2536 13.9787C18.2221 13.9034 18.176 13.835 18.1178 13.7777C18.0597 13.7203 17.9907 13.675 17.9149 13.6445C17.8391 13.614 17.758 13.5989 17.6764 13.6H17.643ZM6.94303 13.6H2.32636C2.24468 13.5989 2.1636 13.614 2.08782 13.6445C2.01203 13.675 1.94307 13.7203 1.88492 13.7777C1.82677 13.835 1.7806 13.9034 1.74909 13.9787C1.71758 14.0541 1.70136 14.135 1.70136 14.2167C1.70026 14.2988 1.71534 14.3802 1.74574 14.4565C1.77613 14.5327 1.82125 14.6023 1.87851 14.6611C1.93578 14.7199 2.00407 14.7668 2.07948 14.7993C2.15489 14.8317 2.23595 14.8489 2.31803 14.85H6.96803C7.13379 14.85 7.29276 14.7842 7.40997 14.667C7.52718 14.5497 7.59303 14.3908 7.59303 14.225C7.59415 14.1437 7.57897 14.063 7.54837 13.9877C7.51778 13.9124 7.4724 13.8439 7.41491 13.7865C7.35742 13.729 7.289 13.6836 7.21367 13.653C7.13835 13.6224 7.05766 13.6072 6.97636 13.6083L6.94303 13.6Z'
        fill='#7E8299'
      />
    </svg>
  );
};

export const ShieldCross = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='17'
      viewBox='0 0 16 17'
      fill='none'>
      <path
        opacity='0.3'
        d='M6.56602 14.654L3.50602 12.154C3.24436 11.9427 3.03316 11.6756 2.88784 11.3723C2.74252 11.069 2.66674 10.737 2.66602 10.4007V5.5007C2.66626 5.06539 2.79222 4.63942 3.02875 4.27398C3.26528 3.90854 3.60232 3.61919 3.99935 3.4407L7.06602 2.0407C7.36102 1.90577 7.68162 1.83594 8.00602 1.83594C8.33041 1.83594 8.65101 1.90577 8.94602 2.0407L11.9993 3.4407C12.3964 3.61919 12.7334 3.90854 12.9699 4.27398C13.2065 4.63942 13.3324 5.06539 13.3327 5.5007V10.4007C13.3328 10.7365 13.258 11.0681 13.1139 11.3714C12.9697 11.6747 12.7598 11.942 12.4993 12.154L9.43935 14.654C9.03527 14.9884 8.52719 15.1714 8.00268 15.1714C7.47817 15.1714 6.97009 14.9884 6.56602 14.654Z'
        fill='white'
      />
      <path
        d='M9.33339 10.3006C9.26923 10.3013 9.20557 10.2892 9.14607 10.2652C9.08658 10.2412 9.03242 10.2056 8.98672 10.1606L6.32005 7.55394C6.22642 7.46019 6.17383 7.3331 6.17383 7.2006C6.17383 7.0681 6.22642 6.94102 6.32005 6.84727C6.41576 6.75481 6.54364 6.70312 6.67672 6.70312C6.8098 6.70312 6.93768 6.75481 7.03339 6.84727L9.70006 9.45394C9.79369 9.54769 9.84628 9.67477 9.84628 9.80727C9.84628 9.93977 9.79369 10.0669 9.70006 10.1606C9.65132 10.2072 9.59379 10.2435 9.53083 10.2675C9.46787 10.2916 9.40075 10.3028 9.33339 10.3006Z'
        fill='white'
      />
      <path
        d='M6.66638 10.3021C6.59968 10.3026 6.53354 10.2899 6.47176 10.2647C6.40998 10.2395 6.35378 10.2024 6.30638 10.1555C6.21275 10.0617 6.16016 9.93462 6.16016 9.80212C6.16016 9.66962 6.21275 9.54254 6.30638 9.44879L8.97305 6.84212C9.01539 6.78041 9.07104 6.72899 9.13591 6.69166C9.20077 6.65432 9.27318 6.63203 9.34781 6.62641C9.42244 6.62079 9.49737 6.632 9.56709 6.65921C9.63681 6.68641 9.69953 6.72892 9.75064 6.7836C9.80174 6.83827 9.83991 6.90373 9.86234 6.97512C9.88478 7.04652 9.8909 7.12204 9.88025 7.19612C9.86961 7.2702 9.84247 7.34094 9.80084 7.40313C9.75921 7.46532 9.70415 7.51738 9.63972 7.55545L6.97305 10.1621C6.8895 10.242 6.78145 10.2913 6.66638 10.3021Z'
        fill='white'
      />
    </svg>
  );
};
export const ProductOwnedGridView = () => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        opacity='0.25'
        d='M10.9754 12.8924C11.1124 11.8925 11.8925 11.1124 12.8924 10.9754C13.4659 10.8969 14.0888 10.832 14.582 10.832C15.0752 10.832 15.6982 10.8969 16.2717 10.9754C17.2716 11.1124 18.0517 11.8925 18.1886 12.8924C18.2672 13.4659 18.332 14.0888 18.332 14.582C18.332 15.0752 18.2672 15.6982 18.1886 16.2717C18.0517 17.2716 17.2716 18.0517 16.2717 18.1886C15.6982 18.2672 15.0752 18.332 14.582 18.332C14.0888 18.332 13.4659 18.2672 12.8924 18.1886C11.8925 18.0517 11.1124 17.2716 10.9754 16.2717C10.8969 15.6982 10.832 15.0752 10.832 14.582C10.832 14.0888 10.8969 13.4659 10.9754 12.8924Z'
        fill='#3699FF'
      />
      <path
        opacity='0.25'
        d='M1.81138 12.8924C1.94832 11.8925 2.72841 11.1124 3.72833 10.9754C4.30184 10.8969 4.92477 10.832 5.41797 10.832C5.91117 10.832 6.5341 10.8969 7.10761 10.9754C8.10752 11.1124 8.88762 11.8925 9.02456 12.8924C9.1031 13.4659 9.16797 14.0888 9.16797 14.582C9.16797 15.0752 9.1031 15.6982 9.02456 16.2717C8.88762 17.2716 8.10752 18.0517 7.10761 18.1886C6.5341 18.2672 5.91117 18.332 5.41797 18.332C4.92477 18.332 4.30184 18.2672 3.72833 18.1886C2.72841 18.0517 1.94832 17.2716 1.81138 16.2717C1.73283 15.6982 1.66797 15.0752 1.66797 14.582C1.66797 14.0888 1.73283 13.4659 1.81138 12.8924Z'
        fill='#3699FF'
      />
      <path
        opacity='0.25'
        d='M10.9754 3.72833C11.1124 2.72841 11.8925 1.94832 12.8924 1.81138C13.4659 1.73283 14.0888 1.66797 14.582 1.66797C15.0752 1.66797 15.6982 1.73283 16.2717 1.81138C17.2716 1.94832 18.0517 2.72841 18.1886 3.72833C18.2672 4.30184 18.332 4.92477 18.332 5.41797C18.332 5.91117 18.2672 6.5341 18.1886 7.10761C18.0517 8.10752 17.2716 8.88762 16.2717 9.02456C15.6982 9.1031 15.0752 9.16797 14.582 9.16797C14.0888 9.16797 13.4659 9.1031 12.8924 9.02456C11.8925 8.88762 11.1124 8.10752 10.9754 7.10761C10.8969 6.5341 10.832 5.91117 10.832 5.41797C10.832 4.92477 10.8969 4.30184 10.9754 3.72833Z'
        fill='#3699FF'
      />
      <path
        d='M1.81138 3.72833C1.94832 2.72841 2.72841 1.94832 3.72833 1.81138C4.30184 1.73283 4.92477 1.66797 5.41797 1.66797C5.91117 1.66797 6.5341 1.73283 7.10761 1.81138C8.10752 1.94832 8.88762 2.72841 9.02456 3.72833C9.1031 4.30184 9.16797 4.92477 9.16797 5.41797C9.16797 5.91117 9.1031 6.5341 9.02456 7.10761C8.88762 8.10752 8.10752 8.88762 7.10761 9.02456C6.5341 9.1031 5.91117 9.16797 5.41797 9.16797C4.92477 9.16797 4.30184 9.1031 3.72833 9.02456C2.72841 8.88762 1.94832 8.10752 1.81138 7.10761C1.73283 6.5341 1.66797 5.91117 1.66797 5.41797C1.66797 4.92477 1.73283 4.30184 1.81138 3.72833Z'
        fill='#3699FF'
      />
    </svg>
  );
};

export const ListHide = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='15'
      height='15'
      viewBox='0 0 20 20'
      fill='none'>
      <path
        d='M16.2632 1.88637C17.2687 1.97334 18.0517 2.72841 18.1886 3.72833C18.2672 4.30184 18.332 4.92477 18.332 5.41797C18.332 5.91117 18.2672 6.5341 18.1886 7.10761C18.0517 8.10752 17.2687 8.8626 16.2632 8.94956C15.0212 9.05698 13.0094 9.16797 9.9987 9.16797C6.98799 9.16797 4.97621 9.05698 3.73422 8.94956C2.72872 8.8626 1.94572 8.10752 1.80877 7.1076C1.73023 6.5341 1.66537 5.91117 1.66537 5.41797C1.66537 4.92477 1.73023 4.30184 1.80877 3.72833C1.94572 2.72841 2.72872 1.97333 3.73422 1.88637C4.97621 1.77896 6.98799 1.66797 9.9987 1.66797C13.0094 1.66797 15.0212 1.77896 16.2632 1.88637Z'
        fill='#979797'
      />
      <path
        opacity='0.25'
        d='M16.2632 11.0504C17.2687 11.1374 18.0517 11.8925 18.1886 12.8924C18.2672 13.4659 18.332 14.0888 18.332 14.582C18.332 15.0752 18.2672 15.6982 18.1886 16.2717C18.0517 17.2716 17.2687 18.0267 16.2632 18.1136C15.0212 18.221 13.0094 18.332 9.9987 18.332C6.98799 18.332 4.97621 18.221 3.73422 18.1136C2.72872 18.0267 1.94572 17.2716 1.80877 16.2717C1.73023 15.6982 1.66537 15.0752 1.66537 14.582C1.66537 14.0888 1.73023 13.4659 1.80877 12.8924C1.94572 11.8925 2.72872 11.1374 3.73422 11.0504C4.97621 10.943 6.98799 10.832 9.9987 10.832C13.0094 10.832 15.0212 10.943 16.2632 11.0504Z'
        fill='#979797'
      />
    </svg>
  );
};
export const ProductOwnedListView = () => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M16.2632 1.88637C17.2687 1.97334 18.0517 2.72841 18.1886 3.72833C18.2672 4.30184 18.332 4.92477 18.332 5.41797C18.332 5.91117 18.2672 6.5341 18.1886 7.10761C18.0517 8.10752 17.2687 8.8626 16.2632 8.94956C15.0212 9.05698 13.0094 9.16797 9.9987 9.16797C6.98799 9.16797 4.97621 9.05698 3.73422 8.94956C2.72872 8.8626 1.94572 8.10752 1.80878 7.1076C1.73023 6.5341 1.66536 5.91117 1.66536 5.41797C1.66536 4.92477 1.73023 4.30184 1.80878 3.72833C1.94572 2.72841 2.72872 1.97333 3.73422 1.88637C4.97621 1.77896 6.98799 1.66797 9.9987 1.66797C13.0094 1.66797 15.0212 1.77896 16.2632 1.88637Z'
        fill='#979797'
      />
      <path
        opacity='0.25'
        d='M16.2632 11.0504C17.2687 11.1374 18.0517 11.8925 18.1886 12.8924C18.2672 13.4659 18.332 14.0888 18.332 14.582C18.332 15.0752 18.2672 15.6982 18.1886 16.2717C18.0517 17.2716 17.2687 18.0267 16.2632 18.1136C15.0212 18.221 13.0094 18.332 9.9987 18.332C6.98799 18.332 4.97621 18.221 3.73422 18.1136C2.72872 18.0267 1.94572 17.2716 1.80878 16.2717C1.73023 15.6982 1.66536 15.0752 1.66536 14.582C1.66536 14.0888 1.73023 13.4659 1.80878 12.8924C1.94572 11.8925 2.72872 11.1374 3.73422 11.0504C4.97621 10.943 6.98799 10.832 9.9987 10.832C13.0094 10.832 15.0212 10.943 16.2632 11.0504Z'
        fill='#979797'
      />
    </svg>
  );
};

export const GridShow = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='15'
      height='15'
      viewBox='0 0 20 20'
      fill='none'>
      <path
        opacity='0.25'
        d='M10.9754 12.8924C11.1124 11.8925 11.8925 11.1124 12.8924 10.9754C13.4659 10.8969 14.0888 10.832 14.582 10.832C15.0752 10.832 15.6982 10.8969 16.2717 10.9754C17.2716 11.1124 18.0517 11.8925 18.1886 12.8924C18.2672 13.4659 18.332 14.0888 18.332 14.582C18.332 15.0752 18.2672 15.6982 18.1886 16.2717C18.0517 17.2716 17.2716 18.0517 16.2717 18.1886C15.6982 18.2672 15.0752 18.332 14.582 18.332C14.0888 18.332 13.4659 18.2672 12.8924 18.1886C11.8925 18.0517 11.1124 17.2716 10.9754 16.2717C10.8969 15.6982 10.832 15.0752 10.832 14.582C10.832 14.0888 10.8969 13.4659 10.9754 12.8924Z'
        fill='#3699FF'
      />
      <path
        opacity='0.25'
        d='M1.81138 12.8924C1.94832 11.8925 2.72841 11.1124 3.72833 10.9754C4.30184 10.8969 4.92477 10.832 5.41797 10.832C5.91117 10.832 6.5341 10.8969 7.10761 10.9754C8.10752 11.1124 8.88762 11.8925 9.02456 12.8924C9.1031 13.4659 9.16797 14.0888 9.16797 14.582C9.16797 15.0752 9.1031 15.6982 9.02456 16.2717C8.88762 17.2716 8.10752 18.0517 7.10761 18.1886C6.5341 18.2672 5.91117 18.332 5.41797 18.332C4.92477 18.332 4.30184 18.2672 3.72833 18.1886C2.72841 18.0517 1.94832 17.2716 1.81138 16.2717C1.73283 15.6982 1.66797 15.0752 1.66797 14.582C1.66797 14.0888 1.73283 13.4659 1.81138 12.8924Z'
        fill='#3699FF'
      />
      <path
        opacity='0.25'
        d='M10.9754 3.72833C11.1124 2.72841 11.8925 1.94832 12.8924 1.81138C13.4659 1.73283 14.0888 1.66797 14.582 1.66797C15.0752 1.66797 15.6982 1.73283 16.2717 1.81138C17.2716 1.94832 18.0517 2.72841 18.1886 3.72833C18.2672 4.30184 18.332 4.92477 18.332 5.41797C18.332 5.91117 18.2672 6.5341 18.1886 7.10761C18.0517 8.10752 17.2716 8.88762 16.2717 9.02456C15.6982 9.1031 15.0752 9.16797 14.582 9.16797C14.0888 9.16797 13.4659 9.1031 12.8924 9.02456C11.8925 8.88762 11.1124 8.10752 10.9754 7.10761C10.8969 6.5341 10.832 5.91117 10.832 5.41797C10.832 4.92477 10.8969 4.30184 10.9754 3.72833Z'
        fill='#3699FF'
      />
      <path
        d='M1.81138 3.72833C1.94832 2.72841 2.72841 1.94832 3.72833 1.81138C4.30184 1.73283 4.92477 1.66797 5.41797 1.66797C5.91117 1.66797 6.5341 1.73283 7.10761 1.81138C8.10752 1.94832 8.88762 2.72841 9.02456 3.72833C9.1031 4.30184 9.16797 4.92477 9.16797 5.41797C9.16797 5.91117 9.1031 6.5341 9.02456 7.10761C8.88762 8.10752 8.10752 8.88762 7.10761 9.02456C6.5341 9.1031 5.91117 9.16797 5.41797 9.16797C4.92477 9.16797 4.30184 9.1031 3.72833 9.02456C2.72841 8.88762 1.94832 8.10752 1.81138 7.10761C1.73283 6.5341 1.66797 5.91117 1.66797 5.41797C1.66797 4.92477 1.73283 4.30184 1.81138 3.72833Z'
        fill='#3699FF'
      />
    </svg>
  );
};

export const DeleteIcon = () => {
  return (
    <>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='13'
        height='16'
        viewBox='0 0 13 16'
        fill='none'>
        <path
          d='M1.30859 4.21094V14.5004C1.30859 15.3288 1.98017 16.0004 2.80859 16.0004H9.91381C10.7422 16.0004 11.4138 15.3288 11.4138 14.5004V4.21094H1.30859Z'
          fill='#EB5757'
        />
        <path
          opacity='0.3'
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M8.04375 1.26315V1C8.04375 0.447715 7.59604 0 7.04375 0H5.67535C5.12306 0 4.67535 0.447715 4.67535 1V1.26315H0.964844C0.688701 1.26315 0.464844 1.48701 0.464844 1.76315V2.0263C0.464844 2.30245 0.688701 2.5263 0.964844 2.5263H11.7543C12.0304 2.5263 12.2543 2.30245 12.2543 2.0263V1.76315C12.2543 1.48701 12.0304 1.26315 11.7543 1.26315H8.04375Z'
          fill='#EB5757'
        />
      </svg>
    </>
  );
};

export const UploadIcon = ({ width = "65", height = "65" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 65 65'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M21.8672 21.25L32.3672 10.75L42.8672 21.25'
        stroke='black'
        stroke-width='4'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M32.3672 38.75V10.75'
        stroke='black'
        stroke-width='4'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M54.3672 38.75V52.75C54.3672 53.2804 54.1565 53.7891 53.7814 54.1642C53.4063 54.5393 52.8976 54.75 52.3672 54.75H12.3672C11.8368 54.75 11.328 54.5393 10.953 54.1642C10.5779 53.7891 10.3672 53.2804 10.3672 52.75V38.75'
        stroke='black'
        stroke-width='4'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
};

export const Delete = ({ color = "#EB5757", opacity = "0.3", size = "16" }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 13 16'
      fill={color}>
      <path
        d='M1.30859 4.21094V14.5004C1.30859 15.3288 1.98017 16.0004 2.80859 16.0004H9.91381C10.7422 16.0004 11.4138 15.3288 11.4138 14.5004V4.21094H1.30859Z'
        fill={color}
      />
      <path
        opacity={opacity}
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M8.04375 1.26315V1C8.04375 0.447715 7.59604 0 7.04375 0H5.67535C5.12306 0 4.67535 0.447715 4.67535 1V1.26315H0.964844C0.688701 1.26315 0.464844 1.48701 0.464844 1.76315V2.0263C0.464844 2.30245 0.688701 2.5263 0.964844 2.5263H11.7543C12.0304 2.5263 12.2543 2.30245 12.2543 2.0263V1.76315C12.2543 1.48701 12.0304 1.26315 11.7543 1.26315H8.04375Z'
        fill={color}
      />
    </svg>
  );
};

export const DollerSign = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='23'
      height='23'
      viewBox='0 0 23 23'
      fill='none'>
      <path
        d='M11.9494 0C12.4726 0 12.8968 0.424151 12.8968 0.947369V3.5673H11.002V0.947368C11.002 0.424151 11.4262 0 11.9494 0ZM12.666 19.7471V22.0526C12.666 22.5758 12.2418 23 11.7186 23C11.1954 23 10.7713 22.5758 10.7713 22.0526V19.7471H12.666ZM14.002 15.7808C14.002 15.3212 13.917 14.9302 13.747 14.6078C13.585 14.2853 13.3178 13.9991 12.9453 13.7492C12.581 13.4993 12.087 13.2574 11.4636 13.0237C10.4109 12.6206 9.48381 12.1933 8.68219 11.7419C7.88866 11.2823 7.26923 10.714 6.82389 10.0368C6.37854 9.35156 6.15587 8.48493 6.15587 7.43691C6.15587 6.43726 6.39474 5.57063 6.87247 4.83701C7.3502 4.1034 8.01012 3.53908 8.85223 3.14406C9.70243 2.74097 10.6903 2.53943 11.8158 2.53943C12.6741 2.53943 13.4514 2.66842 14.1478 2.92639C14.8441 3.17631 15.4433 3.54714 15.9453 4.03891C16.4474 4.52261 16.832 5.11514 17.0992 5.81651C17.2636 6.24796 17.3774 6.71755 17.4406 7.22527C17.5089 7.77332 17.0523 8.22292 16.5 8.22292H15.0142C14.4619 8.22292 14.0325 7.77023 13.9251 7.22848C13.9054 7.1292 13.8825 7.03341 13.8563 6.94111C13.751 6.57028 13.5972 6.2599 13.3947 6.00999C13.2004 5.76008 12.9656 5.57466 12.6903 5.45373C12.415 5.32475 12.1113 5.26025 11.7794 5.26025C11.2854 5.26025 10.8806 5.35699 10.5648 5.55047C10.249 5.74395 10.0182 6.00596 9.87247 6.33649C9.73482 6.65896 9.66599 7.02979 9.66599 7.449C9.66599 7.86015 9.73887 8.21889 9.88462 8.52524C10.0385 8.83158 10.3016 9.11374 10.6741 9.37171C11.0466 9.62163 11.5567 9.8796 12.2045 10.1456C13.2571 10.5487 14.1802 10.9841 14.9737 11.4516C15.7672 11.9192 16.3866 12.4916 16.832 13.1688C17.2773 13.846 17.5 14.7086 17.5 15.7566C17.5 16.7965 17.2571 17.6833 16.7713 18.4169C16.2854 19.1425 15.6053 19.6987 14.7308 20.0857C13.8563 20.4646 12.8441 20.654 11.6943 20.654C10.9494 20.654 10.2085 20.5573 9.47166 20.3638C8.73482 20.1623 8.0668 19.8398 7.46761 19.3964C6.86842 18.953 6.39069 18.3645 6.03441 17.6309C5.79372 17.1299 5.63433 16.5515 5.55625 15.8959C5.49093 15.3475 5.94772 14.898 6.5 14.898H7.99798C8.55026 14.898 8.97709 15.3513 9.08896 15.8922C9.12491 16.0659 9.1715 16.2263 9.22874 16.3733C9.38259 16.7603 9.58502 17.0706 9.83603 17.3044C10.0951 17.5301 10.3866 17.6914 10.7105 17.7881C11.0344 17.8849 11.3623 17.9332 11.6943 17.9332C12.2126 17.9332 12.6377 17.8405 12.9696 17.6551C13.3097 17.4697 13.5648 17.2157 13.7348 16.8933C13.913 16.5627 14.002 16.1919 14.002 15.7808Z'
        fill='#8D99A5'
      />
    </svg>
  );
};

export const Globe = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='23'
      height='23'
      viewBox='0 0 23 23'
      fill='none'>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M4.54113 16.9396L5.55233 15.8319C6.90825 17.1241 8.65334 17.9482 10.543 18.1575V19.168H9.58464C8.52609 19.168 7.66797 20.0261 7.66797 21.0846H11.5013H15.3346C15.3346 20.0261 14.4765 19.168 13.418 19.168H12.4596V18.1574C16.7715 17.6801 20.125 14.0243 20.125 9.58519C20.125 6.79555 18.7902 4.22718 16.5796 2.61396C16.152 2.30197 15.5525 2.39563 15.2405 2.82317C14.9285 3.2507 15.0222 3.85021 15.4497 4.16221C17.171 5.41834 18.2083 7.41427 18.2083 9.58519C18.2083 13.2795 15.2221 16.2763 11.5319 16.2934C11.5218 16.2931 11.5115 16.293 11.5013 16.293C11.4909 16.293 11.4805 16.2931 11.4702 16.2935C9.43388 16.2846 7.5515 15.364 6.29057 13.8121C5.92117 13.3575 5.23395 13.3377 4.83902 13.7703L3.12555 15.6474C2.76872 16.0383 2.79634 16.6445 3.18724 17.0013C3.57814 17.3581 4.1843 17.3305 4.54113 16.9396Z'
        fill='#80808F'
      />
      <path
        opacity='0.3'
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M11.5 15.3359C14.6756 15.3359 17.25 12.7616 17.25 9.58594C17.25 6.4103 14.6756 3.83594 11.5 3.83594C8.32436 3.83594 5.75 6.4103 5.75 9.58594C5.75 12.7616 8.32436 15.3359 11.5 15.3359Z'
        fill='#80808F'
      />
    </svg>
  );
};

export const Clock = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='23'
      height='23'
      viewBox='0 0 23 23'
      fill='none'>
      <g clip-path='url(#clip0_7124_47989)'>
        <path
          d='M11.4917 1.91797C6.20172 1.91797 1.91797 6.2113 1.91797 11.5013C1.91797 16.7913 6.20172 21.0846 11.4917 21.0846C16.7913 21.0846 21.0846 16.7913 21.0846 11.5013C21.0846 6.2113 16.7913 1.91797 11.4917 1.91797ZM11.5013 19.168C7.26547 19.168 3.83464 15.7371 3.83464 11.5013C3.83464 7.26547 7.26547 3.83464 11.5013 3.83464C15.7371 3.83464 19.168 7.26547 19.168 11.5013C19.168 15.7371 15.7371 19.168 11.5013 19.168Z'
          fill='#80808F'
        />
        <path
          d='M11.9805 6.70703H10.543V12.457L15.5742 15.4758L16.293 14.297L11.9805 11.7383V6.70703Z'
          fill='#80808F'
        />
      </g>
      <defs>
        <clipPath id='clip0_7124_47989'>
          <rect width='23' height='23' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const HistoryIcon = props => {
  return (
    <svg
      {...props}
      width='41'
      height='40'
      viewBox='0 0 41 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <rect width='40' height='40' transform='translate(0.5)' fill='white' />
      <path
        d='M2.31641 15.1509C2.31641 14.7835 2.46376 14.4312 2.72605 14.1714C2.98834 13.9116 3.34408 13.7656 3.71501 13.7656C6.23599 13.7656 7.59438 14.6626 8.68704 15.3829C9.65906 16.0271 10.4318 16.5362 12.1066 16.5362C13.7814 16.5362 14.5542 16.0271 15.5262 15.3829C16.6171 14.6626 17.9737 13.7656 20.4965 13.7656C23.0192 13.7656 24.3776 14.6626 25.4685 15.3829C26.444 16.0271 27.2168 16.5362 28.8898 16.5362C30.5629 16.5362 31.3374 16.0271 32.3094 15.3829C33.4021 14.6626 34.757 13.7656 37.2814 13.7656C37.6524 13.7656 38.0081 13.9116 38.2704 14.1714C38.5327 14.4312 38.68 14.7835 38.68 15.1509C38.68 15.5183 38.5327 15.8707 38.2704 16.1304C38.0081 16.3902 37.6524 16.5362 37.2814 16.5362C35.6066 16.5362 34.8339 17.0453 33.8619 17.6894C32.7692 18.4098 31.4143 19.3068 28.8898 19.3068C26.3654 19.3068 25.0087 18.4098 23.9178 17.6894C22.9458 17.0453 22.1713 16.5362 20.4982 16.5362C18.8251 16.5362 18.0507 17.0453 17.0786 17.6894C15.9877 18.4098 14.6311 19.3068 12.1084 19.3068C9.58564 19.3068 8.22899 18.4098 7.13634 17.6894C6.16256 17.0453 5.38983 16.5362 3.71501 16.5362C3.34408 16.5362 2.98834 16.3902 2.72605 16.1304C2.46376 15.8707 2.31641 15.5183 2.31641 15.1509ZM38.68 22.0773C38.68 22.4447 38.5327 22.7971 38.2704 23.0569C38.0081 23.3166 37.6524 23.4626 37.2814 23.4626C35.6066 23.4626 34.8339 23.9717 33.8619 24.6158C32.7692 25.3362 31.4143 26.2332 28.8898 26.2332C26.3654 26.2332 25.0087 25.3362 23.9178 24.6158C22.9458 23.9717 22.1713 23.4626 20.4982 23.4626C18.8251 23.4626 18.0507 23.9717 17.0786 24.6158C15.9877 25.3362 14.6311 26.2332 12.1084 26.2332C9.58564 26.2332 8.22899 25.3362 7.13634 24.6158C6.16256 23.9717 5.38983 23.4626 3.71501 23.4626C3.34408 23.4626 2.98834 23.3166 2.72605 23.0569C2.46376 22.7971 2.31641 22.4447 2.31641 22.0773C2.31641 21.7099 2.46376 21.3576 2.72605 21.0978C2.98834 20.838 3.34408 20.692 3.71501 20.692C6.23599 20.692 7.59438 21.589 8.68704 22.3093C9.65906 22.9535 10.4318 23.4626 12.1066 23.4626C13.7814 23.4626 14.5542 22.9535 15.5262 22.3093C16.6171 21.589 17.9737 20.692 20.4965 20.692C23.0192 20.692 24.3776 21.589 25.4685 22.3093C26.444 22.9535 27.2168 23.4626 28.8898 23.4626C30.5629 23.4626 31.3374 22.9535 32.3094 22.3093C33.4021 21.589 34.757 20.692 37.2814 20.692C37.6524 20.692 38.0081 20.838 38.2704 21.0978C38.5327 21.3576 38.68 21.7099 38.68 22.0773Z'
        fill={props?.style.fill}
      />
    </svg>
  );
};

export const TemperatureIcon = props => {
  return (
    <svg
      {...props}
      width='41'
      height='40'
      viewBox='0 0 41 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <rect
        width='40'
        height='40.0016'
        transform='translate(0.5)'
        fill='white'
      />
      <path
        d='M20.5011 1.81641C22.0101 1.81628 23.462 2.3935 24.5591 3.42969C25.6561 4.46589 26.3152 5.88254 26.4011 7.38913L26.4102 7.7255L26.412 22.1837L26.5574 22.3091C28.2518 23.8198 29.3183 25.9106 29.5465 28.1691L29.5811 28.6273L29.592 29.0891C29.5922 30.587 29.2224 32.0617 28.5153 33.3821C27.8083 34.7026 26.7859 35.8279 25.5391 36.658C24.2923 37.488 22.8597 37.9972 21.3687 38.1402C19.8777 38.2831 18.3745 38.0554 16.9927 37.4774C15.6109 36.8993 14.3933 35.9888 13.4482 34.8268C12.5031 33.6647 11.8598 32.2871 11.5755 30.8165C11.2911 29.3459 11.3746 27.8279 11.8183 26.3973C12.2621 24.9667 13.0525 23.6679 14.1192 22.6164L14.4465 22.3073L14.5902 22.1837L14.592 7.7255C14.5917 6.27332 15.1261 4.87189 16.0933 3.78867C17.0605 2.70545 18.3927 2.01631 19.8356 1.85277L20.1665 1.8255L20.5011 1.81641ZM20.5011 4.54368C19.7022 4.54375 18.9327 4.84428 18.3452 5.38558C17.7578 5.92689 17.3954 6.66935 17.3302 7.4655L17.3192 7.7255V23.5328L16.7574 23.9419C15.684 24.7226 14.8816 25.8195 14.4626 27.079C14.0435 28.3384 14.0288 29.6974 14.4204 30.9656C14.812 32.2339 15.5904 33.3479 16.6466 34.1518C17.7028 34.9557 18.9839 35.4092 20.3106 35.4489C21.6374 35.4885 22.9433 35.1123 24.0456 34.3729C25.1479 33.6335 25.9915 32.568 26.4581 31.3254C26.9248 30.0828 26.9912 28.7254 26.6481 27.4431C26.305 26.1609 25.5696 25.0181 24.5447 24.1746L24.2447 23.9437L23.6865 23.5346L23.6829 7.7255C23.6829 6.88163 23.3477 6.07232 22.751 5.47561C22.1542 4.87891 21.3449 4.54368 20.5011 4.54368ZM20.5011 12.7255C20.8627 12.7255 21.2096 12.8692 21.4653 13.1249C21.721 13.3806 21.8647 13.7275 21.8647 14.0891V24.7528C22.9012 25.0786 23.7867 25.7647 24.3611 26.687C24.9354 27.6093 25.1605 28.7067 24.9957 29.7806C24.8309 30.8545 24.287 31.8339 23.4626 32.5414C22.6381 33.249 21.5875 33.638 20.5011 33.638C19.4146 33.638 18.364 33.249 17.5396 32.5414C16.7151 31.8339 16.1712 30.8545 16.0064 29.7806C15.8416 28.7067 16.0667 27.6093 16.6411 26.687C17.2154 25.7647 18.101 25.0786 19.1374 24.7528V14.0891C19.1374 13.7275 19.2811 13.3806 19.5368 13.1249C19.7926 12.8692 20.1394 12.7255 20.5011 12.7255Z'
        fill={props?.style.fill}
      />
    </svg>
  );
};

export const ChemicalIcon = props => {
  return (
    <svg
      // {...props}
      width='41'
      height='40'
      viewBox='0 0 41 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <rect
        width='40'
        height='39.9997'
        transform='translate(0.5)'
        fill='white'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M13.5375 26.6103C12.9623 26.6103 12.5694 26.3211 12.359 25.7425C12.1485 25.164 12.2047 24.6957 12.5274 24.3376L17.7467 18.5525V12.974H16.6523C16.4839 12.974 16.3366 12.9121 16.2103 12.7881C16.0841 12.6641 16.0209 12.5195 16.0209 12.3542C16.0209 12.1889 16.0841 12.0443 16.2103 11.9203C16.3366 11.7964 16.4839 11.7344 16.6523 11.7344H23.3869C23.5552 11.7344 23.7025 11.7964 23.8288 11.9203C23.9551 12.0443 24.0182 12.1889 24.0182 12.3542C24.0182 12.5195 23.9551 12.6641 23.8288 12.7881C23.7025 12.9121 23.5552 12.974 23.3869 12.974H22.2925V18.5525L27.5118 24.3376C27.8485 24.7095 27.9082 25.1813 27.6907 25.7529C27.4732 26.3245 27.0769 26.6103 26.5016 26.6103H22.8606L22.8604 26.6104L22.8603 26.6103H13.5375ZM14.5977 23.9113L14.6169 23.9116L14.6067 23.9013L14.5977 23.9113Z'
        fill={props?.style.fill}
      />
      <path
        d='M38.6782 20C38.6782 30.9091 30.6964 38.1818 20.8492 38.1818C12.8455 38.1818 6.38736 33.9364 4.13281 27.2727'
        stroke={props?.style.fill}
        stroke-width='1.94804'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M2.31641 19.9982C2.31641 9.08913 10.2982 1.81641 20.1455 1.81641C28.1509 1.81641 34.6073 6.06186 36.8618 12.7255'
        stroke={props?.style.fill}
        stroke-width='1.94804'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M11.4073 29.0877L4.13459 27.2695L2.31641 34.5422'
        stroke={props?.style.fill}
        stroke-width='2.59738'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M29.5898 10.9077L36.8626 12.7258L38.6808 5.45312'
        stroke={props?.style.fill}
        stroke-width='1.94804'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
};

export const FilterLifeIcon = props => {
  return (
    <svg
      width='41'
      height='40'
      viewBox='0 0 41 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <rect
        width='40'
        height='39.9997'
        transform='translate(0.5)'
        fill='white'
      />
      <path
        d='M39.0172 20C39.0172 31.1111 30.8876 38.5185 20.858 38.5185C12.7061 38.5185 6.12833 34.1944 3.83203 27.4074'
        stroke={props?.style.fill}
        stroke-width='1.72264'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M1.98047 19.999C1.98047 8.88787 10.1101 1.48047 20.1397 1.48047C28.2934 1.48047 34.8694 5.80454 37.1657 12.5916'
        stroke={props?.style.fill}
        stroke-width='1.72264'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M11.2397 29.2581L3.83232 27.4062L1.98047 34.8137'
        stroke={props?.style.fill}
        stroke-width='1.72264'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M29.7578 10.7391L37.1652 12.591L39.0171 5.18359'
        stroke={props?.style.fill}
        stroke-width='1.72264'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M13.2877 14.5435C13.4766 14.1394 13.8823 13.8812 14.3284 13.8812H26.5811C27.0272 13.8812 27.433 14.1394 27.6218 14.5435C27.8107 14.9477 27.7485 15.4246 27.4623 15.7668L23.045 21.0491V24.0392C23.045 24.4743 22.7991 24.8721 22.41 25.0667L19.527 26.5082C19.1709 26.6862 18.748 26.6672 18.4094 26.4579C18.0707 26.2486 17.8646 25.8789 17.8646 25.4807V21.0491L13.4472 15.7668C13.1611 15.4246 13.0989 14.9477 13.2877 14.5435ZM16.7864 16.1786L19.8945 19.8952C20.0673 20.1018 20.162 20.3627 20.162 20.6321V23.6221L20.7476 23.3293V20.6321C20.7476 20.3627 20.8423 20.1018 21.0151 19.8952L24.1231 16.1786H16.7864Z'
        fill={props?.style.fill}
      />
      <path
        d='M17.4592 12.1018C17.4592 12.7362 16.9449 13.2505 16.3105 13.2505C15.6761 13.2505 15.1618 12.7362 15.1618 12.1018C15.1618 11.4674 15.6761 10.9531 16.3105 10.9531C16.9449 10.9531 17.4592 11.4674 17.4592 12.1018Z'
        fill={props?.style.fill}
      />
      <path
        d='M21.0623 12.1018C21.0623 12.7362 20.548 13.2505 19.9136 13.2505C19.2792 13.2505 18.7649 12.7362 18.7649 12.1018C18.7649 11.4674 19.2792 10.9531 19.9136 10.9531C20.548 10.9531 21.0623 11.4674 21.0623 12.1018Z'
        fill={props?.style.fill}
      />
      <path
        d='M22.0539 28.1836C22.0539 28.818 21.5396 29.3323 20.9052 29.3323C20.2708 29.3323 19.7565 28.818 19.7565 28.1836C19.7565 27.5492 20.2708 27.0349 20.9052 27.0349C21.5396 27.0349 22.0539 27.5492 22.0539 28.1836Z'
        fill={props?.style.fill}
      />
      <path
        d='M24.6654 12.1018C24.6654 12.7362 24.1511 13.2505 23.5167 13.2505C22.8823 13.2505 22.368 12.7362 22.368 12.1018C22.368 11.4674 22.8823 10.9531 23.5167 10.9531C24.1511 10.9531 24.6654 11.4674 24.6654 12.1018Z'
        fill={props?.style.fill}
      />
    </svg>
  );
};

export const WaterLifeIcon = props => {
  return (
    <svg
      width='41'
      height='40'
      viewBox='0 0 41 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g clip-path='url(#clip0_7124_51623)'>
        <rect width='40' height='40' transform='translate(0.5)' fill='white' />
        <path
          d='M39.4987 20C39.4987 31.4001 31.1576 39.0001 20.8672 39.0001C12.5033 39.0001 5.75445 34.5636 3.39844 27.6'
          stroke={props?.style.fill}
          stroke-width='1.76744'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
        <path
          d='M1.5 20.0001C1.5 8.60005 9.84105 1 20.1315 1C28.4973 1 35.2442 5.43653 37.6002 12.4001'
          stroke={props?.style.fill}
          stroke-width='1.76744'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
        <path
          d='M11.0001 29.5016L3.40001 27.6016L1.5 35.2016'
          stroke={props?.style.fill}
          stroke-width='1.76744'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
        <path
          d='M30 10.5008L37.6001 12.4008L39.5001 4.80078'
          stroke={props?.style.fill}
          stroke-width='1.76744'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M20.499 29.2808C24.1598 29.2808 27.1269 26.427 27.1269 22.9071C27.1269 22.6815 27.1161 22.4542 27.0952 22.2257C26.6486 17.3258 21.6153 11.8808 20.6563 10.8838C20.5554 10.7789 20.4996 10.7233 20.499 10.7227C20.499 10.7227 20.499 10.7227 20.499 10.7227C20.499 10.7227 20.048 11.1714 19.3823 11.9349C17.5035 14.0871 13.9093 18.7357 13.8714 22.8417C13.8712 22.8635 13.8711 22.8853 13.8711 22.9071C13.8711 26.427 16.8382 29.2808 20.499 29.2808Z'
          fill={props?.style.fill}
        />
      </g>
      <defs>
        <clipPath id='clip0_7124_51623'>
          <rect
            width='40'
            height='40'
            fill='white'
            transform='translate(0.5)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const StartIcon = () => {
  return (
    <svg
      width='40'
      height='40'
      viewBox='0 0 40 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M20.0024 30.0027L13.1951 33.5815C12.3804 34.0098 11.3727 33.6966 10.9443 32.8818C10.7738 32.5574 10.7149 32.1858 10.7769 31.8245L12.0769 24.2445L6.56972 18.8763C5.91058 18.2338 5.89709 17.1786 6.5396 16.5194C6.79544 16.257 7.13068 16.0862 7.49341 16.0335L15.1042 14.9275L18.5079 8.03099C18.9152 7.20557 19.9146 6.86667 20.74 7.27404C21.0687 7.43626 21.3348 7.7023 21.497 8.03099L24.9006 14.9275L32.5114 16.0335C33.4223 16.1658 34.0535 17.0116 33.9211 17.9225C33.8684 18.2852 33.6976 18.6204 33.4351 18.8763L27.9279 24.2445L29.228 31.8245C29.3836 32.7318 28.7742 33.5934 27.867 33.749C27.5058 33.8109 27.1341 33.7521 26.8097 33.5815L20.0024 30.0027Z'
        stroke='#70808F'
      />
    </svg>
  );
};
export const FavoriteStartIcon = () => {
  return (
    <svg
      width='40'
      height='40'
      viewBox='0 0 40 40'
      fill='rgb(255, 168, 0)'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M20.0024 30.0027L13.1951 33.5815C12.3804 34.0098 11.3727 33.6966 10.9443 32.8818C10.7738 32.5574 10.7149 32.1858 10.7769 31.8245L12.0769 24.2445L6.56972 18.8763C5.91058 18.2338 5.89709 17.1786 6.5396 16.5194C6.79544 16.257 7.13068 16.0862 7.49341 16.0335L15.1042 14.9275L18.5079 8.03099C18.9152 7.20557 19.9146 6.86667 20.74 7.27404C21.0687 7.43626 21.3348 7.7023 21.497 8.03099L24.9006 14.9275L32.5114 16.0335C33.4223 16.1658 34.0535 17.0116 33.9211 17.9225C33.8684 18.2852 33.6976 18.6204 33.4351 18.8763L27.9279 24.2445L29.228 31.8245C29.3836 32.7318 28.7742 33.5934 27.867 33.749C27.5058 33.8109 27.1341 33.7521 26.8097 33.5815L20.0024 30.0027Z'
        stroke='#70808F'
      />
    </svg>
  );
};

export const Chevron = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='11'
      viewBox='0 0 20 11'
      fill='none'>
      <path
        d='M16.9027 0.402727C17.4397 -0.134243 18.3103 -0.134243 18.8473 0.402727C19.3842 0.939698 19.3842 1.8103 18.8473 2.34727L10.5973 10.5973C10.0767 11.1178 9.23855 11.136 8.69588 10.6386L0.445881 3.07609C-0.113907 2.56295 -0.151724 1.69317 0.361416 1.13338C0.874556 0.573589 1.74434 0.535772 2.30412 1.04891L9.58365 7.72181L16.9027 0.402727Z'
        fill='#70808F'
      />
    </svg>
  );
};

export const SortIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='15'
      height='11'
      viewBox='0 0 15 11'
      fill='none'>
      <path
        d='M6.90075 3.14225C7.01336 3.2631 7.07467 3.42294 7.07175 3.58809C7.06884 3.75325 7.00193 3.91083 6.88513 4.02763C6.76833 4.14443 6.61075 4.21133 6.4456 4.21425C6.28044 4.21716 6.1206 4.15586 5.99975 4.04325L4.5267 2.5719V9.9618C4.5267 10.1309 4.45954 10.293 4.33998 10.4126C4.22043 10.5321 4.05828 10.5993 3.8892 10.5993C3.72013 10.5993 3.55798 10.5321 3.43842 10.4126C3.31887 10.293 3.2517 10.1309 3.2517 9.9618V2.57955L1.7914 4.03985C1.73304 4.10248 1.66266 4.15272 1.58446 4.18756C1.50626 4.2224 1.42184 4.24114 1.33625 4.24265C1.25065 4.24416 1.16562 4.22842 1.08624 4.19635C1.00686 4.16429 0.934755 4.11657 0.874219 4.05603C0.813684 3.9955 0.765961 3.92339 0.733898 3.84401C0.701835 3.76463 0.686089 3.6796 0.687599 3.594C0.689109 3.50841 0.707845 3.42399 0.742688 3.34579C0.777531 3.26759 0.827768 3.19721 0.890402 3.13885L3.39365 0.634748C3.45339 0.560884 3.5289 0.501326 3.61465 0.460438C3.70039 0.41955 3.79421 0.398369 3.8892 0.398448C3.97361 0.397961 4.05727 0.41424 4.13533 0.446341C4.21339 0.478442 4.28431 0.525725 4.34395 0.585448L6.90075 3.14225Z'
        fill='#3699FF'
      />
      <path
        d='M8.10525 7.85464C8.04261 7.79627 7.99238 7.72589 7.95753 7.64769C7.92269 7.56949 7.90395 7.48508 7.90244 7.39948C7.90093 7.31388 7.91668 7.22886 7.94874 7.14948C7.9808 7.0701 8.02853 6.99799 8.08906 6.93745C8.1496 6.87692 8.22171 6.8292 8.30109 6.79713C8.38047 6.76507 8.46549 6.74932 8.55109 6.75083C8.63669 6.75235 8.7211 6.77108 8.7993 6.80592C8.8775 6.84077 8.94788 6.891 9.00625 6.95364L10.4793 8.42584V1.03594C10.4793 0.866862 10.5465 0.704711 10.666 0.585157C10.7856 0.465602 10.9477 0.398438 11.1168 0.398438C11.2859 0.398438 11.448 0.465602 11.5676 0.585157C11.6871 0.704711 11.7543 0.866862 11.7543 1.03594V8.41734L13.2146 6.95704C13.273 6.8944 13.3433 6.84417 13.4215 6.80932C13.4997 6.77448 13.5842 6.75574 13.6698 6.75423C13.7553 6.75272 13.8404 6.76847 13.9198 6.80053C13.9991 6.8326 14.0712 6.88032 14.1318 6.94085C14.1923 7.00139 14.24 7.0735 14.2721 7.15288C14.3042 7.23226 14.3199 7.31728 14.3184 7.40288C14.3169 7.48848 14.2982 7.5729 14.2633 7.65109C14.2285 7.72929 14.1782 7.79967 14.1156 7.85804L11.6123 10.3621C11.5526 10.436 11.4771 10.4956 11.3914 10.5364C11.3056 10.5773 11.2118 10.5985 11.1168 10.5984C11.0324 10.5989 10.9487 10.5826 10.8707 10.5505C10.7926 10.5184 10.7217 10.4712 10.662 10.4114L8.10525 7.85464Z'
        fill='#3699FF'
      />
    </svg>
  );
};

export const QuickEyeIcon = ({ fill1 = "#BADAFB", fill2 = "#4EA5FE" }) => {
  return (
    <svg
      width='25'
      height='16'
      viewBox='0 0 25 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M12.6054 0C7.27207 0 2.7174 3.31733 0.87207 8C2.7174 12.6827 7.27207 16 12.6054 16C17.9387 16 22.4934 12.6827 24.3387 8C22.4934 3.31733 17.9387 0 12.6054 0ZM12.6054 13.3333C9.6614 13.3333 7.27207 10.944 7.27207 8C7.27207 5.056 9.6614 2.66667 12.6054 2.66667C15.5494 2.66667 17.9387 5.056 17.9387 8C17.9387 10.944 15.5494 13.3333 12.6054 13.3333Z'
        fill={fill1}
      />
      <path
        d='M12.6054 0C7.27207 0 2.7174 3.31733 0.87207 8C2.7174 12.6827 7.27207 16 12.6054 16C17.9387 16 22.4934 12.6827 24.3387 8C22.4934 3.31733 17.9387 0 12.6054 0ZM12.6054 13.3333C9.6614 13.3333 7.27207 10.944 7.27207 8C7.27207 5.056 9.6614 2.66667 12.6054 2.66667C15.5494 2.66667 17.9387 5.056 17.9387 8C17.9387 10.944 15.5494 13.3333 12.6054 13.3333Z'
        fill={fill1}
      />
      <path
        d='M12.6053 4.7998C10.8346 4.7998 9.40527 6.22914 9.40527 7.99981C9.40527 9.77047 10.8346 11.1998 12.6053 11.1998C14.3759 11.1998 15.8053 9.77047 15.8053 7.99981C15.8053 6.22914 14.3759 4.7998 12.6053 4.7998Z'
        fill={fill2}
      />
    </svg>
  );
};

export const RcoveryIcon = ({ fill1 = "#3699FF" }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='14'
      height='15'
      viewBox='0 0 14 15'
      fill='none'>
      <path
        d='M7.84244 4.00002V7.1697L10.3716 8.7498C10.499 8.82948 10.5908 8.95859 10.6268 9.10874C10.6628 9.25888 10.64 9.41776 10.5635 9.55042C10.487 9.68309 10.363 9.77867 10.2188 9.81614C10.0746 9.8536 9.92204 9.82989 9.79465 9.75022L6.99377 8.00022C6.91088 7.94836 6.84229 7.87503 6.79468 7.78737C6.74707 7.69972 6.72206 7.60072 6.72209 7.50001V4.00002C6.72209 3.84531 6.78111 3.69693 6.88616 3.58754C6.99121 3.47814 7.1337 3.41668 7.28226 3.41668C7.43083 3.41668 7.57331 3.47814 7.67837 3.58754C7.78342 3.69693 7.84244 3.84531 7.84244 4.00002ZM7.28226 0.500022C6.39859 0.497729 5.52325 0.677963 4.7069 1.03029C3.89056 1.38262 3.14942 1.90004 2.52639 2.55262C2.01733 3.08929 1.56499 3.60554 1.12035 4.14585V2.83335C1.12035 2.67864 1.06133 2.53027 0.956277 2.42087C0.851224 2.31148 0.708742 2.25002 0.560174 2.25002C0.411607 2.25002 0.269124 2.31148 0.164071 2.42087C0.0590182 2.53027 0 2.67864 0 2.83335V5.75001C0 5.90472 0.0590182 6.0531 0.164071 6.16249C0.269124 6.27189 0.411607 6.33335 0.560174 6.33335H3.36104C3.50961 6.33335 3.65209 6.27189 3.75715 6.16249C3.8622 6.0531 3.92122 5.90472 3.92122 5.75001C3.92122 5.5953 3.8622 5.44693 3.75715 5.33754C3.65209 5.22814 3.50961 5.16668 3.36104 5.16668H1.75054C2.2512 4.55272 2.74975 3.9745 3.31833 3.37512C4.09687 2.5644 5.08758 2.01057 6.16666 1.78283C7.24573 1.55509 8.36534 1.66353 9.38556 2.09462C10.4058 2.52571 11.2814 3.26032 11.903 4.20667C12.5246 5.15301 12.8646 6.26912 12.8805 7.41554C12.8964 8.56195 12.5876 9.68784 11.9925 10.6525C11.3975 11.6172 10.5427 12.3779 9.53483 12.8395C8.527 13.3011 7.41088 13.4433 6.32593 13.2481C5.24098 13.053 4.2353 12.5292 3.43457 11.7423C3.38105 11.6896 3.3181 11.6485 3.2493 11.6211C3.1805 11.5938 3.10721 11.5808 3.0336 11.583C2.96 11.5852 2.88753 11.6024 2.82032 11.6338C2.75312 11.6651 2.6925 11.7099 2.64192 11.7656C2.59135 11.8214 2.55181 11.8869 2.52556 11.9586C2.49932 12.0302 2.48688 12.1065 2.48896 12.1832C2.49104 12.2598 2.5076 12.3353 2.53769 12.4053C2.56778 12.4753 2.61081 12.5384 2.66433 12.591C3.46219 13.3751 4.4322 13.9439 5.48971 14.2478C6.54721 14.5517 7.66007 14.5814 8.73116 14.3345C9.80225 14.0875 10.799 13.5713 11.6345 12.8309C12.4699 12.0905 13.1187 11.1485 13.5241 10.087C13.9295 9.02544 14.0793 7.87674 13.9604 6.74108C13.8414 5.60543 13.4574 4.51735 12.8418 3.5718C12.2261 2.62625 11.3976 1.85197 10.4286 1.31653C9.45948 0.781089 8.3793 0.500765 7.28226 0.500022Z'
        fill={fill1}
      />
    </svg>
  );
};

export const PdFIcon = () => {
  return (
    <svg
      width='12'
      height='14'
      viewBox='0 0 12 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M11.3538 3.92673L7.85375 0.1575C7.80728 0.107512 7.75212 0.0678742 7.69143 0.0408498C7.63073 0.0138254 7.56568 -5.54539e-05 7.5 1.66491e-07H1.5C1.23478 1.66491e-07 0.98043 0.113461 0.792893 0.315424C0.605357 0.517386 0.5 0.791305 0.5 1.07692V12.9231C0.5 13.2087 0.605357 13.4826 0.792893 13.6846C0.98043 13.8865 1.23478 14 1.5 14H10.5C10.7652 14 11.0196 13.8865 11.2071 13.6846C11.3946 13.4826 11.5 13.2087 11.5 12.9231V4.30769C11.5001 4.23696 11.4872 4.16691 11.4621 4.10154C11.437 4.03618 11.4002 3.97677 11.3538 3.92673ZM8 1.83817L9.79313 3.76923H8V1.83817ZM10.5 12.9231H1.5V1.07692H7V4.30769C7 4.4505 7.05268 4.58746 7.14645 4.68844C7.24021 4.78942 7.36739 4.84615 7.5 4.84615H10.5V12.9231Z'
        fill='#3699FF'
      />
    </svg>
  );
};
export const PdFIconLargeIcon = () => {
  return (
    <svg
      width='50'
      height='67'
      viewBox='0 0 12 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M11.3538 3.92673L7.85375 0.1575C7.80728 0.107512 7.75212 0.0678742 7.69143 0.0408498C7.63073 0.0138254 7.56568 -5.54539e-05 7.5 1.66491e-07H1.5C1.23478 1.66491e-07 0.98043 0.113461 0.792893 0.315424C0.605357 0.517386 0.5 0.791305 0.5 1.07692V12.9231C0.5 13.2087 0.605357 13.4826 0.792893 13.6846C0.98043 13.8865 1.23478 14 1.5 14H10.5C10.7652 14 11.0196 13.8865 11.2071 13.6846C11.3946 13.4826 11.5 13.2087 11.5 12.9231V4.30769C11.5001 4.23696 11.4872 4.16691 11.4621 4.10154C11.437 4.03618 11.4002 3.97677 11.3538 3.92673ZM8 1.83817L9.79313 3.76923H8V1.83817ZM10.5 12.9231H1.5V1.07692H7V4.30769C7 4.4505 7.05268 4.58746 7.14645 4.68844C7.24021 4.78942 7.36739 4.84615 7.5 4.84615H10.5V12.9231Z'
        fill='#3699FF'
      />
    </svg>
  );
};
export const FolderIcon = () => {
  return (
    <svg
      width='19'
      height='16'
      viewBox='0 0 19 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M10.7689 2.73904H17.1624C18.0719 2.74807 18.8044 3.48792 18.8044 4.39744V13.4739C18.8044 14.3834 18.0719 15.1233 17.1624 15.1323H1.83729C0.927818 15.1233 0.195268 14.3834 0.195312 13.4739V2.52741C0.194265 1.61716 0.927088 0.876218 1.83729 0.867188H6.56101C7.42491 0.867188 8.24831 1.23347 8.82678 1.87511C9.32261 2.42508 10.0284 2.73904 10.7689 2.73904Z'
        fill='#D9D298'
      />
    </svg>
  );
};

export const ListView = ({ color }) => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M16.2642 1.88491C17.2697 1.97187 18.0527 2.72695 18.1896 3.72687C18.2681 4.30037 18.333 4.9233 18.333 5.4165C18.333 5.9097 18.2681 6.53263 18.1896 7.10614C18.0527 8.10606 17.2697 8.86114 16.2642 8.9481C15.0222 9.05551 13.0104 9.1665 9.99967 9.1665C6.98896 9.1665 4.97719 9.05551 3.7352 8.9481C2.7297 8.86114 1.9467 8.10606 1.80975 7.10614C1.73121 6.53263 1.66634 5.9097 1.66634 5.4165C1.66634 4.9233 1.73121 4.30037 1.80975 3.72687C1.9467 2.72695 2.7297 1.97187 3.7352 1.88491C4.97719 1.7775 6.98897 1.6665 9.99967 1.6665C13.0104 1.6665 15.0222 1.7775 16.2642 1.88491Z'
        fill={color}
      />
      <path
        opacity='0.25'
        d='M16.2642 11.0519C17.2697 11.1389 18.0527 11.8939 18.1896 12.8939C18.2681 13.4674 18.333 14.0903 18.333 14.5835C18.333 15.0767 18.2681 15.6996 18.1896 16.2731C18.0527 17.2731 17.2697 18.0281 16.2642 18.1151C15.0222 18.2225 13.0104 18.3335 9.99967 18.3335C6.98896 18.3335 4.97719 18.2225 3.7352 18.1151C2.7297 18.0281 1.9467 17.2731 1.80975 16.2731C1.73121 15.6996 1.66634 15.0767 1.66634 14.5835C1.66634 14.0903 1.73121 13.4674 1.80975 12.8939C1.9467 11.8939 2.7297 11.1389 3.7352 11.0519C4.97719 10.9445 6.98897 10.8335 9.99967 10.8335C13.0104 10.8335 15.0222 10.9445 16.2642 11.0519Z'
        fill={color}
      />
    </svg>
  );
};

export const GridView = ({ color }) => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        opacity='0.25'
        d='M10.9764 12.8939C11.1134 11.8939 11.8935 11.1138 12.8934 10.9769C13.4669 10.8984 14.0898 10.8335 14.583 10.8335C15.0762 10.8335 15.6991 10.8984 16.2726 10.9769C17.2726 11.1138 18.0527 11.8939 18.1896 12.8939C18.2681 13.4674 18.333 14.0903 18.333 14.5835C18.333 15.0767 18.2681 15.6996 18.1896 16.2731C18.0527 17.2731 17.2726 18.0531 16.2726 18.1901C15.6991 18.2686 15.0762 18.3335 14.583 18.3335C14.0898 18.3335 13.4669 18.2686 12.8934 18.1901C11.8935 18.0531 11.1134 17.2731 10.9764 16.2731C10.8979 15.6996 10.833 15.0767 10.833 14.5835C10.833 14.0903 10.8979 13.4674 10.9764 12.8939Z'
        fill={color}
      />
      <path
        opacity='0.25'
        d='M1.8104 12.8939C1.94734 11.8939 2.72744 11.1138 3.72736 10.9769C4.30086 10.8984 4.92379 10.8335 5.41699 10.8335C5.91019 10.8335 6.53312 10.8984 7.10663 10.9769C8.10655 11.1138 8.88664 11.8939 9.02358 12.8939C9.10213 13.4674 9.16699 14.0903 9.16699 14.5835C9.16699 15.0767 9.10213 15.6996 9.02358 16.2731C8.88664 17.2731 8.10655 18.0531 7.10663 18.1901C6.53312 18.2686 5.91019 18.3335 5.41699 18.3335C4.92379 18.3335 4.30086 18.2686 3.72736 18.1901C2.72744 18.0531 1.94734 17.2731 1.8104 16.2731C1.73186 15.6996 1.66699 15.0767 1.66699 14.5835C1.66699 14.0903 1.73186 13.4674 1.8104 12.8939Z'
        fill={color}
      />
      <path
        opacity='0.25'
        d='M10.9764 3.72687C11.1134 2.72695 11.8935 1.94686 12.8934 1.80991C13.4669 1.73137 14.0898 1.6665 14.583 1.6665C15.0762 1.6665 15.6991 1.73137 16.2726 1.80991C17.2726 1.94686 18.0527 2.72695 18.1896 3.72687C18.2681 4.30037 18.333 4.9233 18.333 5.4165C18.333 5.9097 18.2681 6.53263 18.1896 7.10614C18.0527 8.10606 17.2726 8.88615 16.2726 9.02309C15.6991 9.10164 15.0762 9.1665 14.583 9.1665C14.0898 9.1665 13.4669 9.10164 12.8934 9.02309C11.8935 8.88615 11.1134 8.10606 10.9764 7.10614C10.8979 6.53263 10.833 5.9097 10.833 5.4165C10.833 4.9233 10.8979 4.30037 10.9764 3.72687Z'
        fill={color}
      />
      <path
        d='M1.8104 3.72687C1.94734 2.72695 2.72744 1.94686 3.72736 1.80991C4.30086 1.73137 4.92379 1.6665 5.41699 1.6665C5.91019 1.6665 6.53312 1.73137 7.10663 1.80991C8.10655 1.94686 8.88664 2.72695 9.02358 3.72687C9.10213 4.30038 9.16699 4.92331 9.16699 5.4165C9.16699 5.9097 9.10213 6.53263 9.02358 7.10614C8.88664 8.10606 8.10655 8.88615 7.10663 9.02309C6.53312 9.10164 5.91019 9.1665 5.41699 9.1665C4.92379 9.1665 4.30086 9.10164 3.72736 9.02309C2.72744 8.88615 1.94734 8.10606 1.8104 7.10614C1.73186 6.53263 1.66699 5.9097 1.66699 5.4165C1.66699 4.92331 1.73186 4.30038 1.8104 3.72687Z'
        fill={color}
      />
    </svg>
  );
};

export const FolderIconLarge = () => {
  return (
    <svg
      width='81'
      height='62'
      viewBox='0 0 81 62'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g clip-path='url(#clip0_7243_40405)'>
        <path
          d='M43.8242 8.04706H73.6413C77.5512 8.08588 80.7004 11.2665 80.7002 15.1765V54.1961C80.7004 58.1061 77.5512 61.2869 73.6413 61.3255H7.75902C3.84922 61.2869 0.700004 58.1061 0.7002 54.1961V7.13726C0.69569 3.22412 3.84608 0.0388235 7.75902 0H30.7863C32.7686 0 34.6579 0.840475 35.9853 2.31277L39.3679 6.06468C40.5056 7.32665 42.1251 8.04706 43.8242 8.04706Z'
          fill='#D9D298'
        />
      </g>
      <defs>
        <clipPath id='clip0_7243_40405'>
          <rect
            width='80'
            height='62'
            fill='white'
            transform='translate(0.700195)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const PdfIconLarge = () => {
  return (
    <svg
      width='63'
      height='62'
      viewBox='0 0 63 62'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M16 0C13.8687 0 12.125 1.74375 12.125 3.875V58.125C12.125 60.2562 13.8687 62 16 62H54.75C56.8812 62 58.625 60.2562 58.625 58.125V15.5L43.125 0H16Z'
        fill='#E2E5E7'
      />
      <path
        d='M47 15.5H58.625L43.125 0V11.625C43.125 13.7563 44.8687 15.5 47 15.5Z'
        fill='#B0B7BD'
      />
      <path d='M58.625 27.125L47 15.5H58.625V27.125Z' fill='#CAD1D8' />
      <path
        d='M50.875 50.375C50.875 51.4406 50.0031 52.3125 48.9375 52.3125H6.3125C5.24687 52.3125 4.375 51.4406 4.375 50.375V31C4.375 29.9344 5.24687 29.0625 6.3125 29.0625H48.9375C50.0031 29.0625 50.875 29.9344 50.875 31V50.375Z'
        fill='#F15642'
      />
      <path
        d='M12.8203 36.7096C12.8203 36.1981 13.2233 35.6401 13.8724 35.6401H17.4509C19.4659 35.6401 21.2794 36.9886 21.2794 39.5733C21.2794 42.0223 19.4659 43.3863 17.4509 43.3863H14.8644V45.4323C14.8644 46.1143 14.4304 46.4998 13.8724 46.4998C13.3609 46.4998 12.8203 46.1143 12.8203 45.4323V36.7096ZM14.8644 37.5912V41.4507H17.4509C18.4894 41.4507 19.3109 40.5343 19.3109 39.5733C19.3109 38.4902 18.4894 37.5912 17.4509 37.5912H14.8644Z'
        fill='white'
      />
      <path
        d='M24.3136 46.5C23.8021 46.5 23.2441 46.221 23.2441 45.5409V36.7408C23.2441 36.1847 23.8021 35.7798 24.3136 35.7798H27.8612C34.9408 35.7798 34.7858 46.5 28.0007 46.5H24.3136ZM25.2901 37.6708V44.6109H27.8612C32.0443 44.6109 32.2303 37.6708 27.8612 37.6708H25.2901Z'
        fill='white'
      />
      <path
        d='M37.2971 37.7948V40.2573H41.2477C41.8057 40.2573 42.3637 40.8153 42.3637 41.3559C42.3637 41.8674 41.8057 42.2859 41.2477 42.2859H37.2971V45.539C37.2971 46.0815 36.9116 46.498 36.3691 46.498C35.6871 46.498 35.2705 46.0815 35.2705 45.539V36.7388C35.2705 36.1828 35.689 35.7778 36.3691 35.7778H41.8076C42.4896 35.7778 42.8926 36.1828 42.8926 36.7388C42.8926 37.2348 42.4896 37.7928 41.8076 37.7928H37.2971V37.7948Z'
        fill='white'
      />
      <path
        d='M48.9375 52.3125H12.125V54.25H48.9375C50.0031 54.25 50.875 53.3781 50.875 52.3125V50.375C50.875 51.4406 50.0031 52.3125 48.9375 52.3125Z'
        fill='#CAD1D8'
      />
    </svg>
  );
};

export const DocIconLarge = () => {
  return (
    <svg
      width='63'
      height='62'
      viewBox='0 0 63 62'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M16.4004 0C14.2691 0 12.5254 1.74375 12.5254 3.875V58.125C12.5254 60.2562 14.2691 62 16.4004 62H55.1504C57.2816 62 59.0254 60.2562 59.0254 58.125V15.5L43.5254 0H16.4004Z'
        fill='#E2E5E7'
      />
      <path
        d='M47.4004 15.5H59.0254L43.5254 0V11.625C43.5254 13.7563 45.2691 15.5 47.4004 15.5Z'
        fill='#B0B7BD'
      />
      <path d='M59.0254 27.125L47.4004 15.5H59.0254V27.125Z' fill='#CAD1D8' />
      <path
        d='M51.2754 50.375C51.2754 51.4406 50.4035 52.3125 49.3379 52.3125H6.71289C5.64727 52.3125 4.77539 51.4406 4.77539 50.375V31C4.77539 29.9344 5.64727 29.0625 6.71289 29.0625H49.3379C50.4035 29.0625 51.2754 29.9344 51.2754 31V50.375Z'
        fill='#50BEE8'
      />
      <path
        d='M12.1105 46.5C11.599 46.5 11.041 46.219 11.041 45.539V36.7408C11.041 36.1828 11.599 35.7798 12.1105 35.7798H15.6581C22.7377 35.7798 22.5808 46.5 15.7956 46.5H12.1105ZM13.087 37.6688V44.609H15.6581C19.8411 44.609 20.0252 37.6688 15.6581 37.6688H13.087Z'
        fill='white'
      />
      <path
        d='M28.5095 46.6548C25.644 46.7788 22.668 44.8723 22.668 41.0767C22.668 37.2657 25.642 35.3921 28.5095 35.3921C31.2201 35.5297 34.0547 37.4052 34.0547 41.0767C34.0547 44.7502 31.2201 46.6548 28.5095 46.6548ZM28.339 37.4071C26.603 37.4071 24.714 38.6316 24.714 41.0786C24.714 43.5121 26.605 44.7521 28.339 44.7521C30.1215 44.7521 32.0261 43.5121 32.0261 41.0786C32.0261 38.6296 30.1215 37.4071 28.339 37.4071Z'
        fill='white'
      />
      <path
        d='M35.8779 41.0611C35.8779 38.0716 37.7534 35.5005 41.3165 35.5005C42.665 35.5005 43.7345 35.9035 44.8641 36.88C45.2826 37.2655 45.3291 37.9475 44.9106 38.3815C44.4921 38.7516 43.8566 38.707 43.4846 38.335C42.851 37.6685 42.2 37.4845 41.3165 37.4845C38.9314 37.4845 37.7864 39.174 37.7864 41.063C37.7864 42.985 38.9159 44.7501 41.3165 44.7501C42.2 44.7501 43.0215 44.3917 43.7345 43.7581C44.2131 43.3861 44.8796 43.5702 45.1586 43.9441C45.4066 44.2851 45.5286 44.8586 44.9881 45.3992C43.9031 46.4086 42.603 46.6101 41.3146 46.6101C37.5674 46.6101 35.8779 44.0507 35.8779 41.0611Z'
        fill='white'
      />
      <path
        d='M49.3379 52.3125H12.5254V54.25H49.3379C50.4035 54.25 51.2754 53.3781 51.2754 52.3125V50.375C51.2754 51.4406 50.4035 52.3125 49.3379 52.3125Z'
        fill='#CAD1D8'
      />
    </svg>
  );
};

export const PreviewIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='15'
      height='11'
      viewBox='0 0 15 11'
      fill='none'>
      <path
        d='M7.5 0.386475C4.09091 0.386475 1.17955 2.50693 0 5.50011C1.17955 8.49329 4.09091 10.6137 7.5 10.6137C10.9091 10.6137 13.8205 8.49329 15 5.50011C13.8205 2.50693 10.9091 0.386475 7.5 0.386475ZM7.5 8.9092C5.61818 8.9092 4.09091 7.38193 4.09091 5.50011C4.09091 3.61829 5.61818 2.09102 7.5 2.09102C9.38182 2.09102 10.9091 3.61829 10.9091 5.50011C10.9091 7.38193 9.38182 8.9092 7.5 8.9092Z'
        fill='#BADAFB'
      />
      <path
        d='M7.5 0.386475C4.09091 0.386475 1.17955 2.50693 0 5.50011C1.17955 8.49329 4.09091 10.6137 7.5 10.6137C10.9091 10.6137 13.8205 8.49329 15 5.50011C13.8205 2.50693 10.9091 0.386475 7.5 0.386475ZM7.5 8.9092C5.61818 8.9092 4.09091 7.38193 4.09091 5.50011C4.09091 3.61829 5.61818 2.09102 7.5 2.09102C9.38182 2.09102 10.9091 3.61829 10.9091 5.50011C10.9091 7.38193 9.38182 8.9092 7.5 8.9092Z'
        fill='#BADAFB'
      />
      <path
        d='M7.49956 3.45459C6.36774 3.45459 5.4541 4.36823 5.4541 5.50005C5.4541 6.63186 6.36774 7.5455 7.49956 7.5455C8.63137 7.5455 9.54501 6.63186 9.54501 5.50005C9.54501 4.36823 8.63137 3.45459 7.49956 3.45459Z'
        fill='#4EA5FE'
      />
    </svg>
  );
};

export const FavoriteIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='17'
      height='17'
      viewBox='0 0 17 17'
      fill='none'>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M8.49994 13.8794L4.83646 15.8921C4.39799 16.133 3.85567 15.9569 3.62515 15.4987C3.53336 15.3162 3.50168 15.1072 3.53503 14.904L4.23469 10.6411L1.27087 7.62202C0.91614 7.26068 0.908881 6.66725 1.25466 6.29656C1.39235 6.14894 1.57276 6.05288 1.76797 6.02324L5.86387 5.40128L7.69561 1.5227C7.91485 1.05849 8.45268 0.867898 8.8969 1.097C9.07379 1.18823 9.21697 1.33785 9.30427 1.5227L11.136 5.40128L15.2319 6.02324C15.7221 6.09768 16.0618 6.57332 15.9906 7.0856C15.9622 7.2896 15.8703 7.47814 15.729 7.62202L12.7652 10.6411L13.4649 14.904C13.5486 15.4143 13.2207 15.8988 12.7324 15.9863C12.538 16.0212 12.338 15.9881 12.1634 15.8921L8.49994 13.8794Z'
        stroke='#3699FF'
      />
    </svg>
  );
};

export const DownloadIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='17'
      height='17'
      viewBox='0 0 17 17'
      fill='none'>
      <path
        d='M4.9209 6.96582L8.50044 10.5454L12.08 6.96582'
        stroke='#3699FF'
        stroke-width='1.5'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M8.5 1V10.5455'
        stroke='#3699FF'
        stroke-width='1.5'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M16 10.5454V15.3181C16 15.499 15.9282 15.6724 15.8003 15.8003C15.6724 15.9281 15.499 16 15.3182 16H1.68182C1.50099 16 1.32757 15.9281 1.1997 15.8003C1.07183 15.6724 1 15.499 1 15.3181V10.5454'
        stroke='#B0CEED'
        stroke-width='1.5'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
};

export const RenameIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='15'
      viewBox='0 0 16 15'
      fill='none'>
      <path
        d='M14.2031 2.24291C14.7805 2.82032 14.79 3.75352 14.2244 4.34251L8.11389 10.706C7.8386 10.9927 7.46078 11.1584 7.06341 11.1667L4.49547 11.2206L4.54967 8.6374C4.55782 8.24907 4.71629 7.87904 4.99172 7.60517L11.2388 1.3938C11.8251 0.810878 12.7725 0.812235 13.3571 1.39683L14.2031 2.24291Z'
        fill='#3699FF'
      />
      <path
        opacity='0.3'
        d='M8.00092 0.319336C8.40631 0.319336 8.73494 0.647972 8.73494 1.05336C8.73494 1.45876 8.40631 1.78739 8.00092 1.78739H2.93612C2.12533 1.78739 1.46806 2.44467 1.46806 3.25545V12.0638C1.46806 12.8746 2.12533 13.5319 2.93612 13.5319H11.7445C12.5553 13.5319 13.2125 12.8746 13.2125 12.0638V8.39365C13.2125 7.98826 13.5412 7.65963 13.9466 7.65963C14.3519 7.65963 14.6806 7.98826 14.6806 8.39365V12.0638C14.6806 13.6854 13.366 14.9999 11.7445 14.9999H2.93612C1.31454 14.9999 0 13.6854 0 12.0638V3.25545C0 1.63388 1.31454 0.319336 2.93612 0.319336H8.00092Z'
        fill='#3699FF'
      />
    </svg>
  );
};
export const MoveIcon = ({
  stroke1 = "#B0CEED",
  stroke2 = "#3699FF",
  size = "16",
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 17 17'
      fill='none'>
      <path
        d='M10.5407 13.9592L8.49985 16.0001L6.45898 13.9592'
        stroke={stroke1}
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M8.5 10.8076V15.9999'
        stroke={stroke1}
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M6.45898 3.04086L8.49985 1L10.5407 3.04086'
        stroke={stroke1}
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M8.5 6.1923V1'
        stroke={stroke1}
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M3.04086 10.541L1 8.50009L3.04086 6.45923'
        stroke={stroke2}
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M6.1923 8.5H1'
        stroke={stroke2}
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M13.959 6.45923L15.9998 8.50009L13.959 10.541'
        stroke={stroke2}
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M10.8076 8.5H15.9999'
        stroke={stroke2}
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
};

export const CloseIconButton = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M0.43934 0.43934C1.02513 -0.146447 1.97487 -0.146447 2.56066 0.43934L6 3.87868L9.43934 0.43934C10.0251 -0.146447 10.9749 -0.146447 11.5607 0.43934C12.1464 1.02513 12.1464 1.97487 11.5607 2.56066L8.12132 6L11.5607 9.43934C12.1464 10.0251 12.1464 10.9749 11.5607 11.5607C10.9749 12.1464 10.0251 12.1464 9.43934 11.5607L6 8.12132L2.56066 11.5607C1.97487 12.1464 1.02513 12.1464 0.43934 11.5607C-0.146447 10.9749 -0.146447 10.0251 0.43934 9.43934L3.87868 6L0.43934 2.56066C-0.146447 1.97487 -0.146447 1.02513 0.43934 0.43934Z'
        fill='#3699FF'
      />
    </svg>
  );
};

export const CloseGrayIconButton = () => {
  return (
    <svg
      width='17'
      height='16'
      viewBox='0 0 17 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M12.668 4L4.66797 12'
        stroke='#A9B3BC'
        stroke-width='2'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M4.66797 4L12.668 12'
        stroke='#A9B3BC'
        stroke-width='2'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
};
export const CircleCheckedIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'>
      <path
        opacity='0.3'
        d='M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z'
        fill='white'
      />
      <path
        d='M11.7102 15.7102L17.7102 9.71019C17.8034 9.61695 17.8774 9.50626 17.9278 9.38444C17.9783 9.26261 18.0043 9.13204 18.0043 9.00019C18.0043 8.86833 17.9783 8.73776 17.9278 8.61594C17.8774 8.49411 17.8034 8.38342 17.7102 8.29019C17.6169 8.19695 17.5063 8.12299 17.3844 8.07253C17.2626 8.02207 17.132 7.99609 17.0002 7.99609C16.8683 7.99609 16.7378 8.02207 16.6159 8.07253C16.4941 8.12299 16.3834 8.19695 16.2902 8.29019L11.0002 13.5902L7.71019 10.2902C7.52188 10.1019 7.26649 9.99609 7.00019 9.99609C6.73388 9.99609 6.47849 10.1019 6.29019 10.2902C6.10188 10.4785 5.99609 10.7339 5.99609 11.0002C5.99609 11.2665 6.10188 11.5219 6.29019 11.7102L10.2902 15.7102C10.3831 15.8039 10.4937 15.8783 10.6156 15.9291C10.7375 15.9798 10.8682 16.006 11.0002 16.006C11.1322 16.006 11.2629 15.9798 11.3848 15.9291C11.5066 15.8783 11.6172 15.8039 11.7102 15.7102Z'
        fill='white'
      />
    </svg>
  );
};

export const CircleCrossIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'>
      <path
        d='M10.9997 10.9301C10.8123 11.1163 10.5589 11.2209 10.2947 11.2209C10.0305 11.2209 9.77707 11.1163 9.5897 10.9301L1.0497 2.49009C0.955976 2.39713 0.881582 2.28653 0.830813 2.16467C0.780044 2.04281 0.753906 1.9121 0.753906 1.78009C0.753906 1.64808 0.780044 1.51737 0.830813 1.39551C0.881582 1.27365 0.955976 1.16305 1.0497 1.07009C1.23707 0.883839 1.49052 0.779297 1.7547 0.779297C2.01889 0.779297 2.27234 0.883839 2.4597 1.07009L10.9997 9.51009C11.0934 9.60305 11.1678 9.71365 11.2186 9.83551C11.2694 9.95737 11.2955 10.0881 11.2955 10.2201C11.2955 10.3521 11.2694 10.4828 11.2186 10.6047C11.1678 10.7265 11.0934 10.8371 10.9997 10.9301Z'
        fill='white'
      />
      <path
        d='M2.45992 10.9997C2.26896 11.1933 2.00892 11.3031 1.73699 11.305C1.46506 11.3068 1.20353 11.2006 1.00992 11.0097C0.816311 10.8187 0.70649 10.5587 0.704614 10.2867C0.702739 10.0148 0.808963 9.75327 0.999919 9.55967L9.53992 0.999665C9.73088 0.806057 9.99092 0.696236 10.2628 0.69436C10.5348 0.692485 10.7963 0.798709 10.9899 0.989665C11.1835 1.18062 11.2933 1.44067 11.2952 1.71259C11.2971 1.98452 11.1909 2.24606 10.9999 2.43966L2.45992 10.9997Z'
        fill='white'
      />
    </svg>
  );
};

export const BackupLabel = () => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g clip-path='url(#clip0_6792_56365)'>
        <path
          d='M16.6667 5V16.6667H5V18.3333H16.6667C17.5833 18.3333 18.3333 17.5833 18.3333 16.6667V5H16.6667Z'
          fill='#C2E0FF'
        />
        <path
          d='M13.3346 1.66406H3.33464C2.41797 1.66406 1.66797 2.41406 1.66797 3.33073V13.3307C1.66797 14.2474 2.41797 14.9974 3.33464 14.9974H13.3346C14.2513 14.9974 15.0013 14.2474 15.0013 13.3307V3.33073C15.0013 2.41406 14.2513 1.66406 13.3346 1.66406ZM7.5013 13.3307H3.33464V9.16406H7.5013V13.3307ZM13.3346 13.3307H9.16797V9.16406H13.3346V13.3307ZM13.3346 7.4974H3.33464V3.33073H13.3346V7.4974Z'
          fill='#3699FF'
        />
      </g>
      <defs>
        <clipPath id='clip0_6792_56365'>
          <rect width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};
export const SearchFilterIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='16'
      viewBox='0 0 18 16'
      fill='none'>
      <path
        d='M0.667055 3.75834C0.667047 3.67665 0.68327 3.59578 0.71478 3.52041C0.74629 3.44505 0.79246 3.37669 0.850608 3.31932C0.908757 3.26195 0.977725 3.2167 1.05351 3.1862C1.12929 3.15571 1.21037 3.14057 1.29205 3.14167H4.23372C4.38908 2.34465 4.83572 1.63407 5.48655 1.14847C6.13738 0.662877 6.94573 0.437087 7.75399 0.515129C8.56226 0.593171 9.31248 0.96945 9.85838 1.57059C10.4043 2.17174 10.7067 2.95465 10.7067 3.76667C10.7067 4.5787 10.4043 5.36161 9.85838 5.96275C9.31248 6.5639 8.56226 6.94018 7.75399 7.01822C6.94573 7.09626 6.13738 6.87047 5.48655 6.38488C4.83572 5.89928 4.38908 5.18869 4.23372 4.39167H1.31705C1.23219 4.39508 1.14753 4.38115 1.06823 4.35075C0.988927 4.32034 0.916656 4.27409 0.855827 4.21482C0.794997 4.15555 0.746886 4.08451 0.71443 4.00602C0.681974 3.92754 0.665854 3.84326 0.667055 3.75834ZM12.0004 4.39167H16.6504C16.7379 4.3999 16.8262 4.38955 16.9095 4.36131C16.9928 4.33307 17.0692 4.28758 17.1337 4.22781C17.1982 4.16803 17.2493 4.09532 17.2838 4.01442C17.3183 3.93352 17.3353 3.84626 17.3337 3.75834C17.3337 3.67665 17.3175 3.59578 17.286 3.52041C17.2545 3.44505 17.2083 3.37669 17.1502 3.31932C17.092 3.26195 17.0231 3.2167 16.9473 3.1862C16.8715 3.15571 16.7904 3.14057 16.7087 3.14167H12.0254C11.9433 3.14276 11.8622 3.16001 11.7868 3.19242C11.7114 3.22484 11.6431 3.2718 11.5859 3.33061C11.5286 3.38942 11.4835 3.45894 11.4531 3.53519C11.4227 3.61144 11.4076 3.69293 11.4087 3.77501C11.4087 3.8567 11.4249 3.93757 11.4564 4.01294C11.488 4.0883 11.5341 4.15666 11.5923 4.21403C11.6504 4.2714 11.7194 4.31665 11.7952 4.34715C11.871 4.37764 11.952 4.39278 12.0337 4.39167H12.0004ZM16.6421 11.6H13.7671C13.6117 10.803 13.1651 10.0924 12.5142 9.60681C11.8634 9.12121 11.055 8.89542 10.2468 8.97346C9.43852 9.05151 8.6883 9.42778 8.1424 10.0289C7.5965 10.6301 7.29407 11.413 7.29407 12.225C7.29407 13.037 7.5965 13.8199 8.1424 14.4211C8.6883 15.0222 9.43852 15.3985 10.2468 15.4766C11.055 15.5546 11.8634 15.3288 12.5142 14.8432C13.1651 14.3576 13.6117 13.647 13.7671 12.85H16.6837C16.7658 12.8489 16.8469 12.8317 16.9223 12.7993C16.9977 12.7668 17.066 12.7199 17.1232 12.6611C17.1805 12.6023 17.2256 12.5327 17.256 12.4565C17.2864 12.3802 17.3015 12.2988 17.3004 12.2167C17.3004 12.135 17.2842 12.0541 17.2527 11.9787C17.2212 11.9034 17.175 11.835 17.1168 11.7777C17.0587 11.7203 16.9897 11.675 16.9139 11.6445C16.8382 11.614 16.7571 11.5989 16.6754 11.6H16.6421ZM5.94205 11.6H1.32539C1.24371 11.5989 1.16262 11.614 1.08684 11.6445C1.01106 11.675 0.94209 11.7203 0.883942 11.7777C0.825793 11.835 0.779623 11.9034 0.748113 11.9787C0.716603 12.0541 0.700381 12.135 0.700388 12.2167C0.699286 12.2988 0.714364 12.3802 0.744759 12.4565C0.775155 12.5327 0.820273 12.6023 0.877537 12.6611C0.934801 12.7199 1.00309 12.7668 1.0785 12.7993C1.15392 12.8317 1.23498 12.8489 1.31705 12.85H5.96705C6.13281 12.85 6.29179 12.7842 6.409 12.667C6.52621 12.5497 6.59205 12.3908 6.59205 12.225C6.59318 12.1437 6.57799 12.063 6.5474 11.9877C6.51681 11.9124 6.47142 11.8439 6.41394 11.7865C6.35645 11.729 6.28802 11.6836 6.2127 11.653C6.13737 11.6224 6.05668 11.6072 5.97539 11.6083L5.94205 11.6Z'
        fill='#7E8299'
      />
    </svg>
  );
};
export const AssetLiabraryIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'>
      <path
        d='M14.4 7.83333H18.8L14.4 3.25V7.83333ZM8.8 2H15.2L20 7V17C20 17.442 19.8314 17.8659 19.5314 18.1785C19.2313 18.4911 18.8243 18.6667 18.4 18.6667H8.8C7.912 18.6667 7.2 17.9167 7.2 17V3.66667C7.2 3.22464 7.36857 2.80072 7.66863 2.48816C7.96869 2.17559 8.37565 2 8.8 2ZM5.6 5.33333V20.3333H18.4V22H5.6C5.17565 22 4.76869 21.8244 4.46863 21.5118C4.16857 21.1993 4 20.7754 4 20.3333V5.33333H5.6Z'
        fill='#3699FF'
      />
    </svg>
  );
};

export const SearchIcon = () => {
  return (
    <svg
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M16.1251 14.5649L13.7476 12.3149C13.2955 12.8969 12.7538 13.4033 12.1426 13.8149L14.5876 16.1399C14.6904 16.26 14.8175 16.3569 14.9605 16.4242C15.1036 16.4916 15.2592 16.5278 15.4173 16.5305C15.5753 16.5332 15.7322 16.5023 15.8774 16.44C16.0227 16.3776 16.153 16.2851 16.2599 16.1686C16.3668 16.0521 16.4477 15.9143 16.4974 15.7642C16.547 15.6141 16.5643 15.4552 16.548 15.298C16.5317 15.1408 16.4822 14.9888 16.4029 14.8521C16.3235 14.7154 16.216 14.597 16.0876 14.5049L16.1251 14.5649Z'
        fill='#7E8299'
      />
      <path
        d='M8.35547 1.5C7.02045 1.5 5.7154 1.89588 4.60537 2.63758C3.49534 3.37928 2.63018 4.43349 2.11928 5.66689C1.60839 6.90029 1.47472 8.25749 1.73517 9.56686C1.99562 10.8762 2.6385 12.079 3.5825 13.023C4.52651 13.967 5.72924 14.6099 7.03861 14.8703C8.34798 15.1308 9.70518 14.9971 10.9386 14.4862C12.172 13.9753 13.2262 13.1101 13.9679 12.0001C14.7096 10.8901 15.1055 9.58502 15.1055 8.25C15.1055 6.45979 14.3943 4.7429 13.1284 3.47703C11.8626 2.21116 10.1457 1.5 8.35547 1.5ZM8.35547 13.02C7.41386 13.02 6.49338 12.7409 5.71035 12.2179C4.92732 11.6949 4.3169 10.9516 3.95622 10.0818C3.59554 9.21196 3.50079 8.25477 3.68394 7.33114C3.8671 6.40751 4.31994 5.5589 4.98523 4.89255C5.65053 4.22621 6.49843 3.77203 7.42176 3.58743C8.3451 3.40282 9.30245 3.49606 10.1728 3.85537C11.0432 4.21469 11.7875 4.82394 12.3117 5.60614C12.8359 6.38835 13.1165 7.30839 13.118 8.25C13.1199 8.87633 12.9982 9.49688 12.7596 10.076C12.5211 10.6551 12.1705 11.1814 11.7279 11.6247C11.2854 12.0679 10.7597 12.4193 10.1809 12.6588C9.60216 12.8982 8.9818 13.021 8.35547 13.02Z'
        fill='#7E8299'
      />
    </svg>
  );
};

export const DeleteOverlayCloseIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='36'
      height='36'
      viewBox='0 0 36 36'
      fill='none'>
      <path
        opacity='0.25'
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M3.55349 9.81276C3.98869 6.51756 6.51757 3.98869 9.81276 3.55349C12.0781 3.2543 14.9119 3 18 3C21.0881 3 23.9219 3.2543 26.1872 3.55349C29.4824 3.98869 32.0113 6.51757 32.4465 9.81276C32.7457 12.0781 33 14.9119 33 18C33 21.0881 32.7457 23.9219 32.4465 26.1872C32.0113 29.4824 29.4824 32.0113 26.1872 32.4465C23.9219 32.7457 21.0881 33 18 33C14.9119 33 12.0781 32.7457 9.81276 32.4465C6.51756 32.0113 3.98869 29.4824 3.55349 26.1872C3.2543 23.9219 3 21.0881 3 18C3 14.9119 3.2543 12.0781 3.55349 9.81276Z'
        fill='white'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M12.4393 12.4393C13.0251 11.8536 13.9749 11.8536 14.5607 12.4393L18 15.8787L21.4393 12.4393C22.0251 11.8536 22.9749 11.8536 23.5607 12.4393C24.1464 13.0251 24.1464 13.9749 23.5607 14.5607L20.1213 18L23.5607 21.4393C24.1464 22.0251 24.1464 22.9749 23.5607 23.5607C22.9749 24.1464 22.0251 24.1464 21.4393 23.5607L18 20.1213L14.5607 23.5607C13.9749 24.1464 13.0251 24.1464 12.4393 23.5607C11.8536 22.9749 11.8536 22.0251 12.4393 21.4393L15.8787 18L12.4393 14.5607C11.8536 13.9749 11.8536 13.0251 12.4393 12.4393Z'
        fill='#3699FF'
      />
    </svg>
  );
};

export const BackSpaceIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'>
      <g clip-path='url(#clip0_6727_64624)'>
        <path
          d='M3 11H17.17L13.59 7.41L15 6L21 12L15 18L13.59 16.59L17.17 13H3V11Z'
          fill='#3699FF'
        />
      </g>
      <defs>
        <clipPath id='clip0_6727_64624'>
          <rect
            width='24'
            height='24'
            fill='white'
            transform='matrix(-1 0 0 1 24 0)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const OutlinedStar = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M10.0012 15.0001L6.59756 16.7895C6.19019 17.0037 5.68633 16.8471 5.47216 16.4397C5.38688 16.2775 5.35745 16.0917 5.38843 15.911L6.03847 12.121L3.28486 9.43692C2.95529 9.11567 2.94855 8.58807 3.2698 8.2585C3.39772 8.12727 3.56534 8.04186 3.7467 8.01551L7.5521 7.46255L9.25393 4.01427C9.45761 3.60156 9.9573 3.43211 10.37 3.6358C10.5344 3.71691 10.6674 3.84993 10.7485 4.01427L12.4503 7.46255L16.2557 8.01551C16.7112 8.08169 17.0267 8.50456 16.9605 8.96001C16.9342 9.14137 16.8488 9.30899 16.7176 9.43692L13.9639 12.121L14.614 15.911C14.6918 16.3647 14.3871 16.7955 13.9335 16.8733C13.7529 16.9042 13.5671 16.8748 13.4049 16.7895L10.0012 15.0001Z'
        stroke='#70808F'
      />
    </svg>
  );
};

export const FilterSettingIcon = () => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M1.66705 5.75834C1.66705 5.67665 1.68327 5.59578 1.71478 5.52041C1.74629 5.44505 1.79246 5.37669 1.85061 5.31932C1.90876 5.26195 1.97772 5.2167 2.05351 5.1862C2.12929 5.15571 2.21037 5.14057 2.29205 5.14167H5.23372C5.38908 4.34465 5.83572 3.63407 6.48655 3.14847C7.13738 2.66288 7.94573 2.43709 8.75399 2.51513C9.56226 2.59317 10.3125 2.96945 10.8584 3.57059C11.4043 4.17174 11.7067 4.95465 11.7067 5.76667C11.7067 6.5787 11.4043 7.36161 10.8584 7.96275C10.3125 8.5639 9.56226 8.94018 8.75399 9.01822C7.94573 9.09626 7.13738 8.87047 6.48655 8.38488C5.83572 7.89928 5.38908 7.18869 5.23372 6.39167H2.31705C2.23219 6.39508 2.14753 6.38115 2.06823 6.35075C1.98893 6.32034 1.91666 6.27409 1.85583 6.21482C1.795 6.15555 1.74689 6.08451 1.71443 6.00602C1.68197 5.92754 1.66585 5.84326 1.66705 5.75834ZM13.0004 6.39167H17.6504C17.7379 6.3999 17.8262 6.38955 17.9095 6.36131C17.9928 6.33307 18.0692 6.28758 18.1337 6.22781C18.1982 6.16803 18.2493 6.09532 18.2838 6.01442C18.3183 5.93352 18.3353 5.84626 18.3337 5.75834C18.3337 5.67665 18.3175 5.59578 18.286 5.52041C18.2545 5.44505 18.2083 5.37669 18.1502 5.31932C18.092 5.26195 18.0231 5.2167 17.9473 5.1862C17.8715 5.15571 17.7904 5.14057 17.7087 5.14167H13.0254C12.9433 5.14276 12.8622 5.16001 12.7868 5.19242C12.7114 5.22484 12.6431 5.2718 12.5859 5.33061C12.5286 5.38942 12.4835 5.45894 12.4531 5.53519C12.4227 5.61144 12.4076 5.69293 12.4087 5.77501C12.4087 5.8567 12.4249 5.93757 12.4564 6.01294C12.488 6.0883 12.5341 6.15666 12.5923 6.21403C12.6504 6.2714 12.7194 6.31665 12.7952 6.34715C12.871 6.37764 12.952 6.39278 13.0337 6.39167H13.0004ZM17.6421 13.6H14.7671C14.6117 12.803 14.1651 12.0924 13.5142 11.6068C12.8634 11.1212 12.055 10.8954 11.2468 10.9735C10.4385 11.0515 9.6883 11.4278 9.1424 12.0289C8.5965 12.6301 8.29407 13.413 8.29407 14.225C8.29407 15.037 8.5965 15.8199 9.1424 16.4211C9.6883 17.0222 10.4385 17.3985 11.2468 17.4766C12.055 17.5546 12.8634 17.3288 13.5142 16.8432C14.1651 16.3576 14.6117 15.647 14.7671 14.85H17.6837C17.7658 14.8489 17.8469 14.8317 17.9223 14.7993C17.9977 14.7668 18.066 14.7199 18.1232 14.6611C18.1805 14.6023 18.2256 14.5327 18.256 14.4565C18.2864 14.3802 18.3015 14.2988 18.3004 14.2167C18.3004 14.135 18.2842 14.0541 18.2527 13.9787C18.2212 13.9034 18.175 13.835 18.1168 13.7777C18.0587 13.7203 17.9897 13.675 17.9139 13.6445C17.8382 13.614 17.7571 13.5989 17.6754 13.6H17.6421ZM6.94205 13.6H2.32539C2.24371 13.5989 2.16262 13.614 2.08684 13.6445C2.01106 13.675 1.94209 13.7203 1.88394 13.7777C1.82579 13.835 1.77962 13.9034 1.74811 13.9787C1.7166 14.0541 1.70038 14.135 1.70039 14.2167C1.69929 14.2988 1.71436 14.3802 1.74476 14.4565C1.77515 14.5327 1.82027 14.6023 1.87754 14.6611C1.9348 14.7199 2.00309 14.7668 2.0785 14.7993C2.15392 14.8317 2.23498 14.8489 2.31705 14.85H6.96705C7.13281 14.85 7.29179 14.7842 7.409 14.667C7.52621 14.5497 7.59205 14.3908 7.59205 14.225C7.59318 14.1437 7.57799 14.063 7.5474 13.9877C7.51681 13.9124 7.47142 13.8439 7.41394 13.7865C7.35645 13.729 7.28802 13.6836 7.2127 13.653C7.13737 13.6224 7.05668 13.6072 6.97539 13.6083L6.94205 13.6Z'
        fill='#7E8299'
      />
    </svg>
  );
};

export const CloseChipIcon = () => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M12 4L4 12'
        stroke='#A9B3BC'
        stroke-width='2'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M4 4L12 12'
        stroke='#A9B3BC'
        stroke-width='2'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
};

export const AddIconWithBGColor = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='17'
      viewBox='0 0 16 17'
      fill='none'>
      <rect y='0.5' width='16' height='16' rx='3.33333' fill='#3699FF' />
      <path
        d='M8.00049 4.5L8.00049 12.5'
        stroke='white'
        stroke-width='2'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M4 8.5H12'
        stroke='white'
        stroke-width='2'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
};

export const ChipCross = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'>
      <path
        d='M12 4L4 12'
        stroke='#A9B3BC'
        stroke-width='2'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M4 4L12 12'
        stroke='#A9B3BC'
        stroke-width='2'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
};
export const ChevronRight = () => {
  return (
    <svg
      width='7'
      height='13'
      viewBox='0 0 7 13'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M6.66733 6.32931C6.66796 6.43899 6.64694 6.54771 6.60547 6.64924C6.564 6.75077 6.5029 6.84311 6.42566 6.92098L1.42566 11.921C1.34819 11.9991 1.25602 12.0611 1.15447 12.1034C1.05293 12.1457 0.944004 12.1675 0.833994 12.1675C0.723984 12.1675 0.615062 12.1457 0.513513 12.1034C0.411964 12.0611 0.319796 11.9991 0.242327 11.921C0.0871179 11.7648 0 11.5536 0 11.3335C0 11.1133 0.0871179 10.9021 0.242327 10.746L4.65899 6.32931L0.242327 1.92098C0.0871179 1.76484 0 1.55364 0 1.33348C0 1.11333 0.0871179 0.902116 0.242327 0.74598C0.319796 0.667873 0.411964 0.605879 0.513513 0.563571C0.615062 0.521264 0.723984 0.499483 0.833994 0.499483C0.944004 0.499483 1.05293 0.521264 1.15447 0.563571C1.25602 0.605879 1.34819 0.667873 1.42566 0.74598L6.42566 5.74598C6.57962 5.9012 6.66641 6.1107 6.66733 6.32931Z'
        fill='#7E8299'
      />
    </svg>
  );
};

export const ExpandIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='22'
      height='22'
      viewBox='0 0 22 22'
      fill='none'>
      <path
        d='M19 3.72727V8.09091C19 8.28379 18.9234 8.46878 18.787 8.60517C18.6506 8.74156 18.4656 8.81818 18.2727 8.81818C18.0798 8.81818 17.8949 8.74156 17.7585 8.60517C17.6221 8.46878 17.5455 8.28379 17.5455 8.09091V5.48273L12.9691 10.06C12.8326 10.1965 12.6475 10.2731 12.4545 10.2731C12.2616 10.2731 12.0765 10.1965 11.94 10.06C11.8035 9.92353 11.7269 9.73845 11.7269 9.54545C11.7269 9.35246 11.8035 9.16738 11.94 9.03091L16.5173 4.45455H13.9091C13.7162 4.45455 13.5312 4.37792 13.3948 4.24153C13.2584 4.10514 13.1818 3.92016 13.1818 3.72727C13.1818 3.53439 13.2584 3.3494 13.3948 3.21301C13.5312 3.07662 13.7162 3 13.9091 3H18.2727C18.4656 3 18.6506 3.07662 18.787 3.21301C18.9234 3.3494 19 3.53439 19 3.72727ZM9.03091 11.94L4.45455 16.5173V13.9091C4.45455 13.7162 4.37792 13.5312 4.24153 13.3948C4.10514 13.2584 3.92016 13.1818 3.72727 13.1818C3.53439 13.1818 3.3494 13.2584 3.21301 13.3948C3.07662 13.5312 3 13.7162 3 13.9091V18.2727C3 18.4656 3.07662 18.6506 3.21301 18.787C3.3494 18.9234 3.53439 19 3.72727 19H8.09091C8.28379 19 8.46878 18.9234 8.60517 18.787C8.74156 18.6506 8.81818 18.4656 8.81818 18.2727C8.81818 18.0798 8.74156 17.8949 8.60517 17.7585C8.46878 17.6221 8.28379 17.5455 8.09091 17.5455H5.48273L10.06 12.9691C10.1965 12.8326 10.2731 12.6475 10.2731 12.4545C10.2731 12.2616 10.1965 12.0765 10.06 11.94C9.92353 11.8035 9.73845 11.7269 9.54545 11.7269C9.35246 11.7269 9.16738 11.8035 9.03091 11.94Z'
        fill='#3699FF'
      />
    </svg>
  );
};

export const ChatClose = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'>
      <path
        d='M18 6L6 18'
        stroke='#A9B3BC'
        stroke-width='2'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M6 6L18 18'
        stroke='#A9B3BC'
        stroke-width='2'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
};

export const ChatPlus = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'>
      <rect width='12' height='12' rx='2.5' fill='#3699FF' />
      <path
        d='M6 3.69238V8.30777'
        stroke='white'
        stroke-width='0.923077'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M3.69141 6H8.30679'
        stroke='white'
        stroke-width='0.923077'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
};

export const ChatUser = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M3.33316 2.66655C3.33316 4.13925 4.52701 5.33311 5.99971 5.33311C7.4724 5.33311 8.66626 4.13925 8.66626 2.66655C8.66626 1.19386 7.4724 0 5.99971 0C4.52701 0 3.33316 1.19386 3.33316 2.66655ZM5.98864 6.66704C2.84115 6.66704 0.258828 8.28465 0.000434438 11.4663C-0.0136406 11.6396 0.317795 12.0001 0.484981 12.0001H11.4973C11.9981 12.0001 12.0059 11.5971 11.9981 11.4668C11.8028 8.19577 9.18042 6.66704 5.98864 6.66704Z'
        fill='#3699FF'
      />
    </svg>
  );
};
export const ExpandCloseIcon = () => {
  return (
    <svg
      width='22'
      height='22'
      viewBox='0 0 22 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M12.1224 8.48626V4.85008C12.1224 4.65721 12.1991 4.47223 12.3354 4.33585C12.4718 4.19946 12.6568 4.12284 12.8497 4.12284C13.0426 4.12284 13.2275 4.19946 13.3639 4.33585C13.5003 4.47223 13.5769 4.65721 13.5769 4.85008V6.7309L17.4258 2.88109C17.5623 2.74463 17.7473 2.66797 17.9403 2.66797C18.1333 2.66797 18.3184 2.74463 18.4548 2.88109C18.5913 3.01755 18.668 3.20263 18.668 3.39561C18.668 3.58859 18.5913 3.77367 18.4548 3.91013L14.605 7.75902H16.4859C16.6787 7.75902 16.8637 7.83564 17.0001 7.97203C17.1365 8.10841 17.2131 8.29339 17.2131 8.48626C17.2131 8.67914 17.1365 8.86411 17.0001 9.00049C16.8637 9.13688 16.6787 9.2135 16.4859 9.2135H12.8497C12.6568 9.2135 12.4718 9.13688 12.3354 9.00049C12.1991 8.86411 12.1224 8.67914 12.1224 8.48626ZM8.48626 12.1224H4.85008C4.65721 12.1224 4.47223 12.1991 4.33585 12.3354C4.19946 12.4718 4.12284 12.6568 4.12284 12.8497C4.12284 13.0426 4.19946 13.2275 4.33585 13.3639C4.47223 13.5003 4.65721 13.5769 4.85008 13.5769H6.7309L2.88109 17.4258C2.74463 17.5623 2.66797 17.7473 2.66797 17.9403C2.66797 18.1333 2.74463 18.3184 2.88109 18.4548C3.01755 18.5913 3.20263 18.668 3.39561 18.668C3.58859 18.668 3.77367 18.5913 3.91013 18.4548L7.75902 14.605V16.4859C7.75902 16.6787 7.83564 16.8637 7.97203 17.0001C8.10841 17.1365 8.29339 17.2131 8.48626 17.2131C8.67914 17.2131 8.86411 17.1365 9.00049 17.0001C9.13688 16.8637 9.2135 16.6787 9.2135 16.4859V12.8497C9.2135 12.6568 9.13688 12.4718 9.00049 12.3354C8.86411 12.1991 8.67914 12.1224 8.48626 12.1224ZM14.605 13.5769H16.4859C16.6787 13.5769 16.8637 13.5003 17.0001 13.3639C17.1365 13.2275 17.2131 13.0426 17.2131 12.8497C17.2131 12.6568 17.1365 12.4718 17.0001 12.3354C16.8637 12.1991 16.6787 12.1224 16.4859 12.1224H12.8497C12.6568 12.1224 12.4718 12.1991 12.3354 12.3354C12.1991 12.4718 12.1224 12.6568 12.1224 12.8497V16.4859C12.1224 16.6787 12.1991 16.8637 12.3354 17.0001C12.4718 17.1365 12.6568 17.2131 12.8497 17.2131C13.0426 17.2131 13.2275 17.1365 13.3639 17.0001C13.5003 16.8637 13.5769 16.6787 13.5769 16.4859V14.605L17.4258 18.4548C17.4934 18.5224 17.5736 18.576 17.6619 18.6126C17.7502 18.6491 17.8448 18.668 17.9403 18.668C18.0359 18.668 18.1305 18.6491 18.2188 18.6126C18.3071 18.576 18.3873 18.5224 18.4548 18.4548C18.5224 18.3873 18.576 18.3071 18.6126 18.2188C18.6491 18.1305 18.668 18.0359 18.668 17.9403C18.668 17.8448 18.6491 17.7502 18.6126 17.6619C18.576 17.5736 18.5224 17.4934 18.4548 17.4258L14.605 13.5769ZM8.48626 4.12284C8.29339 4.12284 8.10841 4.19946 7.97203 4.33585C7.83564 4.47223 7.75902 4.65721 7.75902 4.85008V6.7309L3.91013 2.88109C3.77367 2.74463 3.58859 2.66797 3.39561 2.66797C3.20263 2.66797 3.01755 2.74463 2.88109 2.88109C2.74463 3.01755 2.66797 3.20263 2.66797 3.39561C2.66797 3.58859 2.74463 3.77367 2.88109 3.91013L6.7309 7.75902H4.85008C4.65721 7.75902 4.47223 7.83564 4.33585 7.97203C4.19946 8.10841 4.12284 8.29339 4.12284 8.48626C4.12284 8.67914 4.19946 8.86411 4.33585 9.00049C4.47223 9.13688 4.65721 9.2135 4.85008 9.2135H8.48626C8.67914 9.2135 8.86411 9.13688 9.00049 9.00049C9.13688 8.86411 9.2135 8.67914 9.2135 8.48626V4.85008C9.2135 4.65721 9.13688 4.47223 9.00049 4.33585C8.86411 4.19946 8.67914 4.12284 8.48626 4.12284Z'
        fill='#3699FF'
      />
    </svg>
  );
};

export const NoInbox = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'>
      <path
        d='M10.8 0H1.2C0.88174 0 0.576515 0.126428 0.351472 0.351472C0.126428 0.576515 0 0.88174 0 1.2V10.8C0 11.1183 0.126428 11.4235 0.351472 11.6485C0.576515 11.8736 0.88174 12 1.2 12H10.8C11.1183 12 11.4235 11.8736 11.6485 11.6485C11.8736 11.4235 12 11.1183 12 10.8V1.2C12 0.88174 11.8736 0.576515 11.6485 0.351472C11.4235 0.126428 11.1183 0 10.8 0ZM10.56 1.44V6.96H9.0786C8.92096 6.95957 8.7648 6.99043 8.61917 7.05078C8.47354 7.11114 8.34133 7.19979 8.2302 7.3116L7.14 8.4H4.86L3.7698 7.3116C3.65867 7.19979 3.52646 7.11114 3.38083 7.05078C3.2352 6.99043 3.07904 6.95957 2.9214 6.96H1.44V1.44H10.56ZM1.44 10.56V8.4H2.82L3.9084 9.4884C4.01974 9.60043 4.15224 9.6892 4.2982 9.74956C4.44416 9.80992 4.60066 9.84066 4.7586 9.84H7.2414C7.39904 9.84043 7.5552 9.80957 7.70083 9.74922C7.84646 9.68886 7.97867 9.60021 8.0898 9.4884L9.18 8.4H10.56V10.56H1.44Z'
        fill='#3699FF'
      />
    </svg>
  );
};

export const Dragable = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='10'
      viewBox='0 0 18 10'
      fill='none'>
      <path
        d='M1 1H17'
        stroke='#A9B2BC'
        stroke-width='2'
        stroke-linecap='round'
      />
      <path
        d='M1 5H17'
        stroke='#A9B2BC'
        stroke-width='2'
        stroke-linecap='round'
      />
      <path
        d='M1 9H17'
        stroke='#A9B2BC'
        stroke-width='2'
        stroke-linecap='round'
      />
    </svg>
  );
};

export const Magnifier = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='19'
      height='18'
      viewBox='0 0 19 18'
      fill='none'>
      <path
        d='M17.0509 14.5649L14.6734 12.3149C14.2213 12.8969 13.6796 13.4033 13.0684 13.8149L15.5134 16.1399C15.6162 16.26 15.7433 16.3569 15.8863 16.4242C16.0293 16.4916 16.185 16.5278 16.3431 16.5305C16.5011 16.5332 16.658 16.5023 16.8032 16.44C16.9484 16.3776 17.0788 16.2851 17.1857 16.1686C17.2925 16.0521 17.3735 15.9143 17.4231 15.7642C17.4728 15.6141 17.4901 15.4552 17.4738 15.298C17.4575 15.1408 17.408 14.9888 17.3287 14.8521C17.2493 14.7154 17.1418 14.597 17.0134 14.5049L17.0509 14.5649Z'
        fill='#7E8299'
      />
      <path
        d='M9.28125 1.5C7.94623 1.5 6.64119 1.89588 5.53115 2.63758C4.42112 3.37928 3.55596 4.43349 3.04507 5.66689C2.53417 6.90029 2.4005 8.25749 2.66095 9.56686C2.9214 10.8762 3.56428 12.079 4.50828 13.023C5.45229 13.967 6.65502 14.6099 7.96439 14.8703C9.27376 15.1308 10.631 14.9971 11.8644 14.4862C13.0978 13.9753 14.152 13.1101 14.8937 12.0001C15.6354 10.8901 16.0313 9.58502 16.0313 8.25C16.0313 6.45979 15.3201 4.7429 14.0542 3.47703C12.7884 2.21116 11.0715 1.5 9.28125 1.5ZM9.28125 13.02C8.33964 13.02 7.41916 12.7409 6.63613 12.2179C5.85311 11.6949 5.24268 10.9516 4.882 10.0818C4.52132 9.21196 4.42657 8.25477 4.60972 7.33114C4.79288 6.40751 5.24572 5.5589 5.91101 4.89255C6.57631 4.22621 7.42421 3.77203 8.34755 3.58743C9.27089 3.40282 10.2282 3.49606 11.0986 3.85537C11.969 4.21469 12.7133 4.82394 13.2375 5.60614C13.7617 6.38835 14.0423 7.30839 14.0438 8.25C14.0457 8.87633 13.9239 9.49688 13.6854 10.076C13.4469 10.6551 13.0962 11.1814 12.6537 11.6247C12.2112 12.0679 11.6854 12.4193 11.1067 12.6588C10.5279 12.8982 9.90758 13.021 9.28125 13.02Z'
        fill='#7E8299'
      />
    </svg>
  );
};

export const Cross = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='17'
      height='17'
      viewBox='0 0 17 17'
      fill='none'>
      <path
        d='M12.332 4.5L4.33203 12.5'
        stroke='#A9B3BC'
        stroke-width='2'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M4.33203 4.5L12.332 12.5'
        stroke='#A9B3BC'
        stroke-width='2'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
};

export const EndUserStarFill = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'>
      <path
        d='M11.5245 1.46353C11.6741 1.00287 12.3259 1.00287 12.4755 1.46353L14.5819 7.9463C14.6488 8.15232 14.8408 8.2918 15.0574 8.2918H21.8738C22.3582 8.2918 22.5596 8.9116 22.1677 9.1963L16.6531 13.2029C16.4779 13.3302 16.4046 13.5559 16.4715 13.7619L18.5779 20.2447C18.7276 20.7053 18.2003 21.0884 17.8085 20.8037L12.2939 16.7971C12.1186 16.6698 11.8814 16.6698 11.7061 16.7971L6.19153 20.8037C5.79967 21.0884 5.27243 20.7053 5.42211 20.2447L7.52849 13.7619C7.59543 13.5559 7.5221 13.3302 7.34685 13.2029L1.83227 9.1963C1.44041 8.9116 1.6418 8.2918 2.12616 8.2918H8.94256C9.15917 8.2918 9.35115 8.15232 9.41809 7.9463L11.5245 1.46353Z'
        fill='#F7C000'
      />
    </svg>
  );
};
export const EndUserStarOutLine = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'>
      <path
        d='M11.5245 1.46353C11.6741 1.00287 12.3259 1.00287 12.4755 1.46353L14.5819 7.9463C14.6488 8.15232 14.8408 8.2918 15.0574 8.2918H21.8738C22.3582 8.2918 22.5596 8.9116 22.1677 9.1963L16.6531 13.2029C16.4779 13.3302 16.4046 13.5559 16.4715 13.7619L18.5779 20.2447C18.7276 20.7053 18.2003 21.0884 17.8085 20.8037L12.2939 16.7971C12.1186 16.6698 11.8814 16.6698 11.7061 16.7971L6.19153 20.8037C5.79967 21.0884 5.27243 20.7053 5.42211 20.2447L7.52849 13.7619C7.59543 13.5559 7.5221 13.3302 7.34685 13.2029L1.83227 9.1963C1.44041 8.9116 1.6418 8.2918 2.12616 8.2918H8.94256C9.15917 8.2918 9.35115 8.15232 9.41809 7.9463L11.5245 1.46353Z'
        fill='#E0E0E0'
      />
    </svg>
  );
};

export const ActiveEndUserIcon = () => {
  return (
    <svg
      width='14'
      height='14'
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g filter='url(#filter0_d_8185_5903)'>
        <circle cx='7' cy='5' r='3' fill='#3699FF' />
      </g>
      <defs>
        <filter
          id='filter0_d_8185_5903'
          x='0'
          y='0'
          width='14'
          height='14'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'>
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='2' />
          <feGaussianBlur stdDeviation='2' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_8185_5903'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_8185_5903'
            result='shape'
          />
        </filter>
      </defs>
    </svg>
  );
};
export const CopyDataIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'>
      <path
        d='M11.8405 3.36577L8.02227 0.135C7.97158 0.0921535 7.91141 0.0581778 7.84519 0.0350141C7.77898 0.0118504 7.70801 -4.75319e-05 7.63636 1.42707e-07H1.09091C0.801582 1.42707e-07 0.524105 0.0972526 0.31952 0.270363C0.114935 0.443474 0 0.678262 0 0.923077V11.0769C0 11.3217 0.114935 11.5565 0.31952 11.7296C0.524105 11.9027 0.801582 12 1.09091 12H10.9091C11.1984 12 11.4759 11.9027 11.6805 11.7296C11.8851 11.5565 12 11.3217 12 11.0769V3.69231C12.0001 3.63168 11.986 3.57164 11.9586 3.51561C11.9312 3.45958 11.8911 3.40866 11.8405 3.36577ZM8.18182 1.57558L10.138 3.23077H8.18182V1.57558ZM10.9091 11.0769H1.09091V0.923077H7.09091V3.69231C7.09091 3.81472 7.14838 3.93211 7.25067 4.01866C7.35296 4.10522 7.4917 4.15385 7.63636 4.15385H10.9091V11.0769ZM8.72727 6.46154C8.72727 6.58395 8.66981 6.70134 8.56751 6.7879C8.46522 6.87445 8.32648 6.92308 8.18182 6.92308H3.81818C3.67352 6.92308 3.53478 6.87445 3.43249 6.7879C3.33019 6.70134 3.27273 6.58395 3.27273 6.46154C3.27273 6.33913 3.33019 6.22174 3.43249 6.13518C3.53478 6.04863 3.67352 6 3.81818 6H8.18182C8.32648 6 8.46522 6.04863 8.56751 6.13518C8.66981 6.22174 8.72727 6.33913 8.72727 6.46154ZM8.72727 8.30769C8.72727 8.4301 8.66981 8.54749 8.56751 8.63405C8.46522 8.7206 8.32648 8.76923 8.18182 8.76923H3.81818C3.67352 8.76923 3.53478 8.7206 3.43249 8.63405C3.33019 8.54749 3.27273 8.4301 3.27273 8.30769C3.27273 8.18528 3.33019 8.06789 3.43249 7.98134C3.53478 7.89478 3.67352 7.84615 3.81818 7.84615H8.18182C8.32648 7.84615 8.46522 7.89478 8.56751 7.98134C8.66981 8.06789 8.72727 8.18528 8.72727 8.30769Z'
        fill='#3699FF'
      />
    </svg>
  );
};
export const SearchDataIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='11'
      height='11'
      viewBox='0 0 11 11'
      fill='none'>
      <path
        d='M9.7507 8.70996L8.1657 7.20996C7.86435 7.59795 7.50316 7.93551 7.0957 8.20996L8.7257 9.75996C8.79424 9.84001 8.87899 9.90461 8.97434 9.94949C9.06969 9.99437 9.17347 10.0185 9.27884 10.0203C9.38421 10.0221 9.48877 10.0016 9.5856 9.95997C9.68243 9.91838 9.76934 9.85673 9.84058 9.77907C9.91183 9.70142 9.96578 9.60953 9.99889 9.50948C10.032 9.40943 10.0435 9.3035 10.0326 9.19867C10.0218 9.09385 9.98882 8.99252 9.93591 8.90138C9.88299 8.81024 9.81135 8.73137 9.7257 8.66996L9.7507 8.70996Z'
        fill='#3699FF'
      />
      <path
        d='M4.57031 0C3.6803 0 2.81027 0.26392 2.07025 0.758387C1.33023 1.25285 0.753451 1.95566 0.412857 2.77792C0.0722623 3.60019 -0.0168527 4.50499 0.156781 5.37791C0.330414 6.25082 0.758998 7.05264 1.38833 7.68198C2.01767 8.31132 2.81949 8.7399 3.69241 8.91353C4.56532 9.08717 5.47012 8.99805 6.29239 8.65746C7.11466 8.31686 7.81746 7.74009 8.31193 7.00007C8.80639 6.26004 9.07031 5.39002 9.07031 4.5C9.07031 3.30653 8.59621 2.16193 7.7523 1.31802C6.90838 0.474106 5.76379 0 4.57031 0ZM4.57031 7.68C3.94257 7.68 3.32892 7.49391 2.8069 7.14526C2.28488 6.79661 1.87793 6.30104 1.63748 5.72117C1.39702 5.14131 1.33386 4.50318 1.45596 3.88742C1.57806 3.27167 1.87996 2.70593 2.32349 2.2617C2.76702 1.81747 3.33228 1.51469 3.94784 1.39162C4.5634 1.26855 5.20163 1.33071 5.78187 1.57025C6.36212 1.80979 6.85833 2.21596 7.2078 2.73743C7.55728 3.2589 7.74433 3.87226 7.74531 4.5C7.74663 4.91755 7.66544 5.33125 7.50641 5.71733C7.34738 6.10342 7.11365 6.45428 6.81862 6.74977C6.5236 7.04526 6.17311 7.27955 5.78727 7.43918C5.40144 7.59882 4.98787 7.68066 4.57031 7.68Z'
        fill='#3699FF'
      />
    </svg>
  );
};

export const SoftwareReleaseSearchIcon = () => {
  return (
    <svg
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M16.1251 14.5649L13.7476 12.3149C13.2955 12.8969 12.7538 13.4033 12.1426 13.8149L14.5876 16.1399C14.6904 16.26 14.8175 16.3569 14.9605 16.4242C15.1036 16.4916 15.2592 16.5278 15.4173 16.5305C15.5753 16.5332 15.7322 16.5023 15.8774 16.44C16.0227 16.3776 16.153 16.2851 16.2599 16.1686C16.3668 16.0521 16.4477 15.9143 16.4974 15.7642C16.547 15.6141 16.5643 15.4552 16.548 15.298C16.5317 15.1408 16.4822 14.9888 16.4029 14.8521C16.3235 14.7154 16.216 14.597 16.0876 14.5049L16.1251 14.5649Z'
        fill='#7E8299'
      />
      <path
        d='M8.35547 1.5C7.02045 1.5 5.7154 1.89588 4.60537 2.63758C3.49534 3.37928 2.63018 4.43349 2.11928 5.66689C1.60839 6.90029 1.47472 8.25749 1.73517 9.56686C1.99562 10.8762 2.6385 12.079 3.5825 13.023C4.52651 13.967 5.72924 14.6099 7.03861 14.8703C8.34798 15.1308 9.70518 14.9971 10.9386 14.4862C12.172 13.9753 13.2262 13.1101 13.9679 12.0001C14.7096 10.8901 15.1055 9.58502 15.1055 8.25C15.1055 6.45979 14.3943 4.7429 13.1284 3.47703C11.8626 2.21116 10.1457 1.5 8.35547 1.5ZM8.35547 13.02C7.41386 13.02 6.49338 12.7409 5.71035 12.2179C4.92732 11.6949 4.3169 10.9516 3.95622 10.0818C3.59554 9.21196 3.50079 8.25477 3.68394 7.33114C3.8671 6.40751 4.31994 5.5589 4.98523 4.89255C5.65053 4.22621 6.49843 3.77203 7.42176 3.58743C8.3451 3.40282 9.30245 3.49606 10.1728 3.85537C11.0432 4.21469 11.7875 4.82394 12.3117 5.60614C12.8359 6.38835 13.1165 7.30839 13.118 8.25C13.1199 8.87633 12.9982 9.49688 12.7596 10.076C12.5211 10.6551 12.1705 11.1814 11.7279 11.6247C11.2854 12.0679 10.7597 12.4193 10.1809 12.6588C9.60216 12.8982 8.9818 13.021 8.35547 13.02Z'
        fill='#7E8299'
      />
    </svg>
  );
};

export const SoftwareReleaseSortIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='17'
      height='17'
      viewBox='0 0 17 17'
      fill='none'>
      <path
        d='M7.8988 6.14371C8.01141 6.26456 8.07271 6.4244 8.0698 6.58956C8.06688 6.75471 7.99998 6.91229 7.88318 7.02909C7.76638 7.14589 7.6088 7.2128 7.44364 7.21571C7.27849 7.21863 7.11865 7.15732 6.9978 7.04471L5.52475 5.57336V12.9633C5.52475 13.1323 5.45758 13.2945 5.33803 13.414C5.21848 13.5336 5.05632 13.6008 4.88725 13.6008C4.71817 13.6008 4.55602 13.5336 4.43647 13.414C4.31691 13.2945 4.24975 13.1323 4.24975 12.9633V5.58101L2.78945 7.04131C2.73109 7.10395 2.66071 7.15418 2.58251 7.18903C2.50431 7.22387 2.41989 7.24261 2.33429 7.24412C2.2487 7.24563 2.16367 7.22988 2.08429 7.19782C2.00491 7.16575 1.9328 7.11803 1.87227 7.0575C1.81173 6.99696 1.76401 6.92485 1.73194 6.84547C1.69988 6.76609 1.68414 6.68107 1.68565 6.59547C1.68716 6.50987 1.70589 6.42546 1.74074 6.34726C1.77558 6.26906 1.82582 6.19868 1.88845 6.14031L4.3917 3.63621C4.45144 3.56235 4.52695 3.50279 4.61269 3.4619C4.69844 3.42101 4.79225 3.39983 4.88725 3.39991C4.97165 3.39943 5.05531 3.41571 5.13338 3.44781C5.21144 3.47991 5.28235 3.52719 5.342 3.58691L7.8988 6.14371Z'
        fill='#3699FF'
      />
      <path
        d='M9.10232 10.8561C9.03968 10.7977 8.98945 10.7274 8.9546 10.6492C8.91976 10.571 8.90102 10.4865 8.89951 10.4009C8.898 10.3153 8.91375 10.2303 8.94581 10.1509C8.97787 10.0716 9.0256 9.99946 9.08613 9.93892C9.14667 9.87838 9.21878 9.83066 9.29816 9.7986C9.37754 9.76653 9.46256 9.75079 9.54816 9.7523C9.63376 9.75381 9.71817 9.77255 9.79637 9.80739C9.87457 9.84223 9.94495 9.89247 10.0033 9.9551L11.4764 11.4273V4.0374C11.4764 3.86833 11.5435 3.70618 11.6631 3.58662C11.7826 3.46707 11.9448 3.3999 12.1139 3.3999C12.2829 3.3999 12.4451 3.46707 12.5646 3.58662C12.6842 3.70618 12.7514 3.86833 12.7514 4.0374V11.4188L14.2117 9.9585C14.27 9.89587 14.3404 9.84563 14.4186 9.81079C14.4968 9.77595 14.5812 9.75721 14.6668 9.7557C14.7524 9.75419 14.8374 9.76994 14.9168 9.802C14.9962 9.83406 15.0683 9.88178 15.1288 9.94232C15.1894 10.0029 15.2371 10.075 15.2692 10.1543C15.3012 10.2337 15.317 10.3187 15.3155 10.4043C15.314 10.4899 15.2952 10.5744 15.2604 10.6526C15.2255 10.7308 15.1753 10.8011 15.1127 10.8595L12.6094 13.3636C12.5497 13.4375 12.4742 13.497 12.3884 13.5379C12.3027 13.5788 12.2089 13.6 12.1139 13.5999C12.0295 13.6004 11.9458 13.5841 11.8677 13.552C11.7897 13.5199 11.7188 13.4726 11.6591 13.4129L9.10232 10.8561Z'
        fill='#3699FF'
      />
    </svg>
  );
};

export const SoftwareReleaseOulinedFavIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M7.52447 1.46352C7.67415 1.00287 8.32585 1.00287 8.47553 1.46353L9.68386 5.18237C9.75079 5.38838 9.94277 5.52786 10.1594 5.52786H14.0696C14.554 5.52786 14.7554 6.14767 14.3635 6.43237L11.2001 8.73075C11.0248 8.85807 10.9515 9.08375 11.0184 9.28976L12.2268 13.0086C12.3764 13.4693 11.8492 13.8523 11.4573 13.5676L8.29389 11.2693C8.11865 11.1419 7.88135 11.1419 7.70611 11.2693L4.54267 13.5676C4.15081 13.8523 3.62357 13.4693 3.77325 13.0086L4.98157 9.28976C5.04851 9.08375 4.97518 8.85807 4.79994 8.73075L1.6365 6.43237C1.24464 6.14767 1.44603 5.52786 1.93039 5.52786H5.84062C6.05723 5.52786 6.24921 5.38838 6.31614 5.18237L7.52447 1.46352Z'
        stroke='#F7C000'
      />
    </svg>
  );
};

export const SoftwareReleaseFavFilledIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'>
      <path
        d='M7.52447 1.46352C7.67415 1.00287 8.32585 1.00287 8.47553 1.46353L9.68386 5.18237C9.75079 5.38838 9.94277 5.52786 10.1594 5.52786H14.0696C14.554 5.52786 14.7554 6.14767 14.3635 6.43237L11.2001 8.73075C11.0248 8.85807 10.9515 9.08375 11.0184 9.28976L12.2268 13.0086C12.3764 13.4693 11.8492 13.8523 11.4573 13.5676L8.29389 11.2693C8.11865 11.1419 7.88135 11.1419 7.70611 11.2693L4.54267 13.5676C4.15081 13.8523 3.62357 13.4693 3.77325 13.0086L4.98157 9.28976C5.04851 9.08375 4.97518 8.85807 4.79994 8.73075L1.6365 6.43237C1.24464 6.14767 1.44603 5.52786 1.93039 5.52786H5.84062C6.05723 5.52786 6.24921 5.38838 6.31614 5.18237L7.52447 1.46352Z'
        fill='#F7C000'
      />
    </svg>
  );
};

export const SoftwareReleaseEditIcon = () => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M14.6824 2.44408C15.2497 3.03145 15.259 3.98075 14.7033 4.5799L8.33845 11.443C8.06799 11.7346 7.69681 11.9032 7.30641 11.9117L4.63102 11.9698L4.68746 9.18414C4.69547 8.78911 4.85115 8.41269 5.12176 8.1341L11.6293 1.43455C12.2053 0.841567 13.136 0.842949 13.7104 1.43763L14.6824 2.44408Z'
        fill='#3699FF'
      />
      <path
        opacity='0.3'
        d='M8.24322 0.338867C8.66089 0.338867 8.99948 0.68945 8.99948 1.12192C8.99948 1.55438 8.66089 1.90496 8.24322 1.90496H3.02504C2.18969 1.90496 1.51252 2.60613 1.51252 3.47106V12.8676C1.51252 13.7326 2.18969 14.4337 3.02504 14.4337H12.1001C12.9355 14.4337 13.6127 13.7326 13.6127 12.8676V8.9524C13.6127 8.51993 13.9512 8.16935 14.3689 8.16935C14.7866 8.16935 15.1252 8.51993 15.1252 8.9524V12.8676C15.1252 14.5975 13.7708 15.9998 12.1001 15.9998H3.02504C1.35435 15.9998 0 14.5975 0 12.8676V3.47106C0 1.7412 1.35435 0.338867 3.02504 0.338867H8.24322Z'
        fill='#3699FF'
      />
    </svg>
  );
};

export const SoftwareReleaseEyeIcon = props => {
  return (
    <svg
      width='24'
      height='16'
      viewBox='0 0 24 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M11.7324 0C6.39902 0 1.84436 3.31733 -0.000976562 8C1.84436 12.6827 6.39902 16 11.7324 16C17.0657 16 21.6204 12.6827 23.4657 8C21.6204 3.31733 17.0657 0 11.7324 0ZM11.7324 13.3333C8.78836 13.3333 6.39902 10.944 6.39902 8C6.39902 5.056 8.78836 2.66667 11.7324 2.66667C14.6764 2.66667 17.0657 5.056 17.0657 8C17.0657 10.944 14.6764 13.3333 11.7324 13.3333Z'
        fill={props?.style?.fill || "#BADAFB"}
      />
      <path
        d='M11.7324 0C6.39902 0 1.84436 3.31733 -0.000976562 8C1.84436 12.6827 6.39902 16 11.7324 16C17.0657 16 21.6204 12.6827 23.4657 8C21.6204 3.31733 17.0657 0 11.7324 0ZM11.7324 13.3333C8.78836 13.3333 6.39902 10.944 6.39902 8C6.39902 5.056 8.78836 2.66667 11.7324 2.66667C14.6764 2.66667 17.0657 5.056 17.0657 8C17.0657 10.944 14.6764 13.3333 11.7324 13.3333Z'
        fill={props?.style?.fill || "#BADAFB"}
      />
      <path
        d='M11.7322 4.7998C9.96156 4.7998 8.53222 6.22914 8.53222 7.99981C8.53222 9.77047 9.96156 11.1998 11.7322 11.1998C13.5029 11.1998 14.9322 9.77047 14.9322 7.99981C14.9322 6.22914 13.5029 4.7998 11.7322 4.7998Z'
        fill={props?.style?.fill2 || "#4EA5FE"}
      />
    </svg>
  );
};

export const SoftwareReleaseDeleteIcon = () => {
  return (
    <svg
      width='13'
      height='16'
      viewBox='0 0 13 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M1.30762 4.21045V14.4999C1.30762 15.3283 1.97919 15.9999 2.80762 15.9999H9.91283C10.7413 15.9999 11.4128 15.3283 11.4128 14.4999V4.21045H1.30762Z'
        fill='#EB5757'
      />
      <path
        opacity='0.3'
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M8.04473 1.26315V1C8.04473 0.447715 7.59701 0 7.04473 0H5.67633C5.12404 0 4.67633 0.447715 4.67633 1V1.26315H0.96582C0.689678 1.26315 0.46582 1.48701 0.46582 1.76315V2.0263C0.46582 2.30245 0.689678 2.5263 0.96582 2.5263H11.7552C12.0314 2.5263 12.2552 2.30245 12.2552 2.0263V1.76315C12.2552 1.48701 12.0314 1.26315 11.7552 1.26315H8.04473Z'
        fill='#EB5757'
      />
    </svg>
  );
};
export const CloseIconCustomPopup = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='36'
      height='36'
      viewBox='0 0 36 36'
      fill='none'>
      <path
        opacity='0.25'
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M3.55349 9.81276C3.98869 6.51756 6.51757 3.98869 9.81276 3.55349C12.0781 3.2543 14.9119 3 18 3C21.0881 3 23.9219 3.2543 26.1872 3.55349C29.4824 3.98869 32.0113 6.51757 32.4465 9.81276C32.7457 12.0781 33 14.9119 33 18C33 21.0881 32.7457 23.9219 32.4465 26.1872C32.0113 29.4824 29.4824 32.0113 26.1872 32.4465C23.9219 32.7457 21.0881 33 18 33C14.9119 33 12.0781 32.7457 9.81276 32.4465C6.51756 32.0113 3.98869 29.4824 3.55349 26.1872C3.2543 23.9219 3 21.0881 3 18C3 14.9119 3.2543 12.0781 3.55349 9.81276Z'
        fill='white'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M12.4393 12.4393C13.0251 11.8536 13.9749 11.8536 14.5607 12.4393L18 15.8787L21.4393 12.4393C22.0251 11.8536 22.9749 11.8536 23.5607 12.4393C24.1464 13.0251 24.1464 13.9749 23.5607 14.5607L20.1213 18L23.5607 21.4393C24.1464 22.0251 24.1464 22.9749 23.5607 23.5607C22.9749 24.1464 22.0251 24.1464 21.4393 23.5607L18 20.1213L14.5607 23.5607C13.9749 24.1464 13.0251 24.1464 12.4393 23.5607C11.8536 22.9749 11.8536 22.0251 12.4393 21.4393L15.8787 18L12.4393 14.5607C11.8536 13.9749 11.8536 13.0251 12.4393 12.4393Z'
        fill='#3699FF'
      />
    </svg>
  );
};

export const BlockIcon = () => {
  return (
    <>
      <svg
        width='17'
        height='16'
        viewBox='0 0 17 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M8.73047 1.25C7.39545 1.25 6.0904 1.64588 4.98037 2.38758C3.87034 3.12928 3.00518 4.18349 2.49428 5.41689C1.98339 6.65029 1.84972 8.00749 2.11017 9.31686C2.37062 10.6262 3.0135 11.829 3.9575 12.773C4.90151 13.717 6.10424 14.3598 7.41361 14.6203C8.72298 14.8808 10.0802 14.7471 11.3136 14.2362C12.547 13.7253 13.6012 12.8601 14.3429 11.7501C15.0846 10.6401 15.4805 9.33502 15.4805 8C15.4785 6.2104 14.7667 4.49466 13.5013 3.22922C12.2358 1.96378 10.5201 1.25199 8.73047 1.25ZM13.9805 8C13.9816 9.13331 13.6141 10.2363 12.9336 11.1425L5.58797 3.79688C6.3682 3.21388 7.29522 2.85942 8.26537 2.77313C9.23552 2.68685 10.2106 2.87214 11.0814 3.30829C11.9523 3.74443 12.6847 4.41424 13.1966 5.24281C13.7086 6.07137 13.98 7.02602 13.9805 8ZM3.48047 8C3.47939 6.86669 3.84682 5.76374 4.52735 4.8575L11.873 12.2031C11.0927 12.7861 10.1657 13.1406 9.19557 13.2269C8.22542 13.3132 7.25039 13.1279 6.37952 12.6917C5.50865 12.2556 4.77628 11.5858 4.2643 10.7572C3.75233 9.92863 3.48093 8.97398 3.48047 8Z'
          fill='white'
        />
      </svg>
    </>
  );
};

export const AcrchiveIcon = () => {
  return (
    <>
      <svg
        width='17'
        height='16'
        viewBox='0 0 17 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'>
        <g clip-path='url(#clip0_7852_39206)'>
          <path
            d='M14.1328 2.75H2.13281C1.80129 2.75 1.48335 2.8817 1.24893 3.11612C1.01451 3.35054 0.882813 3.66848 0.882813 4V5.5C0.882754 5.78816 0.982258 6.0675 1.16449 6.29073C1.34671 6.51395 1.60047 6.66737 1.88281 6.725V12C1.88281 12.3315 2.01451 12.6495 2.24893 12.8839C2.48335 13.1183 2.80129 13.25 3.13281 13.25H13.1328C13.4643 13.25 13.7823 13.1183 14.0167 12.8839C14.2511 12.6495 14.3828 12.3315 14.3828 12V6.725C14.6652 6.66737 14.9189 6.51395 15.1011 6.29073C15.2834 6.0675 15.3829 5.78816 15.3828 5.5V4C15.3828 3.66848 15.2511 3.35054 15.0167 3.11612C14.7823 2.8817 14.4643 2.75 14.1328 2.75ZM2.38281 4.25H13.8828V5.25H2.38281V4.25ZM3.38281 11.75V6.75H12.8828V11.75H3.38281ZM10.3828 8.5C10.3828 8.69891 10.3038 8.88968 10.1631 9.03033C10.0225 9.17098 9.83173 9.25 9.63281 9.25H6.63281C6.4339 9.25 6.24313 9.17098 6.10248 9.03033C5.96183 8.88968 5.88281 8.69891 5.88281 8.5C5.88281 8.30109 5.96183 8.11032 6.10248 7.96967C6.24313 7.82902 6.4339 7.75 6.63281 7.75H9.63281C9.83173 7.75 10.0225 7.82902 10.1631 7.96967C10.3038 8.11032 10.3828 8.30109 10.3828 8.5Z'
            fill='white'
          />
        </g>
        <defs>
          <clipPath id='clip0_7852_39206'>
            <rect
              width='16'
              height='16'
              fill='white'
              transform='translate(0.132812)'
            />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
export const EndUsersSortingIcon = () => {
  return (
    <>
      <svg
        width='17'
        height='17'
        viewBox='0 0 17 17'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M7.90075 6.14225C8.01336 6.2631 8.07467 6.42294 8.07175 6.58809C8.06884 6.75325 8.00193 6.91083 7.88513 7.02763C7.76833 7.14443 7.61075 7.21133 7.4456 7.21425C7.28044 7.21716 7.1206 7.15586 6.99975 7.04325L5.5267 5.5719V12.9618C5.5267 13.1309 5.45954 13.293 5.33998 13.4126C5.22043 13.5321 5.05828 13.5993 4.8892 13.5993C4.72013 13.5993 4.55798 13.5321 4.43842 13.4126C4.31887 13.293 4.2517 13.1309 4.2517 12.9618V5.57955L2.7914 7.03985C2.73304 7.10248 2.66266 7.15272 2.58446 7.18756C2.50626 7.2224 2.42184 7.24114 2.33625 7.24265C2.25065 7.24416 2.16562 7.22842 2.08624 7.19635C2.00686 7.16429 1.93476 7.11657 1.87422 7.05603C1.81368 6.9955 1.76596 6.92339 1.7339 6.84401C1.70183 6.76463 1.68609 6.6796 1.6876 6.594C1.68911 6.50841 1.70784 6.42399 1.74269 6.34579C1.77753 6.26759 1.82777 6.19721 1.8904 6.13885L4.39365 3.63475C4.45339 3.56088 4.5289 3.50133 4.61465 3.46044C4.70039 3.41955 4.79421 3.39837 4.8892 3.39845C4.97361 3.39796 5.05727 3.41424 5.13533 3.44634C5.21339 3.47844 5.28431 3.52573 5.34395 3.58545L7.90075 6.14225Z'
          fill='#3699FF'
        />
        <path
          d='M9.10525 10.8546C9.04261 10.7963 8.99238 10.7259 8.95753 10.6477C8.92269 10.5695 8.90395 10.4851 8.90244 10.3995C8.90093 10.3139 8.91668 10.2289 8.94874 10.1495C8.9808 10.0701 9.02853 9.99799 9.08906 9.93745C9.1496 9.87692 9.22171 9.8292 9.30109 9.79713C9.38047 9.76507 9.46549 9.74932 9.55109 9.75083C9.63669 9.75235 9.7211 9.77108 9.7993 9.80592C9.8775 9.84077 9.94788 9.891 10.0062 9.95364L11.4793 11.4258V4.03594C11.4793 3.86686 11.5465 3.70471 11.666 3.58516C11.7856 3.4656 11.9477 3.39844 12.1168 3.39844C12.2859 3.39844 12.448 3.4656 12.5676 3.58516C12.6871 3.70471 12.7543 3.86686 12.7543 4.03594V11.4173L14.2146 9.95704C14.273 9.8944 14.3433 9.84417 14.4215 9.80932C14.4997 9.77448 14.5842 9.75574 14.6698 9.75423C14.7553 9.75272 14.8404 9.76847 14.9198 9.80053C14.9991 9.8326 15.0712 9.88032 15.1318 9.94085C15.1923 10.0014 15.24 10.0735 15.2721 10.1529C15.3042 10.2323 15.3199 10.3173 15.3184 10.4029C15.3169 10.4885 15.2982 10.5729 15.2633 10.6511C15.2285 10.7293 15.1782 10.7997 15.1156 10.858L12.6123 13.3621C12.5526 13.436 12.4771 13.4956 12.3914 13.5364C12.3056 13.5773 12.2118 13.5985 12.1168 13.5984C12.0324 13.5989 11.9487 13.5826 11.8707 13.5505C11.7926 13.5184 11.7217 13.4712 11.662 13.4114L9.10525 10.8546Z'
          fill='#3699FF'
        />
      </svg>
    </>
  );
};

export const CloseRedIcon = () => {
  return (
    <>
      <svg
        width='26'
        height='25'
        viewBox='0 0 26 25'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'>
        <rect
          x='0.763672'
          width='25.1023'
          height='25'
          rx='4.97368'
          fill='#EB5757'
          fill-opacity='0.25'
        />
        <path
          d='M19.7947 6.01953L6.83447 18.9798'
          stroke='#EB5757'
          stroke-width='3.60006'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
        <path
          d='M19.7947 18.9798L6.83447 6.01953'
          stroke='#EB5757'
          stroke-width='3.60006'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
      </svg>
    </>
  );
};

export const SaveGreenIcon = () => {
  return (
    <>
      <svg
        width='26'
        height='25'
        viewBox='0 0 26 25'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'>
        <rect
          x='0.897461'
          width='25.1023'
          height='25'
          rx='4.97368'
          fill='#219653'
          fill-opacity='0.25'
        />
        <path
          d='M21.1743 7.34961L10.8735 17.6504L5.72314 12.5'
          stroke='#219653'
          stroke-width='3.67885'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
      </svg>
    </>
  );
};

export const ThreeDots = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='4'
      height='20'
      viewBox='0 0 4 20'
      fill='none'>
      <path
        d='M3 18C3 17.4477 2.55228 17 2 17C1.44772 17 1 17.4477 1 18C1 18.5523 1.44772 19 2 19C2.55228 19 3 18.5523 3 18Z'
        fill='#828282'
        stroke='#828282'
        stroke-width='2'
      />
      <path
        d='M3 10C3 9.44772 2.55228 9 2 9C1.44772 9 1 9.44772 1 10C1 10.5523 1.44772 11 2 11C2.55228 11 3 10.5523 3 10Z'
        fill='#828282'
        stroke='#828282'
        stroke-width='2'
      />
      <path
        d='M3 2C3 1.44772 2.55228 1 2 1C1.44772 1 1 1.44772 1 2C1 2.55228 1.44772 3 2 3C2.55228 3 3 2.55228 3 2Z'
        fill='#828282'
        stroke='#828282'
        stroke-width='2'
      />
    </svg>
  );
};
export const DownChevron = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='10'
      height='5'
      viewBox='0 0 10 5'
      fill='none'>
      <path
        d='M1 1L5.11404 4L8.64035 1'
        stroke='white'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
};

export const CSVDownloadIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='17'
      height='17'
      viewBox='0 0 17 17'
      fill='none'>
      <path
        d='M4.9209 6.96582L8.50044 10.5454L12.08 6.96582'
        stroke='#FFFFFF'
        stroke-width='1.5'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M8.5 1V10.5455'
        stroke='#FFFFFF'
        stroke-width='1.5'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M16 10.5454V15.3181C16 15.499 15.9282 15.6724 15.8003 15.8003C15.6724 15.9281 15.499 16 15.3182 16H1.68182C1.50099 16 1.32757 15.9281 1.1997 15.8003C1.07183 15.6724 1 15.499 1 15.3181V10.5454'
        stroke='#FFFFFF'
        stroke-width='1.5'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
};
